var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _linearGradient68, _linearGradient69, _linearGradient70, _linearGradient71, _linearGradient72, _linearGradient73, _linearGradient74, _linearGradient75, _linearGradient76, _linearGradient77, _linearGradient78, _linearGradient79, _linearGradient80, _linearGradient81, _linearGradient82, _linearGradient83, _linearGradient84, _linearGradient85, _linearGradient86, _linearGradient87, _linearGradient88, _linearGradient89, _linearGradient90, _linearGradient91, _linearGradient92, _linearGradient93, _linearGradient94, _linearGradient95, _linearGradient96, _linearGradient97, _linearGradient98, _linearGradient99, _linearGradient100, _linearGradient101, _linearGradient102, _linearGradient103, _linearGradient104, _linearGradient105, _linearGradient106, _linearGradient107, _linearGradient108, _linearGradient109, _linearGradient110, _linearGradient111, _linearGradient112, _linearGradient113, _linearGradient114, _linearGradient115, _linearGradient116, _linearGradient117, _linearGradient118, _linearGradient119, _linearGradient120, _linearGradient121, _linearGradient122, _linearGradient123, _linearGradient124, _linearGradient125, _linearGradient126, _linearGradient127, _linearGradient128, _linearGradient129, _linearGradient130, _linearGradient131, _linearGradient132, _linearGradient133, _linearGradient134, _linearGradient135, _linearGradient136, _linearGradient137, _linearGradient138, _linearGradient139, _linearGradient140, _linearGradient141, _linearGradient142, _linearGradient143, _linearGradient144, _linearGradient145, _linearGradient146, _linearGradient147, _linearGradient148, _linearGradient149, _linearGradient150, _linearGradient151, _linearGradient152, _linearGradient153, _linearGradient154, _linearGradient155, _linearGradient156, _linearGradient157, _linearGradient158, _linearGradient159, _linearGradient160, _linearGradient161, _linearGradient162, _linearGradient163, _linearGradient164, _linearGradient165, _linearGradient166, _linearGradient167, _linearGradient168, _linearGradient169, _linearGradient170, _linearGradient171, _linearGradient172, _linearGradient173, _linearGradient174, _linearGradient175, _linearGradient176, _linearGradient177, _linearGradient178, _linearGradient179, _linearGradient180, _linearGradient181, _linearGradient182, _linearGradient183, _linearGradient184, _linearGradient185, _linearGradient186, _linearGradient187, _linearGradient188, _linearGradient189, _linearGradient190, _linearGradient191;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var Svg404Hero = function Svg404Hero(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    height: 1046.37,
    viewBox: "0 0 1366 1046.37",
    ref: ref,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "91de6824-2be6-47ed-ae58-58b0518a4f1f",
    x1: 837.91,
    y1: 615.18,
    x2: 1426.43,
    y2: 966.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c022f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#120667"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a471a754-fa6d-4e08-b187-69468230d588",
    x1: 838.89,
    y1: 684.86,
    x2: 724.31,
    y2: 510.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c022f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150773"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0bb4c108-2331-474d-9f16-364342bb796c",
    x1: 697.22,
    y1: 686.89,
    x2: 714.54,
    y2: 686.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#150773",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#110555",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#0e0340",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#0d0233",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c022f"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bcad74fc-dab3-4afb-ac31-3a1de856ed91",
    x1: 571.99,
    y1: 740.68,
    x2: 581.65,
    y2: 740.68,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d5d63905-1dcb-4753-a4bb-b902ac4a1d24",
    x1: 866.33,
    y1: 524.57,
    x2: 866.33,
    y2: 611.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c022f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0c0232",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0e033c",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#10044d",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#130665",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150773",
    stopOpacity: 0
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fed41c79-d0fa-4f65-8155-bb475e4860f8",
    x1: 991.06,
    y1: 491.44,
    x2: 1002.02,
    y2: 491.44,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "26f55779-35c9-4451-89a4-466edff96b0d",
    x1: 688.41,
    y1: 676.52,
    x2: 688.41,
    y2: 634.23,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "22e8db03-4db9-4e11-8e34-5e4805b69364",
    x1: 806.71,
    y1: 604.67,
    x2: 818.08,
    y2: 604.67,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc0e7d86-effe-4555-ba87-af954c5775ad",
    x1: 902.55,
    y1: 558.25,
    x2: 902.55,
    y2: 517.6,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e5a812b7-747a-4a15-b782-613f35e9bf1a",
    x1: 879.65,
    y1: 344.56,
    x2: 1102.98,
    y2: 344.56,
    xlinkHref: "#a471a754-fa6d-4e08-b187-69468230d588"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c5316aca-1f86-413e-9684-d7a38281bb12",
    x1: 929.94,
    y1: 381.19,
    x2: 977,
    y2: 381.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#120667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120667",
    stopOpacity: 0.4
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d1763d0d-a94b-4eb9-ad07-1c8922da39bd",
    x1: 987.51,
    y1: 308.99,
    x2: 1008.49,
    y2: 308.99,
    xlinkHref: "#c5316aca-1f86-413e-9684-d7a38281bb12"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "02a41161-c5db-4a2e-a96f-ded8264a0fe0",
    x1: 882.09,
    y1: 161.96,
    x2: 1067.29,
    y2: 161.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c022f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150773",
    stopOpacity: 0
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fa7f89f5-2d83-4c1a-b1f5-742504ebf128",
    x1: 821.5,
    y1: 279.07,
    x2: 903.57,
    y2: 282.32,
    xlinkHref: "#a471a754-fa6d-4e08-b187-69468230d588"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7e2315da-dc92-457b-a350-cff0ebc39201",
    x1: 341.7,
    y1: 511.11,
    x2: 537.92,
    y2: 511.11,
    xlinkHref: "#a471a754-fa6d-4e08-b187-69468230d588"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "08f6bbca-7d9a-4883-a806-883db767b519",
    x1: 482.08,
    y1: 444.54,
    x2: 349.9,
    y2: 413.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c022f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c022f",
    stopOpacity: 0.4
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7d41c949-e8bc-4005-893a-822887dca9f4",
    x1: 415.83,
    y1: 432.46,
    x2: 380.35,
    y2: 454.13,
    xlinkHref: "#08f6bbca-7d9a-4883-a806-883db767b519"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "642a9d23-05db-4562-af3e-18b45ff0b8bd",
    x1: 503.95,
    y1: 545.17,
    x2: 408.33,
    y2: 515.65,
    xlinkHref: "#08f6bbca-7d9a-4883-a806-883db767b519"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "6738b488-2e7a-4788-a7dc-f10d0132a67f",
    x1: 512.25,
    y1: 582.65,
    x2: 417.71,
    y2: 610.55,
    xlinkHref: "#08f6bbca-7d9a-4883-a806-883db767b519"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bacfac46-1577-4067-93e9-e647bf503eef",
    x1: 253.02,
    y1: 463.38,
    x2: 391.85,
    y2: 463.38,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "42b2a707-5f92-46b0-8884-67464b730792",
    x1: 415.28,
    y1: 397.12,
    x2: 491.85,
    y2: 529.74,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "1e73852a-144a-4e32-a698-3fc32bbd48f7",
    x1: 806.91,
    y1: 334.59,
    x2: 933.41,
    y2: 115.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c022f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0c0232",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0e033c",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#10044d",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#130665",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150773",
    stopOpacity: 0
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "44578c5c-39c7-433d-945c-d37d4efd00b5",
    x1: 851,
    y1: 204.85,
    x2: 1066,
    y2: 204.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c022f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0c0232",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0e033d",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#10044f",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#14066a",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150773",
    stopOpacity: 0
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a1edf8c5-240a-4d54-bf27-ba2c645f9bd1",
    x1: 595.11,
    y1: 243.38,
    x2: 702.37,
    y2: 384.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c022f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120667"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "6f00af97-b93c-431c-ae3c-4649aec55e6c",
    x1: 628.3,
    y1: 339.74,
    x2: 459.27,
    y2: 306.42,
    xlinkHref: "#c5316aca-1f86-413e-9684-d7a38281bb12"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc8434fb-1151-438e-bb91-2b1e461715d3",
    x1: 713.04,
    y1: 305.72,
    x2: 683.78,
    y2: 203.87,
    xlinkHref: "#c5316aca-1f86-413e-9684-d7a38281bb12"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "6915f17a-b8a4-4bd7-af81-a470002b95c7",
    x1: 610.19,
    y1: 256.81,
    x2: 536.24,
    y2: 227.28,
    xlinkHref: "#c5316aca-1f86-413e-9684-d7a38281bb12"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "425fc631-fc62-44a1-b4ab-375089e067a5",
    x1: 766.7,
    y1: 197.46,
    x2: 721.47,
    y2: 174.17,
    xlinkHref: "#c5316aca-1f86-413e-9684-d7a38281bb12"
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c393ed56-8480-46ad-a450-1dad3e4ed425",
    x1: 840.79,
    y1: 234.06,
    x2: 855.14,
    y2: 193.97,
    xlinkHref: "#c5316aca-1f86-413e-9684-d7a38281bb12"
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "74e6500c-ebee-48b7-a439-c8b45312b88b",
    x1: 835.57,
    y1: 205.94,
    x2: 795.75,
    y2: 124.13,
    xlinkHref: "#c5316aca-1f86-413e-9684-d7a38281bb12"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "337740e1-9eb7-481d-aa5e-51703283026e",
    x1: 409.92,
    y1: 741.62,
    x2: 586.65,
    y2: 694.09,
    xlinkHref: "#a1edf8c5-240a-4d54-bf27-ba2c645f9bd1"
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a6b86aa9-3d7b-406c-a51e-b547122ec6f6",
    x1: 440.92,
    y1: 687.62,
    x2: 495.93,
    y2: 672.82,
    xlinkHref: "#08f6bbca-7d9a-4883-a806-883db767b519"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b94a7f7e-293b-480e-8dd9-d2d4595d7245",
    x1: 508.35,
    y1: 700.07,
    x2: 568.29,
    y2: 683.95,
    xlinkHref: "#08f6bbca-7d9a-4883-a806-883db767b519"
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d6cc0401-c5a1-440a-bfc1-ce2206550114",
    x1: 502.19,
    y1: 760.14,
    x2: 519.39,
    y2: 755.51,
    xlinkHref: "#08f6bbca-7d9a-4883-a806-883db767b519"
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f758c415-c3a7-4641-bb64-1afd39d4756d",
    x1: 544.57,
    y1: 743.09,
    x2: 584.33,
    y2: 732.4,
    xlinkHref: "#08f6bbca-7d9a-4883-a806-883db767b519"
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb648bb0-4f01-4fd2-b3bc-9ae303641a54",
    x1: 480.43,
    y1: 713.22,
    x2: 493.19,
    y2: 709.79,
    xlinkHref: "#08f6bbca-7d9a-4883-a806-883db767b519"
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f7c5310a-45c4-42d3-a1c6-d6c312296d29",
    x1: 1198.17,
    y1: 658.27,
    x2: 1199.92,
    y2: 646.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#150773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5333ed"
  }))), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c903bb21-4ae3-414b-bae8-1f127cb7ac8e",
    x1: 1192.18,
    y1: 656.27,
    x2: 1194.99,
    y2: 656.23,
    xlinkHref: "#f7c5310a-45c4-42d3-a1c6-d6c312296d29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fa9dc424-ee20-4c98-a842-002561a79e29"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1146.79 649.71 630.28 528.31 798.36 356.8 1153.82 644.09 1146.79 649.71",
    style: {
      fill: "none"
    }
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "26a09dbf-5a8a-4d54-92a9-02879263ae4f",
    x1: 332.39,
    y1: -189.22,
    x2: 1280.64,
    y2: 1191.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#150773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#1c0c80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2e19a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#4b2ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5333ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#5031e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#472bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3920b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#241291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150773"
  }))), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f3a1e253-465c-4dec-92b0-b525d2770c28",
    x1: 920.71,
    y1: 718.19,
    x2: 779.71,
    y2: 504.19,
    xlinkHref: "#f7c5310a-45c4-42d3-a1c6-d6c312296d29"
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc8e1b03-ed38-42ca-90e1-dfcba80a2632",
    x1: 746.6,
    y1: 720.7,
    x2: 767.46,
    y2: 720.7,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "6a4b39b0-9c90-43dc-8ccc-b1446beac791",
    x1: 592.5,
    y1: 786.89,
    x2: 603.93,
    y2: 786.89,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "87680bcd-2b7e-4725-b202-b05698b9a0ff",
    x1: 954.48,
    y1: 520.95,
    x2: 954.48,
    y2: 627.38,
    xlinkHref: "#d5d63905-1dcb-4753-a4bb-b902ac4a1d24"
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e8606e81-680f-4148-a9c7-9ea756d8552e",
    x1: 1108.2,
    y1: 480.18,
    x2: 1121.23,
    y2: 480.18,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a3a94f76-a890-4fcb-a6da-2b14dc3c9be0",
    x1: 735.53,
    y1: 707.92,
    x2: 735.53,
    y2: 655.9,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c695628a-a1f5-4a2f-9eb1-6b22b580a3d4",
    x1: 881.34,
    y1: 619.52,
    x2: 894.88,
    y2: 619.52,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "03d0a56f-ca5d-4500-a0f3-c5e39d6011dd",
    x1: 999.05,
    y1: 562.38,
    x2: 999.05,
    y2: 512.38,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "340048f0-4679-4458-a2cf-8026b711e190",
    x1: 474.41,
    y1: 808.94,
    x2: 637.9,
    y2: 675.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#150773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5333ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4d9"
  }))), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f0620dda-16a3-4016-9b25-82be8e067348",
    x1: 430.98,
    y1: 721.58,
    x2: 498.67,
    y2: 703.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00799e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4d9"
  }))), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "6c54262f-7a9d-4590-a6af-ab5a2ce32616",
    x1: 513.96,
    y1: 736.91,
    x2: 587.73,
    y2: 717.07,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "4e1e173d-e95b-401c-87c9-2ee904c0f958",
    x1: 506.38,
    y1: 810.83,
    x2: 527.55,
    y2: 805.14,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf891f5f-266a-4902-a500-e7ef99cca2d1",
    x1: 558.53,
    y1: 789.85,
    x2: 607.46,
    y2: 776.69,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a1634d85-6101-4c71-8ee8-797c3629f40b",
    x1: 479.6,
    y1: 753.1,
    x2: 495.3,
    y2: 748.88,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e20133e7-baf1-40f4-93ab-072cd8f38acd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 689.05,
    cy: 434.82,
    rx: 132.34,
    ry: 76.43,
    transform: "translate(-125.1 402.78) rotate(-30)",
    style: {
      fill: "none"
    }
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f24c257e-9719-4b29-b3dc-96240a59a034",
    x1: 361,
    y1: -52.53,
    x2: 1131.58,
    y2: 1069.31,
    xlinkHref: "#26a09dbf-5a8a-4d54-92a9-02879263ae4f"
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "8e4d47ed-ef1a-400f-a4b7-cc3a9c765eb4",
    x1: 839.09,
    y1: 684.86,
    x2: 724.51,
    y2: 510.95,
    xlinkHref: "#f7c5310a-45c4-42d3-a1c6-d6c312296d29"
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "978a5a76-832b-496a-b7b7-d338831c22ab",
    x1: 697.42,
    y1: 686.89,
    x2: 714.74,
    y2: 686.89,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "8edf2054-abc1-47d0-86a9-ebc691b566f5",
    x1: 572.2,
    y1: 740.68,
    x2: 581.85,
    y2: 740.68,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "07713f3e-cf19-48a1-9dae-64bdcd12f55a",
    x1: 866.53,
    y1: 524.57,
    x2: 866.53,
    y2: 611.07,
    xlinkHref: "#d5d63905-1dcb-4753-a4bb-b902ac4a1d24"
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ea76da26-6ec9-4b96-869e-128b9e6ad36f",
    x1: 991.27,
    y1: 491.44,
    x2: 1002.23,
    y2: 491.44,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "915a2675-dbf4-4307-a7cc-17ddbe93f98c",
    x1: 688.61,
    y1: 676.52,
    x2: 688.61,
    y2: 634.23,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "8e0353df-4ec0-41da-bd8a-09a7e5caa15d",
    x1: 806.91,
    y1: 604.67,
    x2: 818.28,
    y2: 604.67,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c44023c4-df42-4f96-ae2f-ead8f2b6918c",
    x1: 902.75,
    y1: 558.25,
    x2: 902.75,
    y2: 517.6,
    xlinkHref: "#0bb4c108-2331-474d-9f16-364342bb796c"
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "6fa6d926-9edb-46f2-9645-ceb43ef5c8bd",
    x1: 882.19,
    y1: 161.96,
    x2: 1067.39,
    y2: 161.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2cd4d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2cd4d9",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2cd4d9",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2cd4d9",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2cd4d9",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2cd4d9",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2cd4d9",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#2cd4d9",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4d9",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4d9",
    stopOpacity: 0
  }))), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "877b9c12-edb9-495f-8f0b-bcb7933d0924",
    x1: 863.65,
    y1: 409.9,
    x2: 1067.2,
    y2: 286.8,
    xlinkHref: "#340048f0-4679-4458-a2cf-8026b711e190"
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "8e7734aa-4630-47bc-9d79-0d59c0106aa6",
    x1: 930.14,
    y1: 381.19,
    x2: 977.2,
    y2: 381.19,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "97163096-fd73-4fee-be9f-2eac34aaaf24",
    x1: 987.71,
    y1: 308.99,
    x2: 1008.7,
    y2: 308.99,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a2b96465-73bf-4c6c-bbd5-18e46360bed2",
    x1: 1046.94,
    y1: 375.73,
    x2: 1074.12,
    y2: 375.73,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "1a7e7864-f451-41d4-a4fa-050775f0c193",
    x1: 703.58,
    y1: 332.7,
    x2: 986.38,
    y2: 236,
    xlinkHref: "#340048f0-4679-4458-a2cf-8026b711e190"
  })), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc4b48e4-0a90-44e4-9c49-f5c89e462530",
    x1: 537.74,
    y1: 405.01,
    x2: 882.29,
    y2: 472.19,
    xlinkHref: "#340048f0-4679-4458-a2cf-8026b711e190"
  })), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "52e99a3a-b6d4-4fd4-8507-9427bcf6bacb",
    x1: 496.5,
    y1: 499.94,
    x2: 796.36,
    y2: 543.01,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "9bc70b7d-b240-4087-bb33-42f1fd08ff54",
    x1: 498.8,
    y1: 483.87,
    x2: 798.66,
    y2: 526.94,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "91730566-6812-4942-9e33-07d1682a954d",
    x1: 502.85,
    y1: 455.72,
    x2: 802.71,
    y2: 498.79,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient73 || (_linearGradient73 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fc6b238f-00c6-47d3-a7cf-0cc4f4318b05",
    x1: 490.5,
    y1: 541.65,
    x2: 790.36,
    y2: 584.72,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient74 || (_linearGradient74 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c4a5a206-76b5-4e1d-87aa-53829a95bb62",
    x1: 485.83,
    y1: 574.22,
    x2: 785.69,
    y2: 617.29,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient75 || (_linearGradient75 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "87e5edcf-81b6-4f5f-acb0-8d26b4adfb12",
    x1: 494.55,
    y1: 513.49,
    x2: 794.41,
    y2: 556.56,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient76 || (_linearGradient76 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d225a2c9-0db1-4fe7-ae5e-c3065ee4f861",
    x1: 507.88,
    y1: 420.66,
    x2: 807.74,
    y2: 463.73,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient77 || (_linearGradient77 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "6574283c-27f8-41bf-8ed5-874eb15604ce",
    x1: 520.2,
    y1: 334.92,
    x2: 820.06,
    y2: 377.99,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient78 || (_linearGradient78 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "8126f6e8-cd69-4be3-979e-de0f22600cfe",
    x1: 522.5,
    y1: 318.86,
    x2: 822.37,
    y2: 361.92,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient79 || (_linearGradient79 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "9893b6f0-e9c4-482b-9029-9da706b0e3ca",
    x1: 526.55,
    y1: 290.7,
    x2: 826.41,
    y2: 333.77,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient80 || (_linearGradient80 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "6f68d9e5-ff9b-4806-9dc2-4bc682c1ef6a",
    x1: 514.21,
    y1: 376.63,
    x2: 814.07,
    y2: 419.7,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient81 || (_linearGradient81 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba0e71f5-f089-46a0-91d4-c7574a0b7e6d",
    x1: 509.53,
    y1: 409.2,
    x2: 809.39,
    y2: 452.27,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient82 || (_linearGradient82 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "21cc8364-bd86-4429-8978-552974e9a4a3",
    x1: 518.25,
    y1: 348.47,
    x2: 818.11,
    y2: 391.54,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient83 || (_linearGradient83 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3f818ae9-b675-4790-94d1-8a144008856a",
    x1: 519.07,
    y1: 342.8,
    x2: 818.93,
    y2: 385.87,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient84 || (_linearGradient84 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "2516b905-f280-4a7f-aca4-4e328f62807e",
    x1: 523.15,
    y1: 314.34,
    x2: 823.01,
    y2: 357.41,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient85 || (_linearGradient85 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "921e206e-e3b8-4805-8c82-222d5f4c818e",
    x1: 514.97,
    y1: 371.34,
    x2: 814.83,
    y2: 414.4,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient86 || (_linearGradient86 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "84b11a00-ffad-48b6-a9b9-69622d98ac39",
    x1: 521.24,
    y1: 327.68,
    x2: 821.1,
    y2: 370.75,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient87 || (_linearGradient87 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3d2ede0d-b634-460e-a157-4119f03511e0",
    x1: 516.77,
    y1: 358.81,
    x2: 816.63,
    y2: 401.88,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient88 || (_linearGradient88 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "67817f50-1caa-4c57-9d5d-203d5d9a9ccf",
    x1: 520.06,
    y1: 335.85,
    x2: 819.92,
    y2: 378.92,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient89 || (_linearGradient89 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "89fd671f-690b-4d83-8c2e-851ef93f4982",
    x1: 518.17,
    y1: 349.01,
    x2: 818.03,
    y2: 392.08,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient90 || (_linearGradient90 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff75ce77-7ee5-4c6c-a3fe-7502dff28e8a",
    x1: 523.66,
    y1: 310.81,
    x2: 823.52,
    y2: 353.88,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient91 || (_linearGradient91 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d19616e4-f720-4042-96be-8f3b050deec9",
    x1: 514.32,
    y1: 375.82,
    x2: 814.18,
    y2: 418.89,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient92 || (_linearGradient92 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "8f693be7-2592-41a0-b31a-f64758f4e297",
    x1: 526.88,
    y1: 288.39,
    x2: 826.74,
    y2: 331.46,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient93 || (_linearGradient93 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bcec5291-3d67-4599-b8d7-279c66c75057",
    x1: 530.97,
    y1: 259.94,
    x2: 830.83,
    y2: 303.01,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient94 || (_linearGradient94 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "02b10fc2-c1c0-4144-a638-56b4014108ed",
    x1: 522.78,
    y1: 316.93,
    x2: 822.64,
    y2: 360,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient95 || (_linearGradient95 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "efa6b0c3-6d6c-4591-954f-dd75ea5b42e6",
    x1: 529.05,
    y1: 273.28,
    x2: 828.91,
    y2: 316.35,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient96 || (_linearGradient96 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "9112ba91-1a34-4c30-bc56-0910add3b265",
    x1: 524.58,
    y1: 304.41,
    x2: 824.44,
    y2: 347.48,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient97 || (_linearGradient97 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a4d9f7ba-2af6-4597-b0b8-61c89eda5208",
    x1: 527.88,
    y1: 281.45,
    x2: 827.74,
    y2: 324.52,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient98 || (_linearGradient98 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "06ac836a-ce44-40e6-adc4-f426e053f040",
    x1: 525.99,
    y1: 294.6,
    x2: 825.85,
    y2: 337.67,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient99 || (_linearGradient99 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "de35fc46-6571-41be-9eb9-c94f020557cc",
    x1: 531.47,
    y1: 256.41,
    x2: 831.33,
    y2: 299.48,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient100 || (_linearGradient100 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f05fb7c1-02dc-4691-9299-0ec1912346ad",
    x1: 522.14,
    y1: 321.42,
    x2: 822,
    y2: 364.48,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient101 || (_linearGradient101 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "8d12bae7-6546-4a3d-ace7-0e4f050a7c32",
    x1: 519.62,
    y1: 338.92,
    x2: 819.48,
    y2: 381.99,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient102 || (_linearGradient102 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3d40e1fa-6c0d-4e68-a56b-d021f10e60ae",
    x1: 514.58,
    y1: 374.02,
    x2: 814.44,
    y2: 417.09,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient103 || (_linearGradient103 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "792f2d07-e6af-4376-950c-61466021a52f",
    x1: 527.49,
    y1: 284.15,
    x2: 827.35,
    y2: 327.22,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient104 || (_linearGradient104 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e14dc49b-e00c-4195-885a-226534a8e12d",
    x1: 522.45,
    y1: 319.24,
    x2: 822.31,
    y2: 362.31,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient105 || (_linearGradient105 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f3da74d3-37ac-4abc-9233-e4d97d85806c",
    x1: 512.4,
    y1: 389.22,
    x2: 812.26,
    y2: 432.29,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient106 || (_linearGradient106 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c40d2838-19fc-4f71-8bc2-b5201ce73060",
    x1: 520.24,
    y1: 334.6,
    x2: 820.1,
    y2: 377.67,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient107 || (_linearGradient107 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "562a9a7a-7638-48a7-b03e-9ccfee3fee5e",
    x1: 506.85,
    y1: 427.86,
    x2: 806.71,
    y2: 470.93,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient108 || (_linearGradient108 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "499f0eba-01fc-46c3-8004-86903303bd18",
    x1: 502.71,
    y1: 456.7,
    x2: 802.57,
    y2: 499.77,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient109 || (_linearGradient109 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3d1b376f-2dfa-44a5-9b0a-33c43b1e35d2",
    x1: 506.75,
    y1: 428.54,
    x2: 806.61,
    y2: 471.61,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient110 || (_linearGradient110 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0e1127ee-4742-48d8-abd6-cc1e3f16f172",
    x1: 511.79,
    y1: 393.48,
    x2: 811.65,
    y2: 436.55,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient111 || (_linearGradient111 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "57f72219-d701-4e94-b80d-88fb83a9b25d",
    x1: 522.7,
    y1: 317.52,
    x2: 822.56,
    y2: 360.59,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient112 || (_linearGradient112 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "1ba9cca0-98fb-496b-a2d8-feb09b7d1245",
    x1: 518.55,
    y1: 346.36,
    x2: 818.41,
    y2: 389.43,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient113 || (_linearGradient113 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "562926de-a7bc-4879-9493-336b7f5972ee",
    x1: 522.6,
    y1: 318.21,
    x2: 822.46,
    y2: 361.28,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient114 || (_linearGradient114 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c9d3a150-864d-4ff6-a20e-63a630843aee",
    x1: 527.63,
    y1: 283.15,
    x2: 827.49,
    y2: 326.22,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient115 || (_linearGradient115 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3bccb5bd-59b6-4141-9265-51e33fbbac9b",
    x1: 493.65,
    y1: 519.76,
    x2: 793.51,
    y2: 562.83,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient116 || (_linearGradient116 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "90cf597e-f19a-4d53-8e22-c8fa0c11430d",
    x1: 511.61,
    y1: 394.72,
    x2: 811.47,
    y2: 437.78,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient117 || (_linearGradient117 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "9d5ab12b-28e9-4d1f-95a4-eb42700a8053",
    x1: 504.9,
    y1: 441.39,
    x2: 804.77,
    y2: 484.46,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient118 || (_linearGradient118 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "4ea928cc-762c-4b51-aabb-29f9a69c0312",
    x1: 496.86,
    y1: 497.41,
    x2: 796.72,
    y2: 540.48,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient119 || (_linearGradient119 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b13e018c-7be5-4dda-8605-abdc953a3fd3",
    x1: 500.09,
    y1: 474.91,
    x2: 799.95,
    y2: 517.98,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient120 || (_linearGradient120 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d5689d48-90c8-4d6d-b028-2d1ed887616f",
    x1: 493.44,
    y1: 521.21,
    x2: 793.3,
    y2: 564.27,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient121 || (_linearGradient121 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "af248fab-4522-463f-9c82-02c9c28bcd5b",
    x1: 509.24,
    y1: 411.17,
    x2: 809.11,
    y2: 454.24,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient122 || (_linearGradient122 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d02d15a4-32ba-4600-8325-8a0d4f85f39c",
    x1: 500.8,
    y1: 469.97,
    x2: 800.66,
    y2: 513.04,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient123 || (_linearGradient123 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a10db361-5c52-48b2-9a69-5b25e809a210",
    x1: 509.66,
    y1: 408.29,
    x2: 809.52,
    y2: 451.36,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient124 || (_linearGradient124 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f068d1b2-6591-4fc9-b4ec-3a918dfa5732",
    x1: 512.73,
    y1: 386.88,
    x2: 812.6,
    y2: 429.95,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient125 || (_linearGradient125 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "8785dfdf-6e9e-49f3-91ee-72832470c82e",
    x1: 504.69,
    y1: 442.89,
    x2: 804.55,
    y2: 485.96,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient126 || (_linearGradient126 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e4464efe-4c4a-48b7-bb18-3df5085682b5",
    x1: 507.92,
    y1: 420.4,
    x2: 807.78,
    y2: 463.47,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient127 || (_linearGradient127 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "9348533f-f77e-4823-b556-05b97df64eaa",
    x1: 517.49,
    y1: 353.78,
    x2: 817.35,
    y2: 396.85,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient128 || (_linearGradient128 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "65be7f8f-1174-447f-affd-60f773f5a484",
    x1: 511.58,
    y1: 394.93,
    x2: 811.44,
    y2: 438,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient129 || (_linearGradient129 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "9e4eadc5-ed30-4524-97e2-b68429d5d043",
    x1: 527.54,
    y1: 283.79,
    x2: 827.4,
    y2: 326.86,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient130 || (_linearGradient130 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "22d9647c-0a4a-4890-bc96-b2b956d92fb4",
    x1: 489.31,
    y1: 549.95,
    x2: 789.17,
    y2: 593.02,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient131 || (_linearGradient131 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "2c474ba5-717b-4e81-821f-764c9efde5b2",
    x1: 495.79,
    y1: 504.88,
    x2: 795.65,
    y2: 547.95,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient132 || (_linearGradient132 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "046e315f-f1ad-4712-84ca-1dffab8c8062",
    x1: 495.58,
    y1: 506.33,
    x2: 795.44,
    y2: 549.4,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient133 || (_linearGradient133 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "dd2ef2e8-f972-42bc-9f7c-ec0061e48ebd",
    x1: 499.35,
    y1: 480.06,
    x2: 799.21,
    y2: 523.13,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient134 || (_linearGradient134 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b348af3b-eb3b-42cc-94d0-3b175f13846d",
    x1: 499.14,
    y1: 481.5,
    x2: 799,
    y2: 524.57,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient135 || (_linearGradient135 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e5eee40a-6e0f-482c-877b-2b0781453213",
    x1: 531.58,
    y1: 255.64,
    x2: 831.44,
    y2: 298.71,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient136 || (_linearGradient136 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d2b49d87-33ec-4f52-a9b8-abd62dc0a166",
    x1: 531.37,
    y1: 257.12,
    x2: 831.23,
    y2: 300.19,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient137 || (_linearGradient137 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b32edbc3-d54f-490c-add3-b5ff43c313d5",
    x1: 534.33,
    y1: 236.55,
    x2: 834.19,
    y2: 279.62,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient138 || (_linearGradient138 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7c2c793d-d9d7-4398-b944-affb54f9ddaa",
    x1: 504.91,
    y1: 441.36,
    x2: 804.77,
    y2: 484.43,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient139 || (_linearGradient139 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "11aebe28-fce0-4f05-ba93-548d82f87400",
    x1: 507.34,
    y1: 424.41,
    x2: 807.2,
    y2: 467.48,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient140 || (_linearGradient140 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "22f40412-3f7a-4c52-8eb7-98d2e7811451",
    x1: -1030.95,
    y1: 1298.99,
    x2: -731.09,
    y2: 1342.06,
    gradientTransform: "matrix(-1, 1.15, 0, 1, -70.74, 41.94)",
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient141 || (_linearGradient141 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "6a56fef2-4b34-4cef-8d18-5bb90eb32ea2",
    x1: 804.29,
    y1: 258.65,
    x2: 844.35,
    y2: 258.65,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient142 || (_linearGradient142 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "1eb4ccee-a5e1-4eb2-b24e-c434ae3aa256",
    x1: 804.29,
    y1: 350.4,
    x2: 844.35,
    y2: 350.4,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient143 || (_linearGradient143 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ea41af92-f9e0-4ec5-8e64-24a269349948",
    x1: 804.29,
    y1: 293.23,
    x2: 844.35,
    y2: 293.23,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient144 || (_linearGradient144 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "9208dde3-4170-4f98-acbc-56ceb7b13aa5",
    x1: 804.29,
    y1: 307.62,
    x2: 844.35,
    y2: 307.62,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient145 || (_linearGradient145 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "4983b9f4-6c7a-40ee-a83a-fbe18546d58b",
    x1: 804.29,
    y1: 397.47,
    x2: 844.35,
    y2: 397.47,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient146 || (_linearGradient146 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bda80835-6da6-4866-846d-b4ca49d6a9d2",
    x1: 804.29,
    y1: 427.46,
    x2: 844.35,
    y2: 427.46,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient147 || (_linearGradient147 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "5ad62196-16ea-4a0a-aa14-ecea9f37c403",
    x1: 827.01,
    y1: 434.5,
    x2: 830.41,
    y2: 434.5,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient148 || (_linearGradient148 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "1b351e0e-0bd7-4e44-8e80-659810dc319e",
    x1: 804.29,
    y1: 333.4,
    x2: 844.35,
    y2: 333.4,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient149 || (_linearGradient149 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "5a9c6035-4e14-445f-adc7-41e35bd46a2a",
    x1: 804.29,
    y1: 380.19,
    x2: 844.35,
    y2: 380.19,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient150 || (_linearGradient150 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "060bb362-88a2-4c3c-a5a3-f4a206541b29",
    x1: 500.35,
    y1: 435.71,
    x2: 540.41,
    y2: 435.71,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient151 || (_linearGradient151 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "40b8b5c7-6699-4286-a414-e211874e33de",
    x1: 500.35,
    y1: 527.47,
    x2: 540.41,
    y2: 527.47,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient152 || (_linearGradient152 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d4e49bff-8d0d-4e68-ae80-3008b669a193",
    x1: 500.35,
    y1: 463.49,
    x2: 540.41,
    y2: 463.49,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient153 || (_linearGradient153 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7f68e2e6-d9b2-4521-accf-ba4e7671d2c5",
    x1: 500.35,
    y1: 477.89,
    x2: 540.41,
    y2: 477.89,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient154 || (_linearGradient154 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "2881e08d-def5-4d3b-9132-859b76cf1c77",
    x1: 500.35,
    y1: 577.47,
    x2: 540.41,
    y2: 577.47,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient155 || (_linearGradient155 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "66fd8806-6988-4cc4-9dc9-ad8cae05bf09",
    x1: 500.35,
    y1: 604.52,
    x2: 540.41,
    y2: 604.52,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient156 || (_linearGradient156 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "0e19ee3e-7feb-49b1-9e16-eef518454e8c",
    x1: 523.07,
    y1: 611.03,
    x2: 526.47,
    y2: 611.03,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient157 || (_linearGradient157 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "484813ad-e47a-4a6e-8d0d-1264554ee915",
    x1: 500.35,
    y1: 510.46,
    x2: 540.41,
    y2: 510.46,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient158 || (_linearGradient158 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7419ee29-0ffe-4448-a7cf-1ebb5ad5bf59",
    x1: 500.35,
    y1: 563.25,
    x2: 540.41,
    y2: 563.25,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient159 || (_linearGradient159 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b2e4c2e3-6b1a-4577-aef0-0b6f40451e3e",
    x1: 387.3,
    y1: 511.11,
    x2: 583.52,
    y2: 511.11,
    xlinkHref: "#340048f0-4679-4458-a2cf-8026b711e190"
  })), _linearGradient160 || (_linearGradient160 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "77de7ae9-5292-4866-9f70-0faf5d55fd31",
    x1: 482.18,
    y1: 444.54,
    x2: 350,
    y2: 413.12,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient161 || (_linearGradient161 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d789e14a-c0f5-4108-b016-5f56aca01df9",
    x1: 415.93,
    y1: 432.46,
    x2: 380.45,
    y2: 454.13,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient162 || (_linearGradient162 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "035f6a32-46b3-4448-8c7a-4e47417c1a97",
    x1: 457.56,
    y1: 501.8,
    x2: 479.73,
    y2: 501.8,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient163 || (_linearGradient163 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "af016eb0-8c4f-4450-9ce5-ade4c8f677f2",
    x1: 504.05,
    y1: 545.17,
    x2: 408.43,
    y2: 515.65,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient164 || (_linearGradient164 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ccf776c7-9399-4702-af0a-28f4c82d6d9f",
    x1: 512.35,
    y1: 582.65,
    x2: 417.81,
    y2: 610.55,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient165 || (_linearGradient165 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "6f2516f3-5ac8-4a4c-af70-1000de7ed6cb",
    x1: 370.81,
    y1: 574.31,
    x2: 407.18,
    y2: 574.31,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient166 || (_linearGradient166 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "02822717-174b-4a42-856b-90e0fa21d2e9",
    x1: 368.41,
    y1: 615.96,
    x2: 391.26,
    y2: 615.96,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient167 || (_linearGradient167 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce6a97ef-ba8e-46a7-b60c-1e663a977bf4",
    x1: 351.3,
    y1: 500.59,
    x2: 376.1,
    y2: 500.59,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient168 || (_linearGradient168 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "9eb49f1a-2019-47c9-9156-7ff239c1b409",
    x1: 346.57,
    y1: 422.41,
    x2: 367.02,
    y2: 422.41,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient169 || (_linearGradient169 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "34e5f752-766b-44ef-999a-e682dd6ebfc5",
    x1: 352.11,
    y1: 571.54,
    x2: 372.88,
    y2: 571.54,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient170 || (_linearGradient170 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "38edea67-d63f-4e12-9d11-eb2fe98c6f53",
    x1: 253.11,
    y1: 463.38,
    x2: 391.95,
    y2: 463.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2cd4d9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2cd4d9",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2cd4d9",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2cd4d9",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2cd4d9",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2cd4d9",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2cd4d9",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2cd4d9",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4d9"
  }))), _linearGradient171 || (_linearGradient171 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d7df31fb-3557-4902-84b8-35cc3c51647d",
    x1: 268.25,
    y1: 452.91,
    x2: 597.76,
    y2: 452.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2cd4d9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2cd4d9",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2cd4d9",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2cd4d9",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2cd4d9",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#2cd4d9",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#30c3db",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#3b94e1",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#4d4aea",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5333ed"
  }))), _linearGradient172 || (_linearGradient172 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "855fece1-fad3-4037-ab91-7c93acc3c7ea",
    x1: 667.25,
    y1: 298.82,
    x2: 792.26,
    y2: 298.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5333ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4d9"
  }))), _linearGradient173 || (_linearGradient173 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "8b6ca878-7adc-466a-8741-bde500a7009e",
    x1: 851.1,
    y1: 204.85,
    x2: 1066.1,
    y2: 204.85,
    xlinkHref: "#6fa6d926-9edb-46f2-9645-ceb43ef5c8bd"
  })), _linearGradient174 || (_linearGradient174 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "9a06ae5e-f249-454d-bfaf-00cc8a77a4a3",
    x1: 807.01,
    y1: 334.59,
    x2: 933.51,
    y2: 115.48,
    xlinkHref: "#6fa6d926-9edb-46f2-9645-ceb43ef5c8bd"
  })), _linearGradient175 || (_linearGradient175 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a89c03ea-4b58-48e1-bf03-cc13c3bf3682",
    x1: 476.61,
    y1: 218.1,
    x2: 856.92,
    y2: 356.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#150773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5333ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4f44eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4470e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#33b7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4d9"
  }))), _linearGradient176 || (_linearGradient176 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "06158f64-4c2b-4048-ba8c-e0a5c55a4d44",
    x1: 628.4,
    y1: 339.74,
    x2: 459.37,
    y2: 306.42,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient177 || (_linearGradient177 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "7eb4d5bf-5f69-4f86-b118-5ea4c09e1e55",
    x1: 713.14,
    y1: 305.72,
    x2: 683.88,
    y2: 203.87,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient178 || (_linearGradient178 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "16b62e6b-7bef-4951-a433-0bc80b581041",
    x1: 610.29,
    y1: 256.81,
    x2: 536.34,
    y2: 227.28,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient179 || (_linearGradient179 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ea463362-6315-4f0b-8b22-fcd35f2b4b7d",
    x1: 766.8,
    y1: 197.46,
    x2: 721.56,
    y2: 174.17,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient180 || (_linearGradient180 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "5e4d8a4d-91d6-414d-a182-3b60a202ffcd",
    x1: 840.89,
    y1: 234.06,
    x2: 855.24,
    y2: 193.97,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient181 || (_linearGradient181 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "be55035d-f33a-4916-b5f9-303719efc641",
    x1: 835.67,
    y1: 205.94,
    x2: 795.85,
    y2: 124.13,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient182 || (_linearGradient182 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c2c99808-cdd3-419e-bb97-4e46c835e35f",
    x1: 371.83,
    y1: 366.6,
    x2: 413.82,
    y2: 366.6,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient183 || (_linearGradient183 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "22218155-b59b-4ffc-9112-25ee55d2725a",
    x1: 404.13,
    y1: 301.17,
    x2: 437.65,
    y2: 301.17,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient184 || (_linearGradient184 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae6183a1-afd2-4967-8e26-22201f83dd57",
    x1: 610.09,
    y1: 192.49,
    x2: 637.29,
    y2: 192.49,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient185 || (_linearGradient185 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "da352464-0b08-468b-ae62-8d8dc2de83eb",
    x1: 468.65,
    y1: 389.2,
    x2: 500.35,
    y2: 389.2,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient186 || (_linearGradient186 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "2e1dc1ee-7b4c-4a02-a714-5bc41feabdcd",
    x1: 476.42,
    y1: 758.6,
    x2: 609.27,
    y2: 650.12,
    xlinkHref: "#340048f0-4679-4458-a2cf-8026b711e190"
  })), _linearGradient187 || (_linearGradient187 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "4dc256a3-9952-448a-9ac7-4b6581fe7bb0",
    x1: 441.12,
    y1: 687.62,
    x2: 496.13,
    y2: 672.82,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient188 || (_linearGradient188 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aae4e39d-e885-45f2-880d-2b65f5c3b46f",
    x1: 508.55,
    y1: 700.07,
    x2: 568.5,
    y2: 683.95,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient189 || (_linearGradient189 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "726bd4ac-4e51-4f68-9884-1446985ee0c6",
    x1: 502.39,
    y1: 760.14,
    x2: 519.59,
    y2: 755.51,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient190 || (_linearGradient190 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "afa62112-4ab1-446c-b0ca-7e19a44cef1f",
    x1: 544.77,
    y1: 743.09,
    x2: 584.54,
    y2: 732.4,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  })), _linearGradient191 || (_linearGradient191 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b87bda48-e2e7-49cb-8685-d115afec8197",
    x1: 480.64,
    y1: 713.22,
    x2: 493.39,
    y2: 709.79,
    xlinkHref: "#f0620dda-16a3-4016-9b25-82be8e067348"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "404-hero") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "e425dda7-6f0e-481c-a44d-ec65de978fab",
    "data-name": "figures and interactions"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1367.59,
    height: 1046.37,
    style: {
      fill: "url(#91de6824-2be6-47ed-ae58-58b0518a4f1f)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1009.3,432.28s.51,24.84-31.08,29.51c-8.68,1.28-31.22.42-40.63,5.69-24.45,13.69-20.42,41.44-34.13,50.17-13.87,8.83-23.36-2.86-38.83,7-22.14,14.06-26.71,37.84-50.76,52.58-37.79,23.16-78.12,15.44-97.11,27.34-10.5,6.58,3,13.18-7.31,19.59-24.84,15.49-62.89,23.48-84.92,37-29.91,18.33-26.49,35.05-64.69,52.43-33.47,15.22-69.89,18.61-69.89,18.61s-39.93,8.19,33,41.72c0,0,59.55,22.57,159.74-12.28s72.64-54.62,72.64-54.62-3.84-8.24,19-12,54-13.72,63.65-25.92,14.21-26.93,30.05-31.91,70.58,5.33,113.65-19.58,16.84-54.68,16.25-61.95,1.8-15.17,17.15-17.51,24.82-5.11,23.34-13.47,1.62-15.06,5.75-18.21,57-12.14,39.89-51.12-39.18-43.54-39.18-43.54S1012.54,396.26,1009.3,432.28Z",
    style: {
      fill: "url(#a471a754-fa6d-4e08-b187-69468230d588)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 713.54,
    y1: 619.79,
    x2: 698.21,
    y2: 753.99,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#0bb4c108-2331-474d-9f16-364342bb796c)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580.65,
    y1: 701.3,
    x2: 572.99,
    y2: 780.07,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#bcad74fc-dab3-4afb-ac31-3a1de856ed91)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 864.63,
    y1: 524.61,
    x2: 868.03,
    y2: 611.03,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#d5d63905-1dcb-4753-a4bb-b902ac4a1d24)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 755.35,
    y1: 704.09,
    x2: 750.69,
    y2: 728.09,
    style: {
      fill: "none",
      stroke: "#0c022f",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 997.93,
    y1: 555.59,
    x2: 988.66,
    y2: 613.03,
    style: {
      fill: "none",
      stroke: "#0c022f",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1001.03,
    y1: 452.01,
    x2: 992.06,
    y2: 530.87,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#fed41c79-d0fa-4f65-8155-bb475e4860f8)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 689.38,
    y1: 634.27,
    x2: 687.44,
    y2: 676.48,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#26f55779-35c9-4451-89a4-466edff96b0d)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 817.09,
    y1: 575.07,
    x2: 807.7,
    y2: 634.27,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#22e8db03-4db9-4e11-8e34-5e4805b69364)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 903.46,
    y1: 517.64,
    x2: 901.63,
    y2: 558.21,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#bc0e7d86-effe-4555-ba87-af954c5775ad)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M886.73,419.82s37.84,13.45,66,3.78,24.81-13.38,38.95-12.88,17.39,6.69,38.52,5.49,26.14-8.72,33.19-4.36,11.79,6.16,21.53.2c5.83-3.56,8.37-11.71,11.36-11.75,9.75-.14,6.81-8.87,3.81-13.85-23-38.15-30.88-18.27-29.8-23.84s9.78-7.62,4.35-22.85-10.85-12.49-18.44-22.8-.54-7.21-7.58-16.88-6.82-21-26-15.21c-15.47,4.69-36.26,1.19-45.2-8.53-10.91-11.87-39.32-14.65-46.36-7.6s-6.54,11.67-10.88,9.88-4.45-6.75-15.37-11.71-18.33-6-23.69-3.79S886.73,419.82,886.73,419.82Z",
    style: {
      fill: "url(#e5a812b7-747a-4a15-b782-613f35e9bf1a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.94,362.17s4.88,3.73,13.81,3.46,9.75,3.47,10.56,5.66.14,8.16,3.32,8.15,3.18,2.09,4,4.7,3.25.15,7,3.55a15,15,0,0,1,4.88,9.77c.27,2.29,1.9,5.27,3,6.89s-2.1-6.57-.88-7.18,1.68.68,1.11-2.84-1-2.37-2.67-4.13-.61-2-2.3-5.08-1.83-3.45-5-4-3.93-1.22-4.06-2.37,1.29-.68-.95-3-3.39-1.08-4.13-3.18,1-.27-1.22-4.2-4-4.54-5.55-4.81-3.59-1.42-5.76-1.08a5.64,5.64,0,0,1-5-2.23c-.47-.95.07-3.25-3.79-2.1A14.94,14.94,0,0,0,929.94,362.17Z",
    style: {
      fill: "url(#c5316aca-1f86-413e-9684-d7a38281bb12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.51,283.07s14.69,7.46,11.84,15.58-7.52,8.94-2.44,14.22,8.94,6.91,7.92,9.75-4.67-.2-2.84,5.28,3.17,5.89,3,6.91-2-6.7,0-7.52,2.06.61,2.87-3.25.81-4.06,0-7.11-2.64-3.45-3.86-5.28-3-3.52-1.42-5.42,2.44-2.91,1-5.15-2.44-1.63-1.83-3.25,2.44-2.93,2.44-4.61.31-.69-1.63-3.72-3.46-3.24-3.46-3.24Z",
    style: {
      fill: "url(#d1763d0d-a94b-4eb9-ad07-1c8922da39bd)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.55,363.66a35.61,35.61,0,0,0-9.24,3.27c-3.86,2.22-2.64,7.91-6.09,7.91s-4.88-2.23-5.89,0a32.22,32.22,0,0,0-2.23,7.52c0,1-.81,5.28,0,6.5s1.63-3.66,1.63-3.66,1-8.9,3.25-8.61.41-.49,5.08,0,6.3-.33,7.31-2.56-2.44-3.45,2.44-4.06,7.24-5.05,7.11-6.3l-.13-1.25Z",
    style: {
      fill: "#0c022f",
      opacity: 0.61
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M883.7,166s96.35,61.22,181.41-29.25",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 6,
      stroke: "url(#02a41161-c5db-4a2e-a96f-ded8264a0fe0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.14,133.86c-7.08-1.77-9.88-9.53-18-10s-13.09,9-20.27,11.91c-6.58,2.64-48.46,32.67-55.43,37.68l.05,0-11.3,7.49A14.65,14.65,0,0,0,736.38,191a51.56,51.56,0,0,1-2.39,8.88l-1.12,3.11a13.7,13.7,0,0,0,5.36,16.27c.09.06,5,1.88,10.94,4.11a13.58,13.58,0,0,0-11.82,9.46c-.08.28-3.18,35.6-3.18,35.6a25.29,25.29,0,0,0,7.28,24.22l5.9,5.55-4.08,2.49a14.65,14.65,0,0,0-6.82,10.07A51.56,51.56,0,0,1,734,319.6l-1.12,3.11c-2.17,6,.24,12.46,5.36,16.27,4.76,3.54,8.63,13.54,7.7,21a35.23,35.23,0,0,0,1.77,17.19c-6.28,6.07-10.27,16.45-6.45,30.27,2,7.29-.38,17.74-4.57,21.93s125.16,5.13,151.87,5.31a17.1,17.1,0,0,0,8.9-2.43h0a14.65,14.65,0,0,0,6.91-10,51.56,51.56,0,0,1,2.47-8.86l1.15-3.1c2.22-6-.13-12.46-5.23-16.32-4.73-3.58-8.52-13.61-7.52-21.1a35.23,35.23,0,0,0-1.62-17.2c6.33-6,10.41-16.36,6.71-30.21-1.95-7.31.53-17.74,4.76-21.89,4.56-4.48,6.06-11.19,3.09-16.85l-1.54-2.93a51.57,51.57,0,0,1-3.58-8.47,14.65,14.65,0,0,0-8.13-9l-4.87-2.12a27.3,27.3,0,0,0,5.39-10.31,93.37,93.37,0,0,1,4.09-11.77l1.74-4.17c3.36-8.05,2.22-16.58-3.1-20.13-.09-.06-4.5-1.5-10.13-3.32L887.94,183a7.9,7.9,0,0,1,1-.71s10.84-15-1.12-31a40.51,40.51,0,0,0-6.33-6.62C860,126.5,855.21,135.63,848.14,133.86Z",
    style: {
      fill: "url(#fa7f89f5-2d83-4c1a-b1f5-742504ebf128)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "771.14 235.9 811.21 212.93 844.25 232.1 844.25 435.32 804.19 458.29 771.14 439.11 771.14 235.9",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "804.19 255.07 844.25 232.1 844.25 435.32 804.19 458.29 804.19 255.07",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "536.41 405.75 798.36 254.93 798.36 454.87 536.41 605.7 536.41 405.75",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 547.9,
    y: 428.24,
    width: 1.63,
    height: 158.71,
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 548.85,
    y: 428.24,
    width: 1.63,
    height: 158.71,
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M553.2,490.68c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07A4.44,4.44,0,0,0,545.8,495c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,553.2,490.68Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.35,491.59a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,554.35,491.59Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M553.2,461.94c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31h0l.08-.06a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,553.2,461.94Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.35,462.85a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,554.35,462.85Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M553.2,549.65c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31h0l.08-.06a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,553.2,549.65Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.35,550.56a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,554.35,550.56Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M553.2,582.89c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,553.2,582.89Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.35,583.8a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,554.35,583.8Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M553.2,520.91c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,553.2,520.91Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.35,521.82a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,554.35,521.82Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M552.83,424.4a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17c1.06-1.84,3.15-3.84,3.49-5.61l-1.25-.68a17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a10.27,10.27,0,0,0-.22-3.83l-1.25-.68c-.18.4-.34.81-.49,1.21l-1-.37a15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38l1.25.68c1.14.05,2-.86,3.4-1.66a14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05c1.63-.94,4.62-2,5.9-3.7l-1.25-.68A6.45,6.45,0,0,0,552.83,424.4Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.08,425.08a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17,17.64,17.64,0,0,0,2.24-6.29,17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a6.45,6.45,0,0,0-1.47-4.51,18.51,18.51,0,0,0-.73,1.92,4.74,4.74,0,0,0-.73-1.08,15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38,6.45,6.45,0,0,0,4.65-1,14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05,15.47,15.47,0,0,0,4.65-4.38A6.45,6.45,0,0,0,554.08,425.08Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 786.98,
    y: 294.15,
    width: 1.63,
    height: 158.71,
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 787.92,
    y: 294.15,
    width: 1.63,
    height: 158.71,
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M792.27,356.6c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,792.27,356.6Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.42,357.5a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,3.77,3.77,0,0,0,1.69,2.79,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,793.42,357.5Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M792.27,327.86c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91A13.3,13.3,0,0,0,790.7,327a14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31h0l.08-.06a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,792.27,327.86Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.42,328.77a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07A3.77,3.77,0,0,0,786,333a3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a4.54,4.54,0,0,0,.44-.21,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,793.42,328.77Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M792.27,415.56c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,792.27,415.56Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.42,416.47a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a4.54,4.54,0,0,0,.44-.21,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,793.42,416.47Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M792.27,448.81c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,792.27,448.81Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.42,449.71a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8A1.86,1.86,0,1,0,786,454a3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,793.42,449.71Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M792.27,386.83c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,792.27,386.83Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.42,387.74a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8A1.86,1.86,0,1,0,786,392a3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,793.42,387.74Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 665.91,
    y1: 422,
    x2: 665.91,
    y2: 388.9,
    style: {
      fill: "none",
      stroke: "#0c022f",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M596,473.56l-13.49,7.79a2.94,2.94,0,0,1-4.41-2.55l4.53-57.38c0-5-7-6.43-8.94-5.3l-14.28,8.25a2.94,2.94,0,0,0-1.47,2.55v86.81c0,5.84,3.27,7.21,8.64,5.91l11.52-12.46,15-8.64a2.94,2.94,0,0,1,4.41,2.55v33.16c0,2.26,3.14,7.09,8.47,6l10.23-11.67a2.94,2.94,0,0,0,1.47-2.55V461.07l4.53-62.48c0-6.25-7-6.42-8.94-5.29l-14.28,8.25a2.94,2.94,0,0,0-1.47,2.55V471A2.94,2.94,0,0,1,596,473.56Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.26,313.56v66.93a2.94,2.94,0,0,1-1.47,2.55l-13.49,7.79a2.94,2.94,0,0,1-4.41-2.55l4.56-56.94a6.11,6.11,0,0,0-9-5.74l-14.28,8.25a2.94,2.94,0,0,0-1.47,2.55V423.2c0,4,4,8.38,8.7,5.88l11.47-12.43,15-8.64a2.94,2.94,0,0,1,4.41,2.55v33.16c0,4.3,4,8.23,9,5.74L772.95,438a2.94,2.94,0,0,0,1.47-2.55V370.55L779,308.1c0-5.52-6.21-7-9-5.33L755.73,311A2.94,2.94,0,0,0,754.26,313.56Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.15,367.93l-18.69,10.79a2.94,2.94,0,0,0-1.47,2.55V511.43a6.62,6.62,0,0,0,8.48,6l11.69-12.52,19.37-11.18,18.69-10.79a2.94,2.94,0,0,0,1.47-2.55v-112l4.56-15c0-5.92-5.18-7.66-9-5.74l-15.75,9.1Zm17.9,103.33L661.56,479a2.94,2.94,0,0,1-4.41-2.55V392.91a2.94,2.94,0,0,1,1.47-2.55l13.49-7.79a2.94,2.94,0,0,1,4.41,2.55v83.59A2.94,2.94,0,0,1,675.05,471.26Z",
    style: {
      fill: "#0c022f"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 667.58,
    y1: 502,
    x2: 667.58,
    y2: 530.87,
    style: {
      fill: "none",
      stroke: "#0c022f",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M600.55,476.76l-13.49,7.79a2.94,2.94,0,0,1-4.41-2.55V421.87a2.94,2.94,0,0,0-4.41-2.55L564,427.57a2.94,2.94,0,0,0-1.47,2.55v86.81a2.94,2.94,0,0,0,4.41,2.55l15.75-9.1,15-8.64a2.94,2.94,0,0,1,4.41,2.55v33.16a2.94,2.94,0,0,0,4.41,2.55l14.28-8.25a2.94,2.94,0,0,0,1.47-2.55V399a2.94,2.94,0,0,0-4.41-2.55l-14.28,8.25a2.94,2.94,0,0,0-1.47,2.55v66.93A2.94,2.94,0,0,1,600.55,476.76Z",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.82,316.76v66.93a2.94,2.94,0,0,1-1.47,2.55L743.86,394a2.94,2.94,0,0,1-4.41-2.55V331.34a2.94,2.94,0,0,0-4.41-2.55L720.76,337a2.94,2.94,0,0,0-1.47,2.55V426.4a2.94,2.94,0,0,0,4.41,2.55l15.75-9.1,15-8.64a2.94,2.94,0,0,1,4.41,2.55v33.16a2.94,2.94,0,0,0,4.41,2.55l14.28-8.25a2.94,2.94,0,0,0,1.47-2.55V308.51a2.94,2.94,0,0,0-4.41-2.55l-14.28,8.25A2.94,2.94,0,0,0,758.82,316.76Z",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.72,371.12,643,381.92a2.94,2.94,0,0,0-1.47,2.55V514.62a2.94,2.94,0,0,0,4.41,2.55l15.75-9.1,19.37-11.18,18.69-10.79a2.94,2.94,0,0,0,1.47-2.55V353.39a2.94,2.94,0,0,0-4.41-2.55l-15.75,9.1Zm17.9,103.33-13.49,7.79a2.94,2.94,0,0,1-4.41-2.55V396.11a2.94,2.94,0,0,1,1.47-2.55l13.49-7.79a2.94,2.94,0,0,1,4.41,2.55v83.59A2.94,2.94,0,0,1,679.62,474.45Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "665.91 331.05 665.91 362.77 671.4 365.53 671.4 389.47",
    style: {
      fill: "none",
      stroke: "#0c022f",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "665.91 420.63 665.91 476.49 671.4 479.26 671.4 503.2",
    style: {
      fill: "none",
      stroke: "#0c022f",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M647.54,345.78c0,12.67-7.43,28.86-18.4,35.19-7,4-13.38,4.93-18.53-.74-2.13-2.34-2.8-6.91-2.8-11.52,0-12.67,8.89-28.07,19.87-34.41S647.54,333.11,647.54,345.78Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.18,335.7,628,320.81a12,12,0,0,1,1.61,1.58l3.09,6.44L624.44,336A3,3,0,0,1,622.18,335.7Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.25,386.94l3.14,4.46a13.88,13.88,0,0,0,3.1,3.18h0l5-13-1.81-1.34-9.16,5.29A1,1,0,0,0,623.25,386.94Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.68,339.25l6.5.58a8,8,0,0,1,4,1.54h0l-8.74,10.87-1.81-1.34Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.68,363.56l-10,12.62a8.49,8.49,0,0,0,2.54.31l6.93-.56,1.81-10.31A4.2,4.2,0,0,0,605.68,363.56Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.77,352.65l-2.24-8.35,8.68-2.33a2.28,2.28,0,0,1,1.95.37l.92.68L610,355.39l-.64-.48A4.14,4.14,0,0,1,607.77,352.65Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "639.23 371.94 641.03 373.27 648.97 369.33 648.17 360.92 646.36 359.58 639.23 371.94",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.94,329.69l11-9.54a3.19,3.19,0,0,1,.59,2.23l-4.42,11.42-5.75-2.44A3.06,3.06,0,0,1,638.94,329.69Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608,383.4l-2.46,12a5,5,0,0,0,2.27-.78l9.28-6.53-1.81-1.34L608.79,383A.53.53,0,0,0,608,383.4Z",
    style: {
      fill: "#0c022f"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M649.23,347.19c0,12.67-8.89,28.07-19.87,34.41s-19.87,1.2-19.87-11.47,8.89-28.07,19.87-34.41S649.23,334.52,649.23,347.19Z",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.32,336.06l5.2-13.6,4.46,7.17a.68.68,0,0,1-.22,1Z",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "624.32 387.47 629.36 394.64 634.41 381.64 624.32 387.47",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "650.37 340.66 659.11 341.44 650.37 352.31 650.37 340.66",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "606.79 365.7 598.05 376.57 606.79 377.35 606.79 365.7",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "609.84 355.45 607.22 345.71 616.97 343.1 609.84 355.45",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "640.91 373.34 650.66 370.73 648.05 360.98 640.91 373.34",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "640.2 331.44 650.37 322.46 647.76 335.22 640.2 331.44",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "609.84 384.08 607.69 394.72 616.97 388.19 609.84 384.08",
    style: {
      fill: "#140a99"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M724.75,301.34c0,12.67-7.43,28.86-18.4,35.19-7,4-13.38,4.93-18.53-.74-2.13-2.34-2.8-6.91-2.8-11.52,0-12.67,8.89-28.07,19.87-34.41S724.75,288.68,724.75,301.34Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.39,291.26l5.84-14.88a12,12,0,0,1,1.61,1.58l3.09,6.44-8.28,7.16A3,3,0,0,1,699.39,291.26Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.46,342.5l3.14,4.46a13.88,13.88,0,0,0,3.1,3.18h0l5-13-1.81-1.34-9.16,5.29A1,1,0,0,0,700.46,342.5Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.89,294.82l6.5.58a8,8,0,0,1,4,1.54h0L727.7,307.8l-1.81-1.34Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.89,319.13l-10,12.62a8.49,8.49,0,0,0,2.54.31l6.93-.56,1.81-10.31A4.2,4.2,0,0,0,682.89,319.13Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685,308.21l-2.24-8.35,8.68-2.33a2.28,2.28,0,0,1,1.95.37l.92.68-7.13,12.36-.64-.48A4.14,4.14,0,0,1,685,308.21Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "716.44 327.5 718.25 328.84 726.18 324.89 725.38 316.48 723.57 315.14 716.44 327.5",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.15,285.26l11-9.54a3.19,3.19,0,0,1,.59,2.23l-4.42,11.42-5.75-2.44A3.06,3.06,0,0,1,716.15,285.26Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.21,339l-2.46,12a5,5,0,0,0,2.27-.78l9.28-6.53-1.81-1.34L686,338.61A.53.53,0,0,0,685.21,339Z",
    style: {
      fill: "#0c022f"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M726.44,302.75c0,12.67-8.89,28.07-19.87,34.41s-19.87,1.2-19.87-11.47,8.89-28.07,19.87-34.41S726.44,290.08,726.44,302.75Z",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.53,291.62l5.2-13.6,4.46,7.17a.68.68,0,0,1-.22,1Z",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "701.53 343.03 706.57 350.21 711.62 337.2 701.53 343.03",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "727.58 296.22 736.32 297 727.58 307.87 727.58 296.22",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "684 321.26 675.26 332.13 684 332.91 684 321.26",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "687.04 311.02 684.43 301.27 694.18 298.66 687.04 311.02",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "718.12 328.9 727.87 326.29 725.26 316.55 718.12 328.9",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "717.41 287 727.58 278.02 724.97 290.78 717.41 287",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "687.04 339.64 684.9 350.29 694.18 343.76 687.04 339.64",
    style: {
      fill: "#140a99"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M660.57,362.08s-10.22-1.9-11.34-2.76.08-3.13.08-3.13l.58-.95a1.22,1.22,0,0,1,1.75-.06l9.78,6.34A.93.93,0,0,1,660.57,362.08Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.29,355.7l-.76,2.13a.82.82,0,0,0,.54,1.07l10.32,3a.92.92,0,0,0,1.15-.65h0a.92.92,0,0,0-.46-1l-9.44-5A1,1,0,0,0,650.29,355.7Z",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.82,379.55s-1-1.16-1.83-.59c-.19.13-8.88,9.37-11.07,11.66a2,2,0,0,0-.57,1.64c.08.55.42,1,1.46.86l12.74-12.39Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606,379.73c.27.45.58,1,.86,1.48a1.77,1.77,0,0,1-.46,2.28L594,393a.72.72,0,0,1-1-.16h0a.72.72,0,0,1,.06-.91l11.47-12.34A.89.89,0,0,1,606,379.73Z",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.26,317.33s-10.22-1.9-11.34-2.76.08-3.13.08-3.13l.58-.95a1.22,1.22,0,0,1,1.75-.06l9.78,6.34A.93.93,0,0,1,738.26,317.33Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728,311l-.76,2.13a.82.82,0,0,0,.54,1.07l10.32,3a.92.92,0,0,0,1.15-.65h0a.92.92,0,0,0-.46-1l-9.44-5A1,1,0,0,0,728,311Z",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.23,334.62s-.51-.94-1.2-.59c-.21.11-9.24,9.55-11.42,11.84a2,2,0,0,0-.57,1.64c.08.55.42,1,1.46.86L684.24,336Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.66,335c.27.45.58,1,.86,1.48a1.77,1.77,0,0,1-.46,2.28l-12.32,9.5a.72.72,0,0,1-1-.16h0a.72.72,0,0,1,.06-.91l11.47-12.34A.89.89,0,0,1,683.66,335Z",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.47,396.82l-.44-.44a1.57,1.57,0,0,0-1.79-.3c-1,.47-2.39,1.18-3.42,1.71a1.9,1.9,0,0,0-1,2l1.7,9.8L628.8,415s.33,1.56,2.4,1.13Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.91,398.69c1-.59,2.68-1.47,3.73-2a.67.67,0,0,1,1,.61L632.13,415a1.09,1.09,0,0,1-.75,1h0a1.09,1.09,0,0,1-1.4-.83l-2.87-14.82A1.61,1.61,0,0,1,627.91,398.69Z",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.89,352.34l-.44-.44a1.57,1.57,0,0,0-1.79-.3c-1,.47-2.39,1.18-3.42,1.71a1.9,1.9,0,0,0-1,2l1.7,9.8,1.29,5.35s.33,1.56,2.4,1.13Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.33,354.21c1-.59,2.68-1.47,3.73-2a.67.67,0,0,1,1,.61l-.49,17.79a1.09,1.09,0,0,1-.75,1h0a1.09,1.09,0,0,1-1.4-.83l-2.87-14.82A1.61,1.61,0,0,1,706.33,354.21Z",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 587.98,
    y: 406.26,
    width: 1.63,
    height: 67.04,
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.93,
    y: 406.26,
    width: 1.63,
    height: 67.04,
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M593.28,468.7c.72-1.24,2.56-2.63,2.84-3.84L595,464a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,593.28,468.7Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.43,469.61a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,594.43,469.61Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M593.28,440c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,593.28,440Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.43,440.87a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,594.43,440.87Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M592.91,402.42a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17c1.06-1.84,3.15-3.84,3.49-5.61l-1.25-.68a17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a10.27,10.27,0,0,0-.22-3.83l-1.25-.68c-.18.4-.34.81-.49,1.21l-1-.37a15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38L580,413c1.14.05,2-.86,3.4-1.66a14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05c1.63-.94,4.62-2,5.9-3.7l-1.25-.68A6.45,6.45,0,0,0,592.91,402.42Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.16,403.11a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17,17.64,17.64,0,0,0,2.24-6.29,17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a6.45,6.45,0,0,0-1.47-4.51,18.51,18.51,0,0,0-.73,1.92,4.74,4.74,0,0,0-.73-1.08,15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8A15.47,15.47,0,0,0,580,413a6.45,6.45,0,0,0,4.65-1,14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05,15.47,15.47,0,0,0,4.65-4.38A6.45,6.45,0,0,0,594.16,403.11Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 744.52,
    y: 316.13,
    width: 1.63,
    height: 67.04,
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.47,
    y: 316.13,
    width: 1.63,
    height: 67.04,
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M749.82,378.58c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31h0l.08-.06a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,749.82,378.58Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751,379.48a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,751,379.48Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M749.82,349.84c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,749.82,349.84Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751,350.75a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,3.77,3.77,0,0,0,1.69,2.79,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,751,350.75Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M749.45,312.3a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17c1.06-1.84,3.15-3.84,3.49-5.61l-1.25-.68a17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a10.27,10.27,0,0,0-.22-3.83l-1.25-.68c-.18.4-.34.81-.49,1.21l-1-.37a15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38l1.25.68c1.14.05,2-.86,3.4-1.66a14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05c1.63-.94,4.62-2,5.9-3.7l-1.25-.68A6.45,6.45,0,0,0,749.45,312.3Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.7,313a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0A18.87,18.87,0,0,0,750,312a17.64,17.64,0,0,0,2.24-6.29,17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a6.45,6.45,0,0,0-1.47-4.51,18.51,18.51,0,0,0-.73,1.92,4.74,4.74,0,0,0-.73-1.08,15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38,6.45,6.45,0,0,0,4.65-1,14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05,15.47,15.47,0,0,0,4.65-4.38A6.45,6.45,0,0,0,750.7,313Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M744.92,429h0L736,434.2l.84-3.3a2.15,2.15,0,0,0-3.14-1.69h0a5.09,5.09,0,0,0-2.3,4v.09l-1.15.67a2.68,2.68,0,0,0-1.21,2.1v1.5l.84.5c.47-.27.1-1.42.2-2l1.32-.6v1.39L722.48,442h0l-5.78,7.2.84.5c2.89-.35,6.16-2.63,9.22-5.55h0a10.11,10.11,0,0,0,4.68-.73c.06.8.16,1.47.3,2.85l0,.21-.61.35a1.72,1.72,0,0,0-.74,1.07l-.69.4-1.24,0h-.06l0,0,0,0,0,0,0,0-.53.67a.34.34,0,0,0-.07.37,1.17,1.17,0,0,0,.18.11l-.27.48a.34.34,0,0,0-.07.37,5.58,5.58,0,0,0,.49.4.22.22,0,0,0,.07.29c.09.08.82.49.82.49l.75-1.41.63-1s.52-.39.87-.6l1-.56.1.43a2.67,2.67,0,0,0,.05.31L731,455.46l.84.5,4.53-3.61-1.29-5.18c0-.12,0-.25.05-.37l.1-.54,1-.57a1.72,1.72,0,0,0,.74-1.07l.71.21,1-.44.3.38c.06.08.19,0,.29-.09h0c.1-.13.62-.22.56-.3l-.51-.3a4.08,4.08,0,0,0,1.31-.51l-.64-.35c.06-.15.47-.18.53-.32s-.93-.61-.93-.61l-.53-.06H739l0,0,0,0,0,0,0,0-1.24,1.4-.69.4c-.09-.32-.38-.42-.74-.22l-.64.37,0-.26c.14-1.53.24-2.32.3-3.18a27.28,27.28,0,0,0,4.71-4.7,21.64,21.64,0,0,0,10.91-6.07l-.84-.5Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.76,429.55h0l-8.92,5.15V431c0-1.47-1-2.06-2.3-1.33h0a5.09,5.09,0,0,0-2.3,4v.09l-1.15.67a2.68,2.68,0,0,0-1.21,2.1v1.5l.09,0a2.21,2.21,0,0,0,1-1.43l1.32-.6v1.39l-8.91,5.14h0l-5.78,7.2c3.09-.09,6.7-1.84,10.07-5.05h0a10.14,10.14,0,0,0,4.68-.74c.06.8.16,1.47.3,2.85l0,.21-.61.35a1.72,1.72,0,0,0-.74,1.07l-.69.4-1.24,0h-.06l0,0,0,0,0,0,0,0-.53.67a.34.34,0,0,0-.07.37c.06.08.19,0,.29-.08l.44-.55h.5l-.7.48a.41.41,0,0,0-.1.1l-.52.66a.34.34,0,0,0-.07.37c.06.08.19,0,.29-.08l.49-.63.57-.39-.46.59h0l0,.07,0,0h0l-.33.8c-.06.15,0,.28.07.29s.23-.09.29-.24l.3-.73,1.13-1.44.63-.36c.09.32.38.42.74.22l1-.56.1.43a2.67,2.67,0,0,0,.05.31L731.85,456l5.38-3.1-1.29-5.18c0-.12,0-.25.05-.37l.1-.54,1-.57a1.72,1.72,0,0,0,.74-1.07l.63-.36,1.13.14.3.38c.06.08.19,0,.29-.09h0a.34.34,0,0,0,.07-.37l-.33-.41h0l0,0h0l-.46-.06.57-.26.49.06c.1,0,.23-.1.29-.25h0c.06-.15,0-.28-.07-.29l-.52-.06a.15.15,0,0,0-.1,0l-.7.33.5-.57.44,0c.1,0,.23-.1.29-.25s0-.28-.07-.29l-.53-.06h-.06l0,0,0,0,0,0,0,0-1.24,1.4-.69.4c-.09-.32-.38-.42-.74-.22l-.64.37,0-.26c.14-1.53.24-2.32.3-3.18a27.28,27.28,0,0,0,4.71-4.7c3.37-.67,7-3.09,10.07-6.57Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M588,518.9h0l-8.92,5.15.84-3.3a2.15,2.15,0,0,0-3.14-1.69h0a5.09,5.09,0,0,0-2.3,4v.09l-1.15.67a2.68,2.68,0,0,0-1.21,2.1v1.5l.84.5c.47-.27.1-1.42.2-2l1.32-.6v1.39l-8.91,5.14h0l-5.78,7.2.84.5c2.89-.35,6.16-2.63,9.22-5.55h0a10.11,10.11,0,0,0,4.68-.73c.06.8.16,1.47.3,2.85l0,.21-.61.35a1.72,1.72,0,0,0-.74,1.07l-.69.4-1.24,0h-.06l0,0,0,0,0,0,0,0-.53.67a.34.34,0,0,0-.07.37,1.17,1.17,0,0,0,.18.11l-.27.48a.34.34,0,0,0-.07.37,5.58,5.58,0,0,0,.49.4.22.22,0,0,0,.07.29c.09.08.82.49.82.49l.75-1.41.63-1s.52-.39.87-.6l1-.56.1.43a2.67,2.67,0,0,0,.05.31l-1.29,6.67.84.5,4.53-3.61L578.21,537c0-.12,0-.25.05-.37l.1-.54,1-.57a1.72,1.72,0,0,0,.74-1.07l.71.21,1-.44.3.38c.06.08.19,0,.29-.09h0c.1-.13.62-.22.56-.3l-.51-.3a4.08,4.08,0,0,0,1.31-.51l-.64-.35c.06-.15.47-.18.53-.32s-.93-.61-.93-.61l-.53-.06h-.06l0,0,0,0,0,0,0,0-1.24,1.4-.69.4c-.09-.32-.38-.42-.74-.22l-.64.37,0-.26c.14-1.53.24-2.32.3-3.18a27.28,27.28,0,0,0,4.71-4.7,21.64,21.64,0,0,0,10.91-6.07l-.84-.5Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.89,519.4h0L580,524.55v-3.66c0-1.47-1-2.06-2.3-1.33h0a5.09,5.09,0,0,0-2.3,4v.09l-1.15.67a2.68,2.68,0,0,0-1.21,2.1v1.5l.09,0a2.21,2.21,0,0,0,1-1.43l1.32-.6v1.39l-8.91,5.14h0l-5.78,7.2c3.09-.09,6.7-1.84,10.07-5.05h0a10.11,10.11,0,0,0,4.68-.73c.06.8.16,1.47.3,2.85l0,.21-.61.35a1.72,1.72,0,0,0-.74,1.07l-.69.4-1.24,0h-.06l0,0,0,0,0,0,0,0-.53.67a.34.34,0,0,0-.07.37c.06.08.19,0,.29-.08l.44-.55h.5l-.7.48a.41.41,0,0,0-.1.1l-.52.66a.34.34,0,0,0-.07.37c.06.08.19,0,.29-.08l.49-.63.57-.39-.46.59h0l0,.08,0,0h0l-.33.8c-.06.15,0,.28.07.29s.23-.09.29-.24l.3-.73,1.13-1.44.63-.36c.09.32.38.42.74.22l1-.56.1.43a2.67,2.67,0,0,0,.05.31L575,545.81l5.38-3.1-1.29-5.18c0-.12,0-.25.05-.37l.1-.54,1-.57a1.72,1.72,0,0,0,.74-1.07l.63-.36,1.13.14.3.38c.06.08.19,0,.29-.09h0a.34.34,0,0,0,.07-.37l-.33-.41h0l0,0h0l-.46-.06.57-.26.49.06c.1,0,.23-.1.29-.25h0c.06-.15,0-.28-.07-.29l-.52-.06a.15.15,0,0,0-.1,0l-.7.33.5-.57.44,0c.1,0,.23-.1.29-.25s0-.28-.07-.29l-.53-.06H583l0,0,0,0,0,0,0,0-1.24,1.4-.69.4c-.09-.32-.38-.42-.74-.22l-.64.37,0-.26c.14-1.53.24-2.32.3-3.18a27.28,27.28,0,0,0,4.71-4.7c3.37-.67,7-3.09,10.07-6.57Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M576.11,389.56h0l-8.92,5.15.84-3.3a2.15,2.15,0,0,0-3.14-1.69h0a5.09,5.09,0,0,0-2.3,4v.09l-1.15.67a2.68,2.68,0,0,0-1.21,2.1v1.5l.84.5c.47-.27.1-1.42.2-2l1.32-.6v1.39l-8.91,5.14h0l-5.78,7.2.84.5c2.89-.35,6.16-2.63,9.22-5.55h0a10.11,10.11,0,0,0,4.68-.73c.06.8.16,1.47.3,2.85l0,.21-.61.35a1.72,1.72,0,0,0-.74,1.07l-.69.4-1.24,0h-.06l0,0,0,0,0,0,0,0-.53.67a.34.34,0,0,0-.07.37,1.17,1.17,0,0,0,.18.11l-.27.48a.34.34,0,0,0-.07.37,5.58,5.58,0,0,0,.49.4.22.22,0,0,0,.07.29c.09.08.82.49.82.49l.75-1.41.63-1s.52-.39.87-.6l1-.56.1.43a2.67,2.67,0,0,0,.05.31L562.2,416l.84.5,4.53-3.61-1.29-5.18c0-.12,0-.25.05-.37l.1-.54,1-.57a1.72,1.72,0,0,0,.74-1.07l.71.21,1-.44.3.38c.06.08.19,0,.29-.09h0c.1-.13.62-.22.56-.3l-.51-.3a4.08,4.08,0,0,0,1.31-.51l-.64-.35c.06-.15.47-.18.53-.32s-.93-.61-.93-.61l-.53-.06h-.06l0,0,0,0,0,0,0,0-1.24,1.4-.69.4c-.09-.32-.38-.42-.74-.22l-.64.37,0-.26c.14-1.53.24-2.32.3-3.18a27.28,27.28,0,0,0,4.71-4.7,21.64,21.64,0,0,0,10.91-6.07l-.84-.5Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577,390.06h0L568,395.22v-3.66c0-1.47-1-2.06-2.3-1.33h0a5.09,5.09,0,0,0-2.3,4v.09l-1.15.67a2.68,2.68,0,0,0-1.21,2.1v1.5l.09,0a2.21,2.21,0,0,0,1-1.43l1.32-.6v1.39L554.52,403h0l-5.78,7.2c3.09-.09,6.7-1.84,10.07-5.05h0a10.11,10.11,0,0,0,4.68-.73c.06.8.16,1.47.3,2.85l0,.21-.61.35a1.72,1.72,0,0,0-.74,1.07l-.69.4-1.24,0h-.06l0,0,0,0,0,0,0,0-.53.67a.34.34,0,0,0-.07.37c.06.08.19,0,.29-.08l.44-.55h.5l-.7.48a.41.41,0,0,0-.1.1l-.52.66a.34.34,0,0,0-.07.37c.06.08.19,0,.29-.08l.49-.63.57-.39-.46.59h0l0,.08,0,0h0l-.33.8c-.06.15,0,.28.07.29s.23-.09.29-.24l.3-.73,1.13-1.44.63-.36c.09.32.38.42.74.22l1-.56.1.43a2.67,2.67,0,0,0,.05.31L563,416.47l5.38-3.1-1.29-5.18c0-.12,0-.25.05-.37l.1-.54,1-.57a1.72,1.72,0,0,0,.74-1.07l.63-.36,1.13.14.3.38c.06.08.19,0,.29-.09h0a.34.34,0,0,0,.07-.37l-.33-.41h0l0,0h0l-.46-.06.57-.26.49.06c.1,0,.23-.1.29-.25h0c.06-.15,0-.28-.07-.29l-.52-.06a.15.15,0,0,0-.1,0l-.7.33.5-.57.44,0c.1,0,.23-.1.29-.25s0-.28-.07-.29l-.53-.06h-.06l0,0,0,0,0,0,0,0-1.24,1.4-.69.4c-.09-.32-.38-.42-.74-.22l-.64.37,0-.26c.14-1.53.24-2.32.3-3.18a27.28,27.28,0,0,0,4.71-4.7c3.37-.67,7-3.09,10.07-6.57Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M629.93,486.46l-.61.19a2.45,2.45,0,0,1-3-2.51V435.85a4.57,4.57,0,0,1,2.27-3.95h0a2.55,2.55,0,0,1,3.61,1.17l.14.32Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.89,486l-.3.17a2,2,0,0,1-3-1.71V436.45a4.55,4.55,0,0,1,2.26-3.93h0a1.64,1.64,0,0,1,2.47,1.42v49.59A2.91,2.91,0,0,1,630.89,486Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M629.93,532.8l-.61.19a2.45,2.45,0,0,1-3-2.51V503.84a4.57,4.57,0,0,1,2.27-3.95h0a2.55,2.55,0,0,1,3.61,1.17l.14.32Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.89,532.38l-.3.17a2,2,0,0,1-3-1.71V504.45a4.55,4.55,0,0,1,2.26-3.93h0a1.64,1.64,0,0,1,2.47,1.42v27.93A2.91,2.91,0,0,1,630.89,532.38Z",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M631,491.5a4.67,4.67,0,0,1-2.11,3.66,1.49,1.49,0,0,0-.66.93s-1-.87-1.06-1a1.68,1.68,0,0,1-.39-1.19,4.67,4.67,0,0,1,2.11-3.66,1.39,1.39,0,0,1,1.65,0l.93.85S631,491.21,631,491.5Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.95,492.34a4.67,4.67,0,0,1-2.11,3.66c-1.17.67-2.11.13-2.11-1.22a4.67,4.67,0,0,1,2.11-3.66C631,490.44,631.95,491,631.95,492.34Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M631,538.75a4.67,4.67,0,0,1-2.11,3.66,1.49,1.49,0,0,0-.66.93s-1-.87-1.06-1a1.68,1.68,0,0,1-.39-1.19,4.67,4.67,0,0,1,2.11-3.66,1.39,1.39,0,0,1,1.65,0l.93.85S631,538.46,631,538.75Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.95,539.59a4.67,4.67,0,0,1-2.11,3.66c-1.17.67-2.11.13-2.11-1.22a4.67,4.67,0,0,1,2.11-3.66C631,537.69,631.95,538.24,631.95,539.59Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M710.7,494.46a4.67,4.67,0,0,1-2.11,3.66,1.49,1.49,0,0,0-.66.93s-1-.87-1.06-1a1.68,1.68,0,0,1-.39-1.19,4.67,4.67,0,0,1,2.11-3.66,1.39,1.39,0,0,1,1.65,0l.93.85S710.7,494.17,710.7,494.46Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.61,495.29A4.67,4.67,0,0,1,709.5,499c-1.17.67-2.11.13-2.11-1.22a4.67,4.67,0,0,1,2.11-3.66C710.67,493.4,711.61,493.94,711.61,495.29Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M777.64,454.37a4.67,4.67,0,0,1-2.11,3.66,1.49,1.49,0,0,0-.66.93s-1-.87-1.06-1a1.68,1.68,0,0,1-.39-1.19,4.67,4.67,0,0,1,2.11-3.66,1.39,1.39,0,0,1,1.65,0l.93.85S777.64,454.08,777.64,454.37Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.55,455.21a4.67,4.67,0,0,1-2.11,3.66c-1.17.67-2.11.13-2.11-1.22a4.67,4.67,0,0,1,2.11-3.66C777.61,453.32,778.55,453.86,778.55,455.21Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M631,423.51a4.67,4.67,0,0,1-2.11,3.66,1.49,1.49,0,0,0-.66.93s-1-.87-1.06-1a1.68,1.68,0,0,1-.39-1.19,4.67,4.67,0,0,1,2.11-3.66,1.39,1.39,0,0,1,1.65,0l.93.85S631,423.22,631,423.51Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.95,424.35a4.67,4.67,0,0,1-2.11,3.66c-1.17.67-2.11.13-2.11-1.22a4.67,4.67,0,0,1,2.11-3.66C631,422.45,631.95,423,631.95,424.35Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M709,442.18l-.61.19a2.45,2.45,0,0,1-3-2.51V391.56a4.57,4.57,0,0,1,2.27-3.95h0a2.55,2.55,0,0,1,3.61,1.17l.14.32Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710,441.76l-.3.17a2,2,0,0,1-3-1.71V392.17a4.55,4.55,0,0,1,2.26-3.93h0a1.64,1.64,0,0,1,2.47,1.42v49.59A2.91,2.91,0,0,1,710,441.76Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M709,488.52l-.61.19a2.45,2.45,0,0,1-3-2.51V459.56a4.57,4.57,0,0,1,2.27-3.95h0a2.55,2.55,0,0,1,3.61,1.17l.14.32Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710,488.1l-.3.17a2,2,0,0,1-3-1.71V460.17a4.55,4.55,0,0,1,2.26-3.93h0a1.64,1.64,0,0,1,2.47,1.42v27.93A2.91,2.91,0,0,1,710,488.1Z",
    style: {
      fill: "#140a99"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M710.11,447.22a4.67,4.67,0,0,1-2.11,3.66,1.49,1.49,0,0,0-.66.93s-1-.87-1.06-1a1.68,1.68,0,0,1-.39-1.19A4.67,4.67,0,0,1,708,446a1.39,1.39,0,0,1,1.65,0l.93.85S710.11,446.93,710.11,447.22Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711,448.06a4.67,4.67,0,0,1-2.11,3.66c-1.17.67-2.11.13-2.11-1.22a4.67,4.67,0,0,1,2.11-3.66C710.07,446.16,711,446.71,711,448.06Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M710.11,379.22a4.67,4.67,0,0,1-2.11,3.66,1.49,1.49,0,0,0-.66.93s-1-.87-1.06-1a1.68,1.68,0,0,1-.39-1.19A4.67,4.67,0,0,1,708,378a1.39,1.39,0,0,1,1.65,0l.93.85S710.11,378.94,710.11,379.22Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711,380.06a4.67,4.67,0,0,1-2.11,3.66c-1.17.67-2.11.13-2.11-1.22a4.67,4.67,0,0,1,2.11-3.66C710.07,378.17,711,378.71,711,380.06Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M593.16,405.64c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,593.16,405.64Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.31,406.55A13.3,13.3,0,0,0,596,401.8a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31h0l.08-.06a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,594.31,406.55Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M750,314.73c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,750,314.73Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.13,315.64a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,3.77,3.77,0,0,0,1.69,2.79,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31h0l.08-.06a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,751.13,315.64Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M607.38,546.17l-3.54,2c0-.11,0-.22,0-.33a13,13,0,0,0-.51-2.23s-1-.81-1.14-.93a4.22,4.22,0,0,0-4.3-.13,13.66,13.66,0,0,0-6.08,6.3L583,555.94c-2.17,1.26-4.22,1.25-5.52,0a6.8,6.8,0,0,0,.18-1.5,2.85,2.85,0,0,0-1.34-2.76,8.07,8.07,0,0,1,.75-1.53s-.85-.65-1-.8a.18.18,0,0,0-.16-.06c-.42.05-1.24,1.56-1.66,2.38-.05,0,0-.49,0-.49l-.71-.61c-.23-.19-.43-.34-.62-.21-.45.3-.85,2-1,2.93a10,10,0,0,0-2.31,4.06l-2.77,1.6a1.66,1.66,0,0,0-.75,1.3,1.47,1.47,0,0,0,.36,1.05,12,12,0,0,0,1.07.88l1.54-1.5.78-.46c.58-.34,1,0,.88.83a2.11,2.11,0,0,1-.68,1.14c-.32.27-.62.32-.83.21a1.05,1.05,0,0,0-1,.16l-.13.07a1.44,1.44,0,0,0-.65,1.13.47.47,0,0,0,.18.41c.12.08,1,.79,1,.79s3.86-2.8,4.45-3.06v5.4a1.62,1.62,0,0,0,.48,1.29l.58.48.36,1.42-8,4.61a7,7,0,0,0-3.18,5.52.58.58,0,0,0,.3.53c.14.09.94.79.94.79l12.52-8.37a3.71,3.71,0,0,0,1.68-2.91V568l-.33-1.33,12.32-7.11a4,4,0,0,0,.73,1.1l-5,2.89a6.75,6.75,0,0,0-3.05,5.29h0a.65.65,0,0,0,.24.57c.16.11.92.75.92.75l8.64-5.94a1.62,1.62,0,0,0-.12.58.66.66,0,0,0,.22.55l.95.77,13.12-8.55c2.45-1.41,4.28-5.35,4.28-7.92a10.17,10.17,0,0,0-.39-2.61s-1.09-.89-1.25-1A2.49,2.49,0,0,0,607.38,546.17Zm0,9.38-4.61,2.66a31.5,31.5,0,0,0,1.77-3.1s-.73-.6-.94-.76a.92.92,0,0,0-1-.08,14.17,14.17,0,0,0,1.18-4l3.59-2.07c1.3-.75,2.52.76,2.52,2.47A6.54,6.54,0,0,1,607.38,555.55Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.38,547l-3.54,2c0-.11,0-.22,0-.33-.42-3.27-2.9-4.64-5.95-3.29a13.66,13.66,0,0,0-6.08,6.3L584,556.75c-2.17,1.26-4.22,1.25-5.52,0a6.8,6.8,0,0,0,.18-1.5,2.85,2.85,0,0,0-1.34-2.76c0-.62.09-2.45-.39-2.39s-1.24,1.56-1.66,2.38l-.15.06c-.25-.63-.73-1.66-1.17-1.37s-.85,2-1,2.93a10,10,0,0,0-2.31,4.06l-2.77,1.6a1.66,1.66,0,0,0-.75,1.3c0,1.18.84,1.66,1.86,1.07l1.1-.64.78-.46c.58-.34,1,0,.88.83A2.11,2.11,0,0,1,571,563c-.32.27-.62.32-.83.21a1.05,1.05,0,0,0-1,.16l-.13.07a1.44,1.44,0,0,0-.65,1.13c0,.42.29.58.65.38l3.32-1.92a3.25,3.25,0,0,0,1.61-.32v5.4c0,.88.4,1.42,1,1.52l.42,1.67-8,4.61a7,7,0,0,0-3.18,5.52c0,.49.35.68.77.44l13-7.5a3.71,3.71,0,0,0,1.68-2.91v-2.62l-.33-1.33,12.32-7.11a4,4,0,0,0,.73,1.1l-5,2.89a6.75,6.75,0,0,0-3.05,5.29h0c0,.57.4.81.9.52l8.91-5.14a1.62,1.62,0,0,0-.12.58c0,.56.39.79.88.51l13.41-7.74c2.45-1.41,4.28-5.35,4.28-7.92C612.66,547.71,610.79,545.58,608.38,547Zm0,9.38L603.77,559a5.45,5.45,0,0,0,1.11-3.05c0-.85-.56-1.21-1.27-.89a14.17,14.17,0,0,0,1.18-4l3.59-2.07c1.3-.75,2.52.76,2.52,2.47A6.54,6.54,0,0,1,608.38,556.36Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M761.28,457l-3.54,2c0-.11,0-.22,0-.33a13,13,0,0,0-.51-2.23s-1-.81-1.14-.93a4.22,4.22,0,0,0-4.3-.13,13.66,13.66,0,0,0-6.08,6.3l-8.76,5.05c-2.17,1.26-4.22,1.25-5.52,0a6.8,6.8,0,0,0,.18-1.5,2.85,2.85,0,0,0-1.34-2.76A8.07,8.07,0,0,1,731,461s-.85-.65-1-.8a.18.18,0,0,0-.16-.06c-.42.05-1.24,1.56-1.66,2.38-.05,0,0-.49,0-.49l-.71-.61c-.23-.19-.43-.34-.62-.21-.45.3-.85,2-1,2.93a10,10,0,0,0-2.31,4.06l-2.77,1.6a1.66,1.66,0,0,0-.75,1.3,1.47,1.47,0,0,0,.36,1.05,12,12,0,0,0,1.07.88l1.54-1.5.78-.46c.58-.34,1,0,.88.83a2.11,2.11,0,0,1-.68,1.14c-.32.27-.62.32-.83.21a1.05,1.05,0,0,0-1,.16l-.13.07a1.44,1.44,0,0,0-.65,1.13.47.47,0,0,0,.18.41c.12.08,1,.79,1,.79s3.86-2.8,4.45-3.06v5.4a1.62,1.62,0,0,0,.48,1.29l.58.48.36,1.42-8,4.61a7,7,0,0,0-3.18,5.52.58.58,0,0,0,.3.53c.14.09.94.79.94.79L731,484.38a3.71,3.71,0,0,0,1.68-2.91v-2.62l-.33-1.33,12.32-7.11a4,4,0,0,0,.73,1.1l-5,2.89a6.75,6.75,0,0,0-3.05,5.29h0a.65.65,0,0,0,.24.57c.16.11.92.75.92.75l8.64-5.94a1.62,1.62,0,0,0-.12.58.66.66,0,0,0,.22.55l.95.77,13.12-8.55c2.45-1.41,4.28-5.35,4.28-7.92a10.17,10.17,0,0,0-.39-2.61s-1.09-.89-1.25-1A2.49,2.49,0,0,0,761.28,457Zm0,9.38L756.67,469a31.5,31.5,0,0,0,1.77-3.1s-.73-.6-.94-.76a.92.92,0,0,0-1-.08,14.17,14.17,0,0,0,1.18-4l3.59-2.07c1.3-.75,2.52.76,2.52,2.47A6.54,6.54,0,0,1,761.28,466.37Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.27,457.8l-3.54,2c0-.11,0-.22,0-.33-.42-3.27-2.9-4.64-5.95-3.29a13.66,13.66,0,0,0-6.08,6.3l-8.76,5.05c-2.17,1.26-4.22,1.25-5.52,0a6.8,6.8,0,0,0,.18-1.5,2.85,2.85,0,0,0-1.34-2.76c0-.62.09-2.45-.39-2.39s-1.24,1.56-1.66,2.38l-.15.06c-.25-.63-.73-1.66-1.17-1.37s-.85,2-1,2.93a10,10,0,0,0-2.31,4.06l-2.77,1.6a1.66,1.66,0,0,0-.75,1.3c0,1.18.84,1.66,1.86,1.07l1.1-.64.78-.46c.58-.34,1,0,.88.83a2.11,2.11,0,0,1-.68,1.14c-.32.27-.62.32-.83.21a1.05,1.05,0,0,0-1,.16l-.13.07a1.44,1.44,0,0,0-.65,1.13c0,.42.29.58.65.38l3.32-1.92a3.25,3.25,0,0,0,1.61-.32v5.4c0,.88.4,1.42,1,1.52l.42,1.67-8,4.61a7,7,0,0,0-3.18,5.52c0,.49.35.68.77.44l13-7.5a3.71,3.71,0,0,0,1.68-2.91v-2.62l-.33-1.33,12.32-7.11a4,4,0,0,0,.73,1.1l-5,2.89a6.75,6.75,0,0,0-3.05,5.29h0c0,.57.4.81.9.52l8.91-5.14a1.62,1.62,0,0,0-.12.58c0,.56.39.79.88.51l13.41-7.74c2.45-1.41,4.28-5.35,4.28-7.92C766.55,458.53,764.68,456.41,762.27,457.8Zm0,9.38-4.61,2.66a5.45,5.45,0,0,0,1.11-3.05c0-.85-.56-1.21-1.27-.89a14.17,14.17,0,0,0,1.18-4l3.59-2.07c1.3-.75,2.52.76,2.52,2.47A6.54,6.54,0,0,1,762.27,467.18Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M656.3,525.23a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17c1.06-1.84,3.15-3.84,3.49-5.61l-1.25-.68a17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a10.27,10.27,0,0,0-.22-3.83l-1.25-.68c-.18.4-.34.81-.49,1.21l-1-.37a15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38l1.25.68c1.14.05,2-.86,3.4-1.66a14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05c1.63-.94,4.62-2,5.9-3.7l-1.25-.68A6.45,6.45,0,0,0,656.3,525.23Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.55,525.91a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17,17.64,17.64,0,0,0,2.24-6.29,17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a6.45,6.45,0,0,0-1.47-4.51,18.51,18.51,0,0,0-.73,1.92,4.74,4.74,0,0,0-.73-1.08,15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38,6.45,6.45,0,0,0,4.65-1,14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0H653a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05,15.47,15.47,0,0,0,4.65-4.38A6.45,6.45,0,0,0,657.55,525.91Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M656.54,528.44c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31h0l.08-.06a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,656.54,528.44Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.7,529.35a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,657.7,529.35Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M691.55,504.95a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17c1.06-1.84,3.15-3.84,3.49-5.61l-1.25-.68a17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a10.27,10.27,0,0,0-.22-3.83l-1.25-.68c-.18.4-.34.81-.49,1.21l-1-.37a15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38l1.25.68c1.14.05,2-.86,3.4-1.66a14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0H687a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05c1.63-.94,4.62-2,5.9-3.7L696.2,504A6.45,6.45,0,0,0,691.55,504.95Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.8,505.63a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17,17.64,17.64,0,0,0,2.24-6.29,17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a6.45,6.45,0,0,0-1.47-4.51,18.51,18.51,0,0,0-.73,1.92,4.74,4.74,0,0,0-.73-1.08,15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38,6.45,6.45,0,0,0,4.65-1,14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05,15.47,15.47,0,0,0,4.65-4.38A6.45,6.45,0,0,0,692.8,505.63Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M691.8,508.16c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31h0l.08-.06a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,691.8,508.16Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693,509.07a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,693,509.07Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M791.91,290.32a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17c1.06-1.84,3.15-3.84,3.49-5.61l-1.25-.68a17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a10.27,10.27,0,0,0-.22-3.83l-1.25-.68c-.18.4-.34.81-.49,1.21l-1-.37a15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38l1.25.68c1.14.05,2-.86,3.4-1.66a14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05c1.63-.94,4.62-2,5.9-3.7l-1.25-.68A6.45,6.45,0,0,0,791.91,290.32Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.16,291a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17,17.64,17.64,0,0,0,2.24-6.29,17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a6.45,6.45,0,0,0-1.47-4.51,18.51,18.51,0,0,0-.73,1.92,4.74,4.74,0,0,0-.73-1.08,15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38,6.45,6.45,0,0,0,4.65-1,14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05A15.47,15.47,0,0,0,797.8,290,6.45,6.45,0,0,0,793.16,291Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M772.73,277.37h0l-8.92,5.15.84-3.3a2.15,2.15,0,0,0-3.14-1.69h0a5.09,5.09,0,0,0-2.3,4v.09l-1.15.67a2.68,2.68,0,0,0-1.21,2.1v1.5l.84.5c.47-.27.1-1.42.2-2l1.32-.6v1.39l-8.91,5.14h0l-5.78,7.2.84.5c2.89-.35,6.16-2.63,9.22-5.55h0a10.11,10.11,0,0,0,4.68-.73c.06.8.16,1.47.3,2.85l0,.21-.61.35a1.72,1.72,0,0,0-.74,1.07l-.69.4-1.24,0h-.06l0,0,0,0,0,0,0,0-.53.67a.34.34,0,0,0-.07.37,1.17,1.17,0,0,0,.18.11l-.27.48a.34.34,0,0,0-.07.37,5.58,5.58,0,0,0,.49.4.22.22,0,0,0,.07.29c.09.08.82.49.82.49l.75-1.41.63-1s.52-.39.87-.6l1-.56.1.43a2.67,2.67,0,0,0,.05.31l-1.29,6.67.84.5,4.53-3.61-1.29-5.18c0-.12,0-.25.05-.37l.1-.54,1-.57a1.72,1.72,0,0,0,.74-1.07l.71.21,1-.44.3.38c.06.08.19,0,.29-.09h0c.1-.13.62-.22.56-.3l-.51-.3a4.08,4.08,0,0,0,1.31-.51l-.64-.35c.06-.15.47-.18.53-.32s-.93-.61-.93-.61l-.53-.06h-.06l0,0,0,0,0,0,0,0-1.24,1.4-.69.4c-.09-.32-.38-.42-.74-.22l-.64.37,0-.26c.14-1.53.24-2.32.3-3.18a27.28,27.28,0,0,0,4.71-4.7,21.64,21.64,0,0,0,10.91-6.07l-.84-.5Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.58,277.87h0L764.65,283v-3.66c0-1.47-1-2.06-2.3-1.33h0a5.09,5.09,0,0,0-2.3,4v.09l-1.15.67a2.68,2.68,0,0,0-1.21,2.1v1.5l.09,0a2.21,2.21,0,0,0,1-1.43l1.32-.6v1.39l-8.91,5.14h0l-5.78,7.2c3.09-.09,6.7-1.84,10.07-5.05h0a10.11,10.11,0,0,0,4.68-.73c.06.8.16,1.47.3,2.85l0,.21-.61.35a1.72,1.72,0,0,0-.74,1.07l-.69.4-1.24,0h-.06l0,0,0,0,0,0,0,0-.53.67a.34.34,0,0,0-.07.37c.06.08.19,0,.29-.08l.44-.55h.5l-.7.48a.41.41,0,0,0-.1.1l-.52.66a.34.34,0,0,0-.07.37c.06.08.19,0,.29-.08l.49-.63.57-.39-.46.59h0l0,.07,0,0h0l-.33.8c-.06.15,0,.28.07.29s.23-.09.29-.24l.3-.73,1.13-1.44.63-.36c.09.32.38.42.74.22l1-.56.1.43a2.67,2.67,0,0,0,.05.31l-1.29,6.67,5.38-3.1L763.75,296c0-.12,0-.25.05-.37l.1-.54,1-.57a1.72,1.72,0,0,0,.74-1.07l.63-.36,1.13.14.3.38c.06.08.19,0,.29-.09h0a.34.34,0,0,0,.07-.37l-.33-.41h0l-.05,0h0l-.46-.06.57-.26.49.06c.1,0,.23-.1.29-.25h0c.06-.15,0-.28-.07-.29l-.52-.06a.15.15,0,0,0-.1,0l-.7.33.5-.57.44,0c.1,0,.23-.1.29-.25s0-.28-.07-.29l-.53-.06h-.06l0,0,0,0,0,0,0,0-1.24,1.4-.69.4c-.09-.32-.38-.42-.74-.22l-.64.37,0-.26c.14-1.53.24-2.32.3-3.18a27.28,27.28,0,0,0,4.71-4.7c3.37-.67,7-3.09,10.07-6.57Z",
    style: {
      fill: "#140a99"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M789.58,271a4.67,4.67,0,0,1-2.11,3.66,1.49,1.49,0,0,0-.66.93s-1-.87-1.06-1a1.68,1.68,0,0,1-.39-1.19,4.67,4.67,0,0,1,2.11-3.66,1.39,1.39,0,0,1,1.65,0l.93.85S789.58,270.71,789.58,271Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.49,271.83a4.67,4.67,0,0,1-2.11,3.66c-1.17.67-2.11.13-2.11-1.22a4.67,4.67,0,0,1,2.11-3.66C789.55,269.94,790.49,270.49,790.49,271.83Z",
    style: {
      fill: "#140a99"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M875.37,166.54c-1.9-7,1.09-12.54,0-20.59-2.18-16.05-37-12.32-50.56-23.24-23.16-18.69-70.87-12.8-75.76.9a13.58,13.58,0,0,0-14-5.73c-.28.06-32.65,14.54-32.65,14.54a25.29,25.29,0,0,0-17.62,18.15l-2,7.85-4.16-2.36A14.65,14.65,0,0,0,666.5,155a51.55,51.55,0,0,1-8.92,2.23l-3.27.53c-6.31,1-10.77,6.27-11.61,12.6-.78,5.88-7.62,14.13-14.63,17a35.23,35.23,0,0,0-14.15,9.9c-8.36-2.53-19.36-1-29.59,9.09-5.39,5.3-15.68,8.3-21.39,6.68-6.15-1.75-12.72.26-16.18,5.64L545,221.43a51.59,51.59,0,0,1-5.59,7.3,14.65,14.65,0,0,0-3.85,11.54l.56,5.28a27.3,27.3,0,0,0-11.63.41,93.37,93.37,0,0,1-12.25,2.26l-4.48.54c-8.66,1.05-15.51,6.26-16,12.64,0,0,0,.11,0,.27a14.63,14.63,0,0,0-4.09-1.1,51.55,51.55,0,0,1-9-1.91l-3.17-1c-6.12-1.84-12.43.9-16,6.23-3.28,4.94-13.05,9.35-20.6,8.82-27-1.89-36.48,21.06-30.07,31.35.17.27.35.54.53.8l-.4-.12c-6.22-2-13.19-3.48-16.11-1.45-1.8,1.25-2.75,4.82-3.22,8.79a30.21,30.21,0,0,1-15.52,22.77l-11.42,6.29c-21.14,11.65-24.74,41-6.51,56.82,6.44,5.59,15,9.69,26.24,10.47,42.45,3,50.8,28.13,58.39,30.44s14.52-6.7,20.59-4.8,14,12.36,24.33,12.44,21.72-15.18,15.76-22.45l4.6-2.65V623l40.06-23V413.28a52.32,52.32,0,0,1,8.38-2l3.27-.51a13.7,13.7,0,0,0,11.71-12.5c0-.11-.72-5.24-1.63-11.57a13.58,13.58,0,0,0,14,5.84c.28-.06,32.77-14.26,32.77-14.26a25.29,25.29,0,0,0,17.77-18l2-7.83,4.14,2.39A14.65,14.65,0,0,0,650.75,356a51.57,51.57,0,0,1,8.94-2.15l3.27-.51c6.32-1,10.82-6.18,11.71-12.5.83-5.87,7.74-14.06,14.78-16.84a35.23,35.23,0,0,0,14.24-9.78c8.34,2.6,19.35,1.13,29.66-8.84,5.43-5.26,15.75-8.17,21.44-6.5,6.13,1.8,12.73-.15,16.23-5.5l1.81-2.77a51.58,51.58,0,0,1,5.65-7.25,14.65,14.65,0,0,0,3.94-11.5l-.52-5.28a27.3,27.3,0,0,0,11.63-.31,93.37,93.37,0,0,1,12.27-2.15l4.49-.51c8.67-1,15.56-6.13,16.08-12.5,0-.1,16.66-4.56,15.51-10.37,0,0,21.94-11.38,27.45-15.43.33-.24,4.9-2.65,10.08-15.62a48.14,48.14,0,0,0,2.71-8.75C887.56,173.31,877.26,173.58,875.37,166.54Z",
    style: {
      fill: "#595959",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "467.2 411.88 507.27 388.92 540.31 408.09 540.31 611.31 500.25 634.27 467.2 615.1 467.2 411.88",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "500.25 431.06 540.31 408.09 540.31 611.31 500.25 634.27 500.25 431.06",
    style: {
      fill: "#120667"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M804.19,276.28s17.95-9.24,20.94-12,2.23-22.85,2.05-24.57,2.57-2,2.57-2,.68,21.51.68,24.09c0,.6,5.09-.73,13.81-9.29v2.65s-8.08,9.07-12.27,9.33-5.39,2-6.68,3.17-7.53,4.54-10.53,6.08-7.73,3.68-10.59,5.73Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.19,368s17.95-9.24,20.94-12,2.23-22.85,2.05-24.57,2.57-2,2.57-2,.68,21.51.68,24.09c0,.6,5.09-.73,13.81-9.29V347s-8.08,9.07-12.27,9.33-5.39,2-6.68,3.17-7.53,4.54-10.53,6.08-7.73,3.68-10.59,5.73Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.19,302.7s12.33-8.22,17.23-10.16,13.47-6.16,16.21-8.45a29.76,29.76,0,0,1,6.62-3.88V283a41.76,41.76,0,0,1-8.79,5,47.69,47.69,0,0,0-10.16,5.36c-1.26,1-8.45,6.85-12.55,7.42s-8.56,5.48-8.56,5.48Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.19,322.49s17.95-9.24,20.94-12,2.23-17.31,2.05-19,2.57-2,2.57-2,.68,16,.68,18.55c0,.6,5.09-.73,13.81-9.29v2.65s-8.08,9.07-12.27,9.33-5.39,2-6.68,3.17-7.53,4.54-10.53,6.08-7.73,3.68-10.59,5.73Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.19,415.1s17.95-9.24,20.94-12,2.23-22.85,2.05-24.57,2.57-2,2.57-2,.68,21.51.68,24.09c0,.6,5.09-.73,13.81-9.29V394s-8.08,9.07-12.27,9.33-5.39,2-6.68,3.17-7.53,4.54-10.53,6.08-7.73,3.68-10.59,5.73Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.19,436.93s12.33-8.22,17.23-10.16,13.47-6.16,16.21-8.45a29.76,29.76,0,0,1,6.62-3.88v2.74a41.76,41.76,0,0,1-8.79,5,47.69,47.69,0,0,0-10.16,5.36c-1.26,1-8.45,6.85-12.55,7.42s-8.56,5.48-8.56,5.48Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.91,445.27c.76-5.32.39-18.37.27-19.56-.17-1.71,2.57-2,2.57-2s.36,14,.56,19.57Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.19,342.87s12.33-8.22,17.23-10.16,13.47-6.16,16.21-8.45a29.76,29.76,0,0,1,6.62-3.88v2.74a41.76,41.76,0,0,1-8.79,5,47.69,47.69,0,0,0-10.16,5.36c-1.26,1-8.45,6.85-12.55,7.42s-8.56,5.48-8.56,5.48Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.19,389.66s12.33-8.22,17.23-10.16,13.47-6.16,16.21-8.45a29.76,29.76,0,0,1,6.62-3.88v2.74a41.76,41.76,0,0,1-8.79,5,47.69,47.69,0,0,0-10.16,5.36c-1.26,1-8.45,6.85-12.55,7.42s-8.56,5.48-8.56,5.48Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.25,453.34s17.95-9.24,20.94-12,2.23-22.85,2.05-24.57,2.57-2,2.57-2,.68,21.51.68,24.09c0,.6,5.09-.73,13.81-9.29v2.65s-8.08,9.07-12.27,9.33-5.39,2-6.68,3.17-7.53,4.54-10.53,6.08-7.73,3.68-10.59,5.73Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.25,545.1s17.95-9.24,20.94-12,2.23-22.85,2.05-24.57,2.57-2,2.57-2,.68,21.51.68,24.09c0,.6,5.09-.73,13.81-9.29V524s-8.08,9.07-12.27,9.33-5.39,2-6.68,3.17-7.53,4.54-10.53,6.08-7.73,3.68-10.59,5.73Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.25,473s12.33-8.22,17.23-10.16,13.47-6.16,16.21-8.45a29.76,29.76,0,0,1,6.62-3.88v2.74a41.76,41.76,0,0,1-8.79,5,47.69,47.69,0,0,0-10.16,5.36c-1.26,1-8.45,6.85-12.55,7.42s-8.56,5.48-8.56,5.48Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.25,492.75s17.95-9.24,20.94-12,2.23-17.31,2.05-19,2.57-2,2.57-2,.68,16,.68,18.55c0,.6,5.09-.73,13.81-9.29v2.65S532.23,480.77,528,481s-5.39,2-6.68,3.17-7.53,4.54-10.53,6.08-7.73,3.68-10.59,5.73Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.25,592.17s17.95-9.24,20.94-12,2.23-17,2.05-18.7,2.57-2,2.57-2,.68,15.65.68,18.23c0,.6,5.09-.73,13.81-9.29v2.65s-8.08,9.07-12.27,9.33-5.39,2-6.68,3.17-7.53,4.54-10.53,6.08-7.73,3.68-10.59,5.73Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.25,614s12.33-8.22,17.23-10.16,13.47-6.16,16.21-8.45a29.76,29.76,0,0,1,6.62-3.88v2.74a41.76,41.76,0,0,1-8.79,5,47.69,47.69,0,0,0-10.16,5.36c-1.26,1-8.45,6.85-12.55,7.42s-8.56,5.48-8.56,5.48Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523,621.25c.76-5.32.39-17.29.27-18.47-.17-1.71,2.57-2,2.57-2s.36,12.89.56,18.49Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.25,519.94s12.33-8.22,17.23-10.16,13.47-6.16,16.21-8.45a29.76,29.76,0,0,1,6.62-3.88v2.74a41.76,41.76,0,0,1-8.79,5,47.69,47.69,0,0,0-10.16,5.36c-1.26,1-8.45,6.85-12.55,7.42s-8.56,5.48-8.56,5.48Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.25,572.72s12.33-8.22,17.23-10.16,13.47-6.16,16.21-8.45a29.76,29.76,0,0,1,6.62-3.88V553a41.76,41.76,0,0,1-8.79,5,47.69,47.69,0,0,0-10.16,5.36c-1.26,1-8.45,6.85-12.55,7.42s-8.56,5.48-8.56,5.48Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M409.9,376.5c6.82,1.71,11.62,12,19.5,10.18,7.31-1.66,9.53-11.57,21.52-13.77,9.9-1.82,20.34-21.22,50-8.14,5.74,2.53,14.08-.62,16.77,1h0a14.65,14.65,0,0,1,6.91,10c.54,3,12.63,1.56,17.08,13.93l1.83,5.3c2.22,6-.13,12.46-5.23,16.32-4.73,3.58-8.87,14.39-11.58,18.29-3.88,5.59-12.5,5.37-12.86,12.74,6.33,6,10.41,16.36,6.71,30.21-1.95,7.31.53,17.74,4.76,21.89,4.56,4.48,6.06,11.19,3.09,16.85l-1.54,2.93a51.57,51.57,0,0,0-3.58,8.47,14.65,14.65,0,0,1-8.13,9l-4.87,2.12a27.3,27.3,0,0,1,5.39,10.31,93.37,93.37,0,0,0,4.09,11.77l1.74,4.17c3.36,8.05,2.22,16.58-3.1,20.13-.09.06-4.5,1.5-10.13,3.32l-.13,31.49a7.9,7.9,0,0,0,1,.71,27.57,27.57,0,0,1,4.2,11l-8.39,4.83S403.68,374.94,409.9,376.5Z",
    style: {
      fill: "#595959",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.39,656.42c-7.08,1.77-9.88,9.53-18,10s-13.09-9-20.27-11.91c-6.58-2.64-51.93-29.41-58.9-34.42l.05,0L357,612.65a14.65,14.65,0,0,1-6.82-10.07,51.56,51.56,0,0,0-2.39-8.88l-1.12-3.11A13.7,13.7,0,0,1,352,574.32c.09-.06,5-1.88,10.94-4.11a13.58,13.58,0,0,1-11.82-9.46c-.08-.28-3.18-35.6-3.18-35.6a25.29,25.29,0,0,1,7.28-24.22l5.9-5.55L357,492.89a14.65,14.65,0,0,1-6.82-10.07c-.51-3-5-28.91-6-31.8l-1.74-5.48c-2.17-6,.67-15.29,5.8-19.1,4.76-3.54,20.14-16.77,13.27-29.25-6.5-11.82-8.86-27.45,6-31.42,1.66-.44,10.44-4.1,17.88-.27a85.62,85.62,0,0,0,18.15,6.5c6.82,1.71,11.62,12,19.5,10.18,7.31-1.66,9.53-11.57,21.52-13.77,9.9-1.82,20.34-21.22,50-8.14,5.74,2.53,14.08-.62,16.77,1h0a14.65,14.65,0,0,1,6.91,10c.54,3,12.63,1.56,17.08,13.93l1.83,5.3c2.22,6-.13,12.46-5.23,16.32-4.73,3.58-8.87,14.39-11.58,18.29-3.88,5.59-12.5,5.37-12.86,12.74,6.33,6,10.41,16.36,6.71,30.21-1.95,7.31.53,17.74,4.76,21.89,4.56,4.48,6.06,11.19,3.09,16.85l-1.54,2.93a51.57,51.57,0,0,0-3.58,8.47,14.65,14.65,0,0,1-8.13,9l-4.87,2.12a27.3,27.3,0,0,1,5.39,10.31,93.37,93.37,0,0,0,4.09,11.77l1.74,4.17c3.36,8.05,2.22,16.58-3.1,20.13-.09.06-4.5,1.5-10.13,3.32l-.13,31.49a7.9,7.9,0,0,0,1,.71s10.84,15-1.12,31a40.51,40.51,0,0,1-6.33,6.62C473.77,667,472.46,654.65,465.39,656.42Z",
    style: {
      fill: "url(#7e2315da-dc92-457b-a350-cff0ebc39201)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M507.42,437.84s-11.22,13.12-37,7-33.66-2.23-42.8-3.39-5.89-8.74-11-14.42a10.21,10.21,0,0,0-11.38-3s-7.52,2.81-7.52-2.08-2.44-5.51-4.88-5.3-7.72.33-7.31-1.87-5.08-5.65-6.3-2.4S375,413,375,413s-.41-4.06-3-3.66-6.3,1-6.3,0c0,0-1.22,2,5.23,1.7,0,0,1.68-.46,1.42,2s3.4,3.45,3.4,3.45,3.15.56,4.42-1.78,2.49-1.52,2.49-1.52-2.66,3.54-.78,4.86S389,419.4,389,419.4s4.69-.3,5.55.41-1.07,2.93.41,5,5.87,2.69,8.57,1.73,5.08-2,6.6-1.63.36,4.82,3.71,5.69,4,1,4.11,2.08-.46,4,.81,4.82,1.37,2.08,2,3.45,5.74,4.22,12.09,3.45c.27,0,.1-.66,2.79-.05s5.23-.76,7.36.1,7.26-.1,8.74-.2,16.86,4.82,21.48,4.52,10-.3,11.12-.2,4.77.84,7.21.22,8.74-4.74,9.19-4.79,8.57-2.62,8-4.81Z",
    style: {
      fill: "url(#08f6bbca-7d9a-4883-a806-883db767b519)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.6,456.6s2.13-11.05,5.79-14.1,5.49-.8,8.33-2,2.44-3.46,4.67-4.27,3.32.11,4.2-.49.61-1.82,1.49-2.09.68-1.08.95-1.35,3.11-3.22,4.6-3.52c7.35-1.49,6.13,8.77,6.13,8.77s-5.28-2.61-6.5-2.34a15.53,15.53,0,0,0-3.56,1.83c-1,.55-2.23.61-4.47.47s-2.57,4-4.81,5a6,6,0,0,1-4.2.32c-1-.14-1.63.14-3,1s-1.76,0-3.12,0-1.42.74-1.49,1.63a7.25,7.25,0,0,1-1.83,3.18C385.07,449.27,385.61,456.48,382.6,456.6Z",
    style: {
      fill: "url(#7d41c949-e8bc-4005-893a-822887dca9f4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.11,479.44s7.81,9.32,6.34,16.56-10.42,9.9-12.24,14.46-1,6.39-3.85,7.1-2.84,3.39-2.84,5.91-3-2.76-3-3.88,1.22-2.54,2.23-3.56a27.89,27.89,0,0,1,3.35-2.84c1.73-1.32-.41-4.37.81-6s2.84-2.34,5.18-3.15a3.55,3.55,0,0,0,2.64-4c-.2-1.32.61-1.37,2.13-4.09s1.22-5.66-1.42-7.59.3-3.86.3-3.86A4.09,4.09,0,0,1,473.11,479.44Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.86,529.36s-3.94,0-7.19,6.25-20.82,15.58-42.36,3.49c-26.1-14.65-19.67-19.92-21.3-21.45s-3.52-12.08-15.71-6.54-17.07,1.29-17.61-1.6a3.85,3.85,0,0,0-5.15-2.93,6,6,0,0,1-7.58-4.17,4.13,4.13,0,0,0,0,3.74c1,2,1.76,1.29,2,1.29s2.17.34,2.71,1.15,3.52-.68,4.13-.41.34,4.6,2.64,5.08S403,516,405,514.89s12.46,2.57,15-1.15,4.6-2.51,6-1.15,4.13,7,5.62,6a9.14,9.14,0,0,0,.64,7.79c2.42,4.25,3.76,1.83,4.3,4.94s2.94,5.72,7.18,7c2.29.71,4.66,2.42,7.16,3.5s2.39,4,5.64,4.28,13.75,3.25,16,2.84c1.83-.32,9.84-.55,13.07-.63a4.11,4.11,0,0,0,2.46-.9c2.31-1.84,8.66-6,9-7.85.41-2.37,2-4.81,3.25-4.81s2.11-2.34,2.11-2.95,3.55.28,3.55.28Z",
    style: {
      fill: "url(#642a9d23-05db-4562-af3e-18b45ff0b8bd)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.85,579.07S493,581.46,490,586.53s-3.86,7.81-6.3,8.88-4,5.39-4,5.39-2.26,4.62-7.95,2-7.31-2.54-9.35-2-6.09,4.22-9.35,2.8-4.88-3.66-8.74-5.69-9.35,3.66-12.19,4.67-7.72,4.3-10.36,3.27-7.52,1.41-8.94,2-1.22-.17-7.31-2c0,0,4.54-.29,6.23-.63s3.79-3.39,10.43-2.64,6.77.34,9.41-1.63-2-3,6.7-5.42,9.75-1.42,12.26.54,1.15,2.91,4.74,2.78,7.25-2.51,13.81-3.79,11.11-.07,13.21-2.44,2.57-11.48,8.46-13.56,11.44-3.84,15.78-4,5.49.65,5.49.65Z",
    style: {
      fill: "url(#6738b488-2e7a-4788-a7dc-f10d0132a67f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.71,556.67s6.5,1.63,8.13,2.84.2,6.53,3.76,9.06,3.76,1.51,6.6,5,2.23,5.89,3.86,8.94,1.83,4.47,4.47,5.08,7.11,2.64,9.55,5.49c0,0-2-.41-1.63-3.25s-1.63-3-3-3.25-4.06,0-4.27-2.64a14.82,14.82,0,0,0-1-5.08c-.61-1.63-2.64-2-3.86-3.74s-1.22-3-1.83-4.79-3.75-2.84-4.92-3.66-2-.87-3-3.38,1.83-4.14-1.83-6.58S370.71,556.67,370.71,556.67Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.6,629.14s-4-8.79-5.65-11.61-3.79-5.31-6.23-6.51-2.71-1.57-2.17-5.18,1.16-6.31-.23-8.21a15,15,0,0,1,4.47,6.88c1.19,4.22-.17,4.71,2.68,6.09a8.13,8.13,0,0,1,4.2,4.91c.54,1.35.2,5,2.95,5.73s4.55,2.4,3.92,4-1.29.75,0,3.87a12.54,12.54,0,0,0,4.64,5.13Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.12,495.38S371.66,497,376,499.72a45.1,45.1,0,0,0-6.64,0c-1.63.19-3.66,3.63-4.74,2.7s-4.33-1-4.74.18-3.32,1.06-5,.78-3.67,2.43-3.67,2.43A76.28,76.28,0,0,1,361.12,495.38Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.47,428.07s3.93-2.57,6.64-2.3,5,1.18,5.55,0,2.3-1.73,3.79-1.67,2.17.87,4.47,0a2.93,2.93,0,0,1-2-1.56c-.95-1.49-1.49-3.66-3.79-3.66a3.21,3.21,0,0,1-3-2.11s-3.59,4.06-5.1,5.66S346.47,428.07,346.47,428.07Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,570.21s3.72-.61,7-1.53a2.69,2.69,0,0,1,2.36.42c.43.34.66.74.05,1.11-1.35.82-3.4.28-4.54.82s-1.37,2.64-4.91,2.64-4.43-.07-6.19.54a12.31,12.31,0,0,1-4.75.11S360.9,570.58,363,570.21Z",
    style: {
      fill: "#0c022f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.9,401.48S368.82,515.64,253.2,522.82",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 6,
      stroke: "url(#bacfac46-1577-4067-93e9-e647bf503eef)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.67,370s-5,113.83-94.42,149.9c-108.54,43.79-230.43-37.3-230.43-37.3",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 6,
      stroke: "url(#42b2a707-5f92-46b0-8884-67464b730792)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.14,260.66s17.19,72,86.27,75.43,116.21-57.15,120.68-107.94,4.06-95.48,4.06-95.48",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 6,
      stroke: "url(#1e73852a-144a-4e32-a698-3fc32bbd48f7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.12,324.67s28.61,24.93,62.48,13.59,55-57.25,57.57-84.55",
    style: {
      fill: "none",
      stroke: "#0c022f",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.21,163c-47.13,119.46-172.55,72.8-172.55,72.8l-38.6-14.56",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 6,
      stroke: "url(#44578c5c-39c7-433d-945c-d37d4efd00b5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.44,160.46c-1.9-7,1.09-12.54,0-20.59-2.18-16.05-37-12.32-50.56-23.24-23.16-18.69-70.87-12.8-75.76.9a13.58,13.58,0,0,0-14-5.73c-.28.06-32.65,14.54-32.65,14.54a25.29,25.29,0,0,0-17.62,18.15l-2,7.85L674.69,150a14.65,14.65,0,0,0-12.12-1.06,51.56,51.56,0,0,1-8.92,2.23l-3.27.53c-6.31,1-10.77,6.27-11.61,12.6-.78,5.88-7.62,14.13-14.63,17a35.23,35.23,0,0,0-14.15,9.9c-8.36-2.53-19.36-1-29.59,9.09-5.39,5.3-15.68,8.3-21.39,6.68-6.15-1.75-12.72.26-16.18,5.64L541,215.35a51.58,51.58,0,0,1-5.59,7.3,14.65,14.65,0,0,0-3.85,11.54l.56,5.28a27.3,27.3,0,0,0-11.63.41,93.37,93.37,0,0,1-12.25,2.26l-4.48.54c-8.66,1.05-15.51,6.26-16,12.64,0,0,0,.11,0,.27a14.63,14.63,0,0,0-4.09-1.1,51.55,51.55,0,0,1-9-1.91l-3.17-1c-6.12-1.84-12.43.9-16,6.23-3.28,4.94-13.05,9.35-20.6,8.82C408,264.76,398.58,287.71,405,298c.17.27.35.54.53.8l-.4-.12c-6.22-2-13.19-3.48-16.11-1.45-1.8,1.25-2.75,4.82-3.22,8.79a30.21,30.21,0,0,1-15.52,22.77l-11.42,6.29c-21.14,11.65-24.74,41-6.51,56.82,6.44,5.59,15,9.69,26.24,10.47,42.45,3,50.8,28.13,58.39,30.44s14.52-6.7,20.59-4.8,14,12.36,24.33,12.44,21.72-15.18,15.76-22.45l26.22-15.14,5.78,3.34a14.65,14.65,0,0,0,12.11,1.16,51.57,51.57,0,0,1,8.94-2.15l3.27-.51a13.7,13.7,0,0,0,11.71-12.5c0-.11-.72-5.24-1.63-11.57a13.58,13.58,0,0,0,14,5.84c.28-.06,32.77-14.26,32.77-14.26a25.29,25.29,0,0,0,17.77-18l2-7.83,4.14,2.39a14.65,14.65,0,0,0,12.11,1.16,51.57,51.57,0,0,1,8.94-2.15l3.27-.51c6.32-1,10.82-6.18,11.71-12.5.83-5.87,7.74-14.06,14.78-16.84a35.23,35.23,0,0,0,14.24-9.78c8.34,2.6,19.35,1.13,29.66-8.84,5.43-5.26,15.75-8.17,21.44-6.5,6.13,1.8,12.73-.15,16.23-5.5l1.81-2.77a51.58,51.58,0,0,1,5.65-7.25,14.65,14.65,0,0,0,3.94-11.5l-.52-5.28a27.3,27.3,0,0,0,11.63-.31A93.37,93.37,0,0,1,801.89,258l4.49-.51c8.67-1,15.56-6.13,16.08-12.5,0-.1,16.66-4.56,15.51-10.37,0,0,21.94-11.38,27.45-15.43.33-.24,4.9-2.65,10.08-15.62a48.13,48.13,0,0,0,2.71-8.75C883.63,167.23,873.34,167.5,871.44,160.46Z",
    style: {
      fill: "url(#a1edf8c5-240a-4d54-bf27-ba2c645f9bd1)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M446.21,311.87c7.39-2.44,4.23-3.61,15.56-4.24s24,4.09,29,5.71,8.59-1.83,19.76-1,19-2.64,22.14-2.64c4.93,0,11.26,4,15.39,5.74,3.11,1.29,8.76-1.05,11,1.45,1.25,1.38,3.81,2.91,9.09,3.52,10.56,1.23,15-1.93,22.35-.7s31.92,4.7,28.37,9.83c-10.7,15.46,10.68-.61,11.68,16.87l-1.66,6.37s-1.95-.8-3.44-6.63-3-5.42-6.57-6-4.67,4.6-6.84-3.39,1.66-7.86-1.95-8.67-2.66-1.73-8.21-2.54-3.3,2.27-9.57.24-10.34-4.6-14.67-1.35-5.15,3.25-8,1.49.95-2.17-4.33-2.71-6.37.54-9.48-.68-3.25-2.17-7.31-4.6-13.27-.54-23.57-2.44-8.13-.27-15.3.14-12.73,6.91-19.1,3.25-4.47-5.82-12.05-6.23-8,.54-13.68-.68-16.12,1.63-16.12,1.63Z",
    style: {
      fill: "url(#6f00af97-b93c-431c-ae3c-4649aec55e6c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.76,308.15s7-10,7.08-12.85-3.28-12.48-1.32-18.49-2.09-10.08-2-12.39c.05-2,10.14-10.63,6.09-14.19a79.64,79.64,0,0,0-7.38-4.2,48,48,0,0,1-11.31-6.9,20.52,20.52,0,0,0-5.18-3c-5-2-14.5-6.66-14.31-12.26.05-1.53-1.5-13.68,4.73-19.5.87-.81-2.17-6.81-1.22-6.64,10.16,1.9,1.61,15.24,1.61,15.24s-5.43,8.73,0,11.44,5.63,8,10.58,10,10.7-.69,14.15,4.88,12.53,3,10.23,8.8c-.66,1.65,7.84,2.5,3.24,7s-9.63,8.33-5.34,11.58,9.35,5.31,6.09,7-6.43,2.17-7.52,7.58,3.25,5.52,2.71,12-2.29,16-2.29,16a14,14,0,0,1-3.73,0l-5.55,3.09Z",
    style: {
      fill: "url(#cc8434fb-1151-438e-bb91-2b1e461715d3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.17,239.46s24.41-4.77,25.75-1.7,1.73,9.17,13.72,9.17,12.6-2.15,18.39-1.69c4.15.33,13.43,0,17.92.39a5.69,5.69,0,0,1,4.43,2.79l6.52,13.48s2.36,6,0,10.72c0,0,4.68-6.82,3.19-9.39s-2.84-3.93-4.06-6.09-1.63-2.57-3-7.86-3.12-6.23-6.09-6.09-10.43,1.35-12.87.27-3.93-2.17-10-2-6.37,3.12-9.62,3.52-7.86-1.49-9.48-2-4.33-.95-4.88-2.3-1.08-6.37-3.39-7-7.31-.81-8.94.14-3,3.12-5.69,2.44-1.2-1.49-5.68-1.63-6.22.81-6.22.81Z",
    style: {
      fill: "url(#6915f17a-b8a4-4bd7-af81-a470002b95c7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.77,177c5.15,3,9.48,2.92,12.46,3.09s4.33,1,5.69,3.14,7.44,6,12,6,7.25,1.35,7.79,3.52-.27,6,1.08,8.13,4.88,0,4.88,0-2.86,0-3.4-2.2a33.91,33.91,0,0,1-.41-6.91c0-.81,1-3.35-3-5s-5.6-1-9.4-.71-5-1.46-6.28-3.89,2.49-1.54-1.85-4-6.57-3-9.24-2.17-4.3.46-6.2.46A19.77,19.77,0,0,0,721.77,177Z",
    style: {
      fill: "url(#425fc631-fc62-44a1-b4ab-375089e067a5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838,234.67s2.44-.81,4.74-8.4,1.32-12,3.71-13.34,3.88-2.1,4.29-6.57.68-4.46,0-6.56.81-1.84,3.12-5.09,2.84-3,2.84-5,1.76,2.71,0,5.55-2.17.68-2.71,4.74-.68,4.47-.54,5.28a5.83,5.83,0,0,1-1.22,3.12,8.32,8.32,0,0,0-1.08,4.54c.14,1.82-1.66.06-3.4,2.64s-2.15,3.79-2.15,5.55a39.39,39.39,0,0,0,.14,4.06c.14,1.63-.6.54-1.45,3.25a24.45,24.45,0,0,1-2.26,5l-4,2.41Z",
    style: {
      fill: "url(#c393ed56-8480-46ad-a450-1dad3e4ed425)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.22,217.6c2.38-8.4,5.63-10,6.72-13.54s2.71-3.8,1.08-6.37-6,.68-1.9-4.74,7.72-1.68,9.14-12.9,4.27-8.5,0-15-3.45-13.81-10.5-15.44-.88-.81-7.89-1.63-12.85-3.25-13.18-6,8.71.14-1-5.55-6.8-8.4-20.48-8.19a74.6,74.6,0,0,1-17.27-1.69s10-1.35,13.81-1.35a50,50,0,0,1,10.56,1.08c4.33.81,7.31-1.08,8.4,1.9s4.6,4.88,8.94,6.23,4.6,4.06,3.52,5.69-5.15,2.44-1.9,3.79a23.66,23.66,0,0,0,8.64,1.9c2.2,0,3-1.35,4.64.27s4.06,1.63,6.5,3,5.83,1.35,5.62,5.15.38,4.88,2.25,6.23a9.48,9.48,0,0,1,4.35,7.31c.23,3.79.5,8.61-1.67,12.3s-6,9.92-4.6,11.54-3.52,2.44-3.52,3.52a29.26,29.26,0,0,0,1.08,5.15c.54,2.17-2.17,1.08-3.25,6S824.22,217.6,824.22,217.6Z",
    style: {
      fill: "url(#74e6500c-ebee-48b7-a439-c8b45312b88b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.73,354.12s1,6.7,5.89,7.31,4.51,2.65,6.11,3.36-.75,1.48,4.08,1.91,4.41,2,8.65,3.31,8,2,9.77,3.16,7,5.58,7.38,5.88-.25-1.66-2.58-4.3-1.19-2.71-3.62-4.33-3-1.73-4.88-1.52-3.35,0-4.16-1,.71-1.63-1.93-1.63-1.93.77-4.27-.63-2.84-2.32-4.27-2.62-1.42.71-2.64-.2-1.12-2.23-2.64-2.84a18.93,18.93,0,0,0-4.16-1.52C377,358.22,373.36,357.17,371.73,354.12Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.51,298.81s.82,1.27,7.05,2.76,6.23,1.08,10.84,1.35,4.74,1.63,7,2.71a15.65,15.65,0,0,0,6.77,1.22c2,0-5.82-2.63-6.77-4s-.14-2.61-4.6-3.16-3.66.14-6.91-.27-1.61.68-5.21-1.49-3.33-2.71-5-2.3a28.68,28.68,0,0,1-4.74.46Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610,191.16s5.59,2.27,8.91,1.86,5.76-2.14,6.27,0-.61,2.69,1.83,2.19a13.66,13.66,0,0,1,4.67-.41c1.52.1,1.63,1.73,4.27,0s.61-1.78-1.52-1.45-3.86.48-4.88,0,1.32-.08-1.93-1.29-2.83-.67-5.23-.94-6.66-.07-7.67-.88a6.65,6.65,0,0,0-3.07-.93Z",
    style: {
      fill: "#120667"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M468.55,399.36s3.88-8.9,5.37-12.73c2-5.24,7.58-.93,9.48-2.71s5.69-4.88,8.67-4.88,7.15,4.06,8.18,1.9c0,0-1.41,4.84-4.12,3.66s-2-3.27-4.64-3.2-3.51,3.87-5.11,5.1-3.77.4-7.58,1.63S476,398.14,468.55,399.36Z",
    style: {
      fill: "#0c022f"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M449,646.45A26.31,26.31,0,0,1,466.72,630c9.17-2.44,7.18-.2,13.4-2.79S500,617.11,508,619.13s13.31,9.81,18.34,14,7.81,6.67,11.41,4.9c18.69-9.23,39.95,19.94,37.3,28.67-2.35,7.73-1.34,11.54,3.68,13.94s14.92-1.41,18,11.13.9,27.71,11,29.16S632.9,736.22,633,742.5s-2.3,10.63-1.74,21.05c.63,11.69-19.36,26.1-42.8,25.84-42.06-.46-66.34-5.81-71.51-11.83s-2.78-10.28-11.06-10.53-21,2.32-31.27-5.74c-5.42-4.25-10-25.85-11.29-36.21s5.59-14.24-.25-17.83c-4.66-2.87-16-7.58-16.17-18.38S446.47,653.32,449,646.45Z",
    style: {
      fill: "url(#337740e1-9eb7-481d-aa5e-51703283026e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.47,710.21a27.14,27.14,0,0,0,1.73-11.4c-.47-6.23-3.2-7,.06-11.91a57.66,57.66,0,0,0,5.16-8.67c1.63-3.25,1.35-6,1.9-9.21s.32-4.88,5.31-7,2,6.23,10.4-3.79,5.69-10,8.4-11.92-5.42-4.06-7,0,1.63,3.52-3.79,7-4.88,3.52-6.77,4.06-4.88-1.63-6.77,2.71-1.35,6.77-3.79,8.4-5.24,8.4-4.79,10.84.8,6,0,7.59-2.48,1.08-1.94,4.6-1.7,15-1.7,15Z",
    style: {
      fill: "url(#a6b86aa9-3d7b-406c-a51e-b547122ec6f6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.76,680.6a48.86,48.86,0,0,0-11.53,0c-4.88.81-7.11,3.66-7.31,4.27s-11.45,5.49-14.66,6.3-7.57,0-8.85,3-5.75,9.83-8.39,9.89-1.63-2.38,0-3.8,1.83-1.63,3.45-4.47,1.91-6.7,6.44-7.52,6.77-.41,8.39-3.25,7.11-6.91,10.56-6.91,5.35-.61,6.43,0,3.11.47,5.55-.27,5-4.8,5-4.8S575,680,578.76,680.6Z",
    style: {
      fill: "url(#b94a7f7e-293b-480e-8dd9-d2d4595d7245)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.08,767.61s-3-1.35-.95-6.77,2.57-5.55,2.57-8.4-2.44-1.63,0-4.74,1.49-3.79,4.47-4.33,3.79.68,3.25,1.08-2.71,1.35-2.84,3.52a17,17,0,0,0,.14,4.74c.27,1.22-2.58,3.39-2.71,3.66s-2.43,1.22-1.89,3.25,3,6,3,6.5-2.33,4.23-2.33,4.23S511.12,767.8,510.08,767.61Z",
    style: {
      fill: "url(#d6cc0401-c5a1-440a-bfc1-ce2206550114)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.18,722.37c-6.09-.27-10.56,0-11.78,1.76s-3.12,3.93-4.41,4.47-1.69-1.9-4,1.08-3.25,7.31-3.79,9.75-4.88,5.82-6,6.5-1.35,3.25-1.35,4.06.41-.14,2.44-1.35,3.25-2,5.55-2.3,3.39,1.49,3.39-3.12-1.76-5.28.68-6.36.95-3,4.47-3.52,2.84.41,5-3.12,2.84-4.47,2.84-4.47-1.63-.81,3-.41S589.18,722.37,589.18,722.37Z",
    style: {
      fill: "url(#f758c415-c3a7-4641-bb64-1afd39d4756d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.8,698.94c4.6,5.42,4.2,5.55,3.39,8.4s-1.35,4.33-.81,5.69-.85.41-.63,4.47.83,4.74,1.95,7.18,0,1.22.85-1.63,1.22-.81,1.35-3.93-.54-3.25-.54-5.42-.14-1.22,1.76-4.6,4.33-4.88,1.35-8.4-1.08-4.47-4.6-4.2S483.8,698.94,483.8,698.94Z",
    style: {
      fill: "url(#cb648bb0-4f01-4fd2-b3bc-9ae303641a54)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1157.84,645.77s-3.15,2-5.35,3.29c-.93.53-1.29,2.57-1.29,2.57s-3-1.69-3.49-2a1.64,1.64,0,0,1-.53-.55c-.73-1.27.46-3.33,2.66-4.6,1.89-1.09,3.9-1.24,4.9-.47C1154.9,644.13,1157.84,645.77,1157.84,645.77Z",
    style: {
      fill: "#6e7075"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1154.5,
    cy: 648.7,
    rx: 4.6,
    ry: 2.66,
    transform: "translate(-169.67 664.16) rotate(-30)",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1154.73,
    cy: 648.9,
    rx: 2.32,
    ry: 1.34,
    transform: "translate(-169.74 664.3) rotate(-30)",
    style: {
      fill: "#6e7075"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1169.72 655.06 1156.52 647.5 1152.97 650.33 1166.32 658 1169.72 655.06",
    style: {
      fill: "#6e7075"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1167.99,
    cy: 656.51,
    rx: 2.32,
    ry: 1.34,
    transform: "translate(-171.77 671.95) rotate(-30)",
    style: {
      fill: "#5333ed"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1161.12,651a2.84,2.84,0,0,1,1.55-.79l-3.59-2a2.23,2.23,0,0,0-1.69,1l3.73,1.87Z",
    style: {
      fill: "#6e7075"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1157.39 649.13 1157.39 649.13 1157.39 650.12 1161.12 652.28 1161.12 651.01 1157.39 649.13",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.12,651h0v1.28a3.09,3.09,0,0,1,1.55-.85v-1.22A2.84,2.84,0,0,0,1161.12,651Z",
    style: {
      fill: "#5333ed"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1204.46,615.49c3.17,7,8.35,16.27,9.87,38,0,.38,4.12.66,4.13-.17.12-14-1.59-25.07-4.75-35.38-1-3.42-3.54-6.3-7.08-6.37h0A2.77,2.77,0,0,0,1204.46,615.49Z",
    style: {
      fill: "#ffc398"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.37,654.85l.8-1.47c-.44-1-4.66-.36-5.66.4-.28.22,1.11,1.21,1,1.48a42.42,42.42,0,0,0-1.84,5l-.08,2.26a2,2,0,0,0,1.1-1.65l.52-.62c0,.63-.07,1.09-.07,1.17,0,.27-.2,3.94-.2,3.94l.47,2.64a3.41,3.41,0,0,0,.48-2.51l.33-3.08.22,3,1.13,2.79a3.85,3.85,0,0,0-.16-3l.14-2.81.28,2.8.5,2.79a3.18,3.18,0,0,0,.43-2.81l0-3.84.52,2.67,1,2.1c.61-.86-.11-2.14-.11-2.14l-.29-2.65a14.14,14.14,0,0,0-.15-5A3.87,3.87,0,0,0,1218.37,654.85Z",
    style: {
      fill: "#5333ed"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1210.5,615.45s1.41,6,.6,10.22-1.15,3.09-1.15,3.09-.92-2.83-1.2-3.31Z",
    style: {
      fill: "#ffc398",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1213.8,
    cy: 700.4,
    rx: 4.19,
    ry: 2.42,
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.6,707.49a2,2,0,0,0-2.56.48,2.35,2.35,0,0,0-.42,1.41,3.05,3.05,0,0,0,.87,2.2c.76.91,4.84,4,7.39,4.66a3.24,3.24,0,0,1,1.25.58,7.54,7.54,0,0,0,1.73,1.13l.52-1.28-8.53-5.42-2-2Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.8,717.94c-.49.85-2.45.85-3.93,0s-2.28-2.24-1.79-3.09,3.43-1.35,4.91-.49A2.69,2.69,0,0,1,1216.8,717.94Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.34,708.17c1.57-2.29,3.48-.1,4.49,0,1.45.21,2.65.36,3.57.6a.36.36,0,0,0,.44-.41l-1.19-7.67s7.1-.49,8.33-.32c0,0-.83,10.57-.85,10.9s.31,3.87-.38,5.66c-.22.57-1.38.74-2.3.44h0a66.16,66.16,0,0,1-8.18-3.9,18.06,18.06,0,0,1-3.38-2.78C1202.39,710.11,1201.74,709,1202.34,708.17Z",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211,704.34a2.37,2.37,0,0,1-1.36-1",
    style: {
      fill: "none",
      stroke: "#5333ed",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.34,706.59a2.37,2.37,0,0,1-1.36-1",
    style: {
      fill: "none",
      stroke: "#5333ed",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.66,708.69a2.37,2.37,0,0,1-1.36-1",
    style: {
      fill: "none",
      stroke: "#5333ed",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.29,708.47a2.62,2.62,0,0,0-1.36,1.47",
    style: {
      fill: "none",
      stroke: "#5333ed",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.92,708.37A6.18,6.18,0,0,0,1207,714l-2.56-1.47L1205,707a11.56,11.56,0,0,0,1,.8A4.15,4.15,0,0,0,1207.92,708.37Z",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.39,708.09a2.62,2.62,0,0,0-1.36,1.47",
    style: {
      fill: "none",
      stroke: "#5333ed",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1213.8,
    cy: 700.4,
    rx: 4.19,
    ry: 2.42,
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1213.8,
    cy: 700.23,
    rx: 3.2,
    ry: 1.85,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1209.21 693.62 1210.6 700.4 1217 700.23 1217.57 693.44 1209.21 693.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1213.38,
    cy: 693.44,
    rx: 4.19,
    ry: 2.42,
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1213.38,
    cy: 693.44,
    rx: 3.27,
    ry: 1.89,
    style: {
      fill: "#ffc398"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1201.62,
    cy: 706.89,
    rx: 4.19,
    ry: 2.42,
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.42,714a2,2,0,0,0-2.56.48,2.35,2.35,0,0,0-.42,1.41,3.05,3.05,0,0,0,.87,2.2c.76.91,4.84,4,7.39,4.66a3.24,3.24,0,0,1,1.25.58,7.54,7.54,0,0,0,1.73,1.13l.52-1.28-8.53-5.42-2-2Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.62,724.44c-.49.85-2.45.85-3.93,0s-2.28-2.24-1.79-3.09,3.43-1.35,4.91-.49A2.69,2.69,0,0,1,1204.62,724.44Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.16,714.66c1.57-2.29,3.48-.1,4.49,0,1.45.21,2.65.36,3.57.6a.36.36,0,0,0,.44-.41l-1.19-7.67s7.1-.49,8.33-.32c0,0-.83,10.57-.85,10.9s.31,3.87-.38,5.66c-.22.57-1.38.74-2.3.44h0a66.16,66.16,0,0,1-8.18-3.9,18.06,18.06,0,0,1-3.38-2.78C1190.21,716.6,1189.56,715.54,1190.16,714.66Z",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.8,710.84a2.37,2.37,0,0,1-1.36-1",
    style: {
      fill: "none",
      stroke: "#5333ed",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.17,713.08a2.37,2.37,0,0,1-1.36-1",
    style: {
      fill: "none",
      stroke: "#5333ed",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.48,715.18a2.37,2.37,0,0,1-1.36-1",
    style: {
      fill: "none",
      stroke: "#5333ed",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.12,715a2.62,2.62,0,0,0-1.36,1.47",
    style: {
      fill: "none",
      stroke: "#5333ed",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.21,714.58a2.62,2.62,0,0,0-1.36,1.47",
    style: {
      fill: "none",
      stroke: "#5333ed",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1201.62,
    cy: 706.89,
    rx: 4.19,
    ry: 2.42,
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1201.62,
    cy: 706.72,
    rx: 3.2,
    ry: 1.85,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1197.04 700.11 1198.42 706.89 1204.82 706.72 1205.39 699.93 1197.04 700.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1201.21,
    cy: 699.93,
    rx: 4.19,
    ry: 2.42,
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1201.21,
    cy: 699.93,
    rx: 3.27,
    ry: 1.89,
    style: {
      fill: "#ffc398"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1194.34,670.14c0,.28,3.61,29.79,3.61,29.79h6.53l-1-34Z",
    style: {
      fill: "#ffc398"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.35,664.54c-.53.12,3.77,28.9,3.77,28.9h6.53l-2.12-34.2Z",
    style: {
      fill: "#ffc398"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194.95,675.32a7.77,7.77,0,0,0,3.34.67,9.22,9.22,0,0,0,5.41-1.5l-.26-8.61-9.1,4.33C1194.34,670.29,1194.95,675.32,1194.95,675.32Z",
    style: {
      fill: "#ffc398",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.16,669.4l-.63-10.19-8.35,5.44.55,4.52a6.23,6.23,0,0,0,4.19,1.25A10.08,10.08,0,0,0,1215.16,669.4Z",
    style: {
      fill: "#ffc398",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.11,665h0v0c-.12-.74-1.92-10.88-2.72-15.32a25.58,25.58,0,0,0-2.12-6.24,15.1,15.1,0,0,0-2.46-3.19h0c0-.08-.07-.16-.11-.24-1.53-2.64-6.47-2.64-11.05,0-3.42,2-5.67,4.87-5.95,7.31h0l-.71,5.92a34.9,34.9,0,0,0,0,8.39c.35,2.85,1.07,9.09,1.07,9.09h0c.15,1.84,2.78,3.31,6,3.31s6-1.53,6-3.43h0s0,0,0,0v0c0-.91.55-9.46.55-9.7l.65,4.67h0c.16,1.65,2.52,3,5.41,3s5.43-1.4,5.43-3.13A1.82,1.82,0,0,0,1216.11,665Z",
    style: {
      fill: "#150773"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.52,634.88h0c.34,2.25-1.7,5.27-5.1,7.23-3.94,2.28-8.2,2.27-9.51,0a3,3,0,0,1-.38-1.36s0,.06,0,.1a27.69,27.69,0,0,0,.39,4.76c1.31,2.28,5.57,2.28,9.51,0,3.29-1.9,5.32-4.79,5.13-7A25.44,25.44,0,0,0,1208.52,634.88Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.42,620.24l13.32-7.68h0a2.54,2.54,0,0,1,1.81-.28,5.75,5.75,0,0,1,3.49,2,3,3,0,0,1,.57,2l-.9,17.78h0c.23,2.55-2.09,5.87-5.87,8.06-4.52,2.61-9.4,2.61-10.91,0a3.43,3.43,0,0,1-.44-1.74h0l-3.19-17C1189,622.44,1189.92,621.1,1191.42,620.24Z",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.39,641a5,5,0,0,1,0-2.36l-.64.33a5.69,5.69,0,0,0-.16,2.07Z",
    style: {
      fill: "#dfe9f8",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.22,639.89l-3.15,4.21a53.41,53.41,0,0,0-9.87,13,15.27,15.27,0,0,1-1.61-10.31,4.29,4.29,0,0,1,.91-1.88l-.87-1.16c-2.12,2.63-1.8,8.08-1,10.66a17.24,17.24,0,0,0,2.7,4.86,88.91,88.91,0,0,1,9.31-12.62C1209.21,641.86,1208.22,639.89,1208.22,639.89Z",
    style: {
      fill: "url(#f7c5310a-45c4-42d3-a1c6-d6c312296d29)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1196.92 650.23 1195.48 651.88 1196.2 656.85 1194.14 658.24 1192.33 653.77 1192.33 652.47 1196.11 649.67 1196.92 650.23",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1192.33 653.77 1191.62 651.8 1194.65 648.02 1195.79 648.02 1196.92 650.23 1195.73 650.3 1194.41 651.73 1195.29 655.62 1193.35 656.29 1192.33 653.77",
    style: {
      fill: "#6e7075"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.28,654.16l3.15-2.57.7.09a2.18,2.18,0,0,1,.75.24h0a2.1,2.1,0,0,1,1,2.56l-.09.26a2.1,2.1,0,0,0-.11.94l.24,2.14a2.8,2.8,0,0,1-1.94,3h0a1,1,0,0,1-1.29-.61Z",
    style: {
      fill: "url(#c903bb21-4ae3-414b-bae8-1f127cb7ac8e)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1194.62 648.66 1195.29 650.19 1192.49 653 1192.05 651.82 1194.62 648.66",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1189.25,623.53c.74,7.77,2.13,23.25-22.77,24.85,0,0,.5,2.87,1.31,3,18.46,3.62,26.68-9.68,28.59-16.5a25.68,25.68,0,0,0,.8-6c-.14-3.58-1.28-7.11-4.6-8.33h0A2.77,2.77,0,0,0,1189.25,623.53Z",
    style: {
      fill: "#ffc398"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1162,656.68s-2.15.53-2,1.58l2.56-.84,2.22-1.78c3.51-1.54,4.5-3.34,4.5-3.34h0a2.56,2.56,0,0,0,.52-2c-.12-1.18-1.63-.74-2.31-.67-.12,0-1.67-.68-1.77-.61l-7.94,4.08-.51-.33c-.75.66.61,1.43.61,1.43l2.71-1-1.33.79-.79-.5c-.69,1.16.9,1.64.9,1.64s.2.78.41.92,1.47-.06,1.47-.06l2.89-1.22Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.86,650.36l-1-2.4c-.77-1.55-1.68-1.74-2.82-.65a3.37,3.37,0,0,0-.63,1.27h0a25.36,25.36,0,0,0-3.48.39,8.19,8.19,0,0,1-2.4.14,5.58,5.58,0,0,0-1.53,0l.73.63a2.27,2.27,0,0,0,1.21.53l2,.24s.76,2.37,2.6,2.48c.59.16,1.63-.39,2.41-.82l.84.29A1.62,1.62,0,0,0,1170.86,650.36Z",
    style: {
      fill: "#5333ed"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1193.68,618.94s1.8-.42,4.94,2.54c1.69,1.59,4.9,1,6.49.09a5.9,5.9,0,0,0,2.83-5.46,3.41,3.41,0,0,0-1.21-2.63c-.34-.1-8.83,3-8.83,3Z",
    style: {
      fill: "#ffc398"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1200.96,
    cy: 616.94,
    rx: 3.38,
    ry: 1.95,
    transform: "translate(-147.57 683.13) rotate(-30)",
    style: {
      fill: "#ffc398"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1200.96,
    cy: 611.06,
    rx: 3.38,
    ry: 1.95,
    transform: "translate(-144.63 682.35) rotate(-30)",
    style: {
      fill: "#ffc398"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1197.87 612.25 1197.87 618.11 1204.04 615.78 1204.04 609.89 1197.87 612.25",
    style: {
      fill: "#ffc398"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1206.28,620.64s0-.08,0-.12,0-.06,0-.09a1.57,1.57,0,0,0-.22-2.74,1.55,1.55,0,0,0,.18-.71,1.57,1.57,0,0,0-1.57-1.57,1.56,1.56,0,0,0-.79.22,1.6,1.6,0,0,0-.3-.35,2.29,2.29,0,0,0,.46-1.37h0V608l-6.17,2.35v5.86h0a1.21,1.21,0,0,0,.14.53c.45.78,1.75.9,3.11.38a1,1,0,0,1,.78,1.8,1.57,1.57,0,0,0,1.23,1.53s0,0,0,.07a1.57,1.57,0,0,0,.81,1.37.4.4,0,0,0-.08.19S1206.79,621.13,1206.28,620.64Z",
    style: {
      fill: "#ffc398",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 1199.61,
    cy: 604.43,
    r: 7.43,
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.13,615.22c-.62-.2-7.48-1.21-7.94-10.21l14.86-.83s.07,5.2.29,6.38c.48,2.55-1.48,6.26-3.48,5.47A13.71,13.71,0,0,1,1200.13,615.22Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1203.49,
    cy: 615.58,
    r: 1.57,
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1204.45,
    cy: 618.07,
    r: 1.57,
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1205.67,
    cy: 619.67,
    r: 1.57,
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1206.65,
    cy: 621.24,
    r: 1.57,
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1206.02,
    cy: 622.15,
    r: 1.57,
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1206.65,
    cy: 623.05,
    r: 1.57,
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1206.26,
    cy: 623.91,
    r: 1.57,
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1206.9,
    cy: 625.05,
    r: 1.57,
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.45,625.62c0,.87,0,1.62-.88,1.62a1.57,1.57,0,0,1,0-3.15C1207.44,624.09,1207.45,624.75,1207.45,625.62Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1206.37,
    cy: 618.27,
    r: 1.57,
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1205.62,
    cy: 616.12,
    r: 1.57,
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1206.78,
    cy: 630.93,
    rx: 1.76,
    ry: 1.02,
    transform: "translate(-153.79 687.92) rotate(-30)",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.17,631.61a10,10,0,0,1,.65-4.83l2-.62s.52.62.53,4.07Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.57,627.9c.22.39.95.39,1.62,0s1-1,.81-1.4c0-.06-.06-.39-.12-.43-.31-.23-.93.1-1.5.43-.34.19-.52.23-.66.49A1.2,1.2,0,0,0,1205.57,627.9Z",
    style: {
      fill: "#150773"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.56,625.69a1.37,1.37,0,0,1-1.84,1.29c-.53-.19-.29-2.66.47-2.66A1.37,1.37,0,0,1,1207.56,625.69Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1207.21,
    cy: 625.37,
    r: 1.19,
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203,610.79a15.75,15.75,0,0,1,1.75,2.64,4.5,4.5,0,0,1,0-1.93S1204.42,611.54,1203,610.79Z",
    style: {
      fill: "#5333ed",
      mixBlendMode: "multiply"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#fa9dc424-ee20-4c98-a842-002561a79e29)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71.71,
    y: -97.57,
    width: 1366,
    height: 1046.37,
    style: {
      fill: "url(#26a09dbf-5a8a-4d54-92a9-02879263ae4f)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1130.41,407.37s.63,30.57-38.24,36.32c-10.68,1.58-38.42.52-50,7-30.09,16.84-25.13,51-42,61.73-17.07,10.87-28.74-3.52-47.78,8.57-27.25,17.3-32.87,46.56-62.47,64.7-46.5,28.5-96.13,19-119.5,33.64-12.92,8.09,3.65,16.22-9,24.11-30.57,19.07-77.39,28.89-104.5,45.5-36.8,22.55-32.59,43.14-79.61,64.52-41.18,18.73-86,22.9-86,22.9S442.18,786.43,532,827.69c0,0,73.28,27.77,196.57-15.12s89.39-67.22,89.39-67.22-4.73-10.14,23.35-14.75,66.5-16.89,78.33-31.9,17.49-33.14,37-39.27,86.85,6.56,139.85-24.09,20.72-67.29,20-76.23,2.22-18.66,21.11-21.54,30.55-6.28,28.72-16.58,2-18.53,7.08-22.41,70.09-14.94,49.09-62.91-48.22-53.57-48.22-53.57S1134.4,363.05,1130.41,407.37Z",
    style: {
      fill: "url(#f3a1e253-465c-4dec-92b0-b525d2770c28)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 766.46,
    y1: 638.12,
    x2: 747.6,
    y2: 803.27,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#bc8e1b03-ed38-42ca-90e1-dfcba80a2632)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 602.93,
    y1: 738.43,
    x2: 593.5,
    y2: 835.35,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#6a4b39b0-9c90-43dc-8ccc-b1446beac791)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 952.39,
    y1: 520.99,
    x2: 956.57,
    y2: 627.34,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#87680bcd-2b7e-4725-b202-b05698b9a0ff)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 817.91,
    y1: 741.86,
    x2: 812.18,
    y2: 771.39,
    style: {
      fill: "none",
      stroke: "#0c022f",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1116.42,
    y1: 559.11,
    x2: 1105.02,
    y2: 629.8,
    style: {
      fill: "none",
      stroke: "#0c022f",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1120.24,
    y1: 431.65,
    x2: 1109.19,
    y2: 528.7,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#e8606e81-680f-4148-a9c7-9ea756d8552e)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 736.73,
    y1: 655.94,
    x2: 734.34,
    y2: 707.88,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#a3a94f76-a890-4fcb-a6da-2b14dc3c9be0)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 893.89,
    y1: 583.1,
    x2: 882.33,
    y2: 655.94,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#c695628a-a1f5-4a2f-9eb1-6b22b580a3d4)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1000.17,
    y1: 512.42,
    x2: 997.92,
    y2: 562.34,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#03d0a56f-ca5d-4500-a0f3-c5e39d6011dd)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M440.95,670.92c3.2-8.63,10.5-17.27,21.78-20.27s8.84-.25,16.48-3.43,24.47-12.4,34.35-9.92,16.38,12.07,22.57,17.19,9.61,8.21,14,6c23-11.35,49.16,24.54,45.9,35.28-2.89,9.51-1.65,14.2,4.53,17.16s18.36-1.74,22.1,13.7,1.1,34.1,13.59,35.89,30.93,18.85,31.11,26.59-2.83,13.08-2.14,25.91c.78,14.39-23.82,32.12-52.66,31.8-51.76-.57-81.64-7.15-88-14.56s-3.42-12.65-13.61-13-25.83,2.85-38.48-7.07c-6.67-5.23-12.33-31.81-13.89-44.56s6.88-17.52-.31-21.94c-5.73-3.53-19.71-9.32-19.89-22.61S437.81,679.38,440.95,670.92Z",
    style: {
      fill: "url(#340048f0-4679-4458-a2cf-8026b711e190)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.2,749.39a33.4,33.4,0,0,0,2.13-14c-.57-7.67-3.93-8.65.08-14.66A71,71,0,0,0,469.75,710c2-4,1.67-7.33,2.33-11.33s.39-6,6.53-8.67,2.47,7.67,12.8-4.67,7-12.33,10.33-14.67-6.67-5-8.67,0,2,4.33-4.67,8.67-6,4.33-8.33,5-6-2-8.33,3.33S470.09,696,467.09,698s-6.45,10.33-5.89,13.33,1,7.35-.06,9.34-3,1.33-2.38,5.66-2.09,18.42-2.09,18.42Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#f0620dda-16a3-4016-9b25-82be8e067348)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.61,713s-8.19-1-14.19,0-8.75,4.5-9,5.25-14.08,6.75-18,7.75-9.32,0-10.89,3.75-7.07,12.1-10.32,12.17-2-2.92,0-4.67,2.25-2,4.25-5.5,2.35-8.25,7.92-9.25,8.33-.5,10.33-4,8.75-8.5,13-8.5,6.59-.75,7.92,0,3.83.58,6.83-.33,6.18-5.91,6.18-5.91S596,712.22,600.61,713Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#6c54262f-7a9d-4590-a6af-ab5a2ce32616)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.09,820s-3.67-1.67-1.17-8.33,3.17-6.83,3.17-10.33-3-2,0-5.83,1.83-4.67,5.5-5.33,4.67.83,4,1.33-3.33,1.67-3.5,4.33a20.93,20.93,0,0,0,.17,5.83c.33,1.5-3.18,4.17-3.34,4.5s-3,1.5-2.33,4,3.67,7.33,3.67,8-2.87,5.21-2.87,5.21S517.37,820.26,516.09,820Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#4e1e173d-e95b-401c-87c9-2ee904c0f958)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.42,764.36c-7.5-.33-13,0-14.5,2.17s-3.84,4.83-5.42,5.5-2.08-2.33-4.91,1.33-4,9-4.67,12-6,7.17-7.33,8-1.67,4-1.67,5,.5-.17,3-1.67,4-2.5,6.83-2.83,4.17,1.83,4.17-3.83-2.17-6.5.83-7.83,1.17-3.67,5.5-4.33,3.5.5,6.17-3.83,3.5-5.5,3.5-5.5-2-1,3.67-.5S613.42,764.36,613.42,764.36Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#bf891f5f-266a-4902-a500-e7ef99cca2d1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.75,735.52c5.67,6.67,5.17,6.83,4.17,10.33s-1.67,5.33-1,7-1,.5-.77,5.5,1,5.83,2.4,8.83,0,1.5,1-2,1.5-1,1.67-4.83-.67-4-.67-6.67-.17-1.5,2.17-5.67,5.33-6,1.67-10.33-1.33-5.5-5.67-5.17S483.75,735.52,483.75,735.52Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#a1634d85-6101-4c71-8ee8-797c3629f40b)"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#e20133e7-baf1-40f4-93ab-072cd8f38acd)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 149.17,
    y: 21.95,
    width: 1110.05,
    height: 850.31,
    style: {
      fill: "url(#f24c257e-9719-4b29-b3dc-96240a59a034)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1009.5,432.28s.51,24.84-31.08,29.51c-8.68,1.28-31.22.42-40.63,5.69-24.45,13.69-20.42,41.44-34.13,50.17-13.87,8.83-23.36-2.86-38.83,7-22.14,14.06-26.71,37.84-50.76,52.58C776.28,600.34,736,592.62,717,604.52c-10.5,6.58,3,13.18-7.31,19.59-24.84,15.49-62.89,23.48-84.92,37-29.91,18.33-26.49,35.05-64.69,52.43-33.47,15.22-69.89,18.61-69.89,18.61s-39.93,8.19,33,41.72c0,0,59.55,22.57,159.74-12.28s72.64-54.62,72.64-54.62-3.84-8.24,19-12,54-13.72,63.65-25.92,14.21-26.93,30.05-31.91,70.58,5.33,113.65-19.58,16.84-54.68,16.25-61.95,1.8-15.17,17.15-17.51,24.82-5.11,23.34-13.47,1.62-15.06,5.75-18.21,57-12.14,39.89-51.12-39.18-43.54-39.18-43.54S1012.75,396.26,1009.5,432.28Z",
    style: {
      fill: "url(#8e4d47ed-ef1a-400f-a4b7-cc3a9c765eb4)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 713.75,
    y1: 619.79,
    x2: 698.41,
    y2: 753.99,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#978a5a76-832b-496a-b7b7-d338831c22ab)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 580.86,
    y1: 701.3,
    x2: 573.19,
    y2: 780.07,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#8edf2054-abc1-47d0-86a9-ebc691b566f5)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 864.83,
    y1: 524.61,
    x2: 868.23,
    y2: 611.03,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#07713f3e-cf19-48a1-9dae-64bdcd12f55a)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 755.55,
    y1: 704.09,
    x2: 750.89,
    y2: 728.09,
    style: {
      fill: "none",
      stroke: "#0c022f",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 998.13,
    y1: 555.59,
    x2: 988.87,
    y2: 613.03,
    style: {
      fill: "none",
      stroke: "#0c022f",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1001.24,
    y1: 452.01,
    x2: 992.26,
    y2: 530.87,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#ea76da26-6ec9-4b96-869e-128b9e6ad36f)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 689.58,
    y1: 634.27,
    x2: 687.64,
    y2: 676.48,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#915a2675-dbf4-4307-a7cc-17ddbe93f98c)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 817.3,
    y1: 575.07,
    x2: 807.9,
    y2: 634.27,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#8e0353df-4ec0-41da-bd8a-09a7e5caa15d)"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 903.66,
    y1: 517.64,
    x2: 901.84,
    y2: 558.21,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#c44023c4-df42-4f96-ae2f-ead8f2b6918c)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M883.8,166s96.35,61.22,181.41-29.25",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 6,
      stroke: "url(#6fa6d926-9edb-46f2-9645-ceb43ef5c8bd)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M886.93,419.82s37.84,13.45,66,3.78,24.81-13.38,38.95-12.88,17.39,6.69,38.52,5.49,26.14-8.72,33.19-4.36,11.79,6.16,21.53.2c5.83-3.56,8.37-11.71,11.36-11.75,9.75-.14,6.81-8.87,3.81-13.85-23-38.15-30.88-18.27-29.8-23.84s9.78-7.62,4.35-22.85S1064,327.27,1056.42,317s-.54-7.21-7.58-16.88-6.82-21-26-15.21c-15.47,4.69-36.26,1.19-45.2-8.53-10.91-11.87-39.32-14.65-46.36-7.6s-6.54,11.67-10.88,9.88-4.45-6.75-15.37-11.71-18.33-6-23.69-3.79S886.93,419.82,886.93,419.82Z",
    style: {
      fill: "url(#877b9c12-edb9-495f-8f0b-bcb7933d0924)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.14,362.17S935,365.9,944,365.63s9.75,3.47,10.56,5.66.14,8.16,3.32,8.15,3.18,2.09,4,4.7,3.25.15,7,3.55a15,15,0,0,1,4.88,9.77c.27,2.29,1.9,5.27,3,6.89s-2.1-6.57-.88-7.18,1.68.68,1.11-2.84-1-2.37-2.67-4.13-.61-2-2.3-5.08-1.83-3.45-5-4-3.93-1.22-4.06-2.37,1.29-.68-.95-3-3.39-1.08-4.13-3.18,1-.27-1.22-4.2-4-4.54-5.55-4.81-3.59-1.42-5.76-1.08a5.64,5.64,0,0,1-5-2.23c-.47-.95.07-3.25-3.79-2.1A14.94,14.94,0,0,0,930.14,362.17Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#8e7734aa-4630-47bc-9d79-0d59c0106aa6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.71,283.07s14.69,7.46,11.84,15.58-7.52,8.94-2.44,14.22,8.94,6.91,7.92,9.75-4.67-.2-2.84,5.28,3.17,5.89,3,6.91-2-6.7,0-7.52,2.06.61,2.87-3.25.81-4.06,0-7.11-2.64-3.45-3.86-5.28-3-3.52-1.42-5.42,2.44-2.91,1-5.15-2.44-1.63-1.83-3.25,2.44-2.93,2.44-4.61.31-.69-1.63-3.72-3.46-3.24-3.46-3.24Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#97163096-fd73-4fee-be9f-2eac34aaaf24)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.75,363.66a35.61,35.61,0,0,0-9.24,3.27c-3.86,2.22-2.64,7.91-6.09,7.91s-4.88-2.23-5.89,0a32.22,32.22,0,0,0-2.23,7.52c0,1-.81,5.28,0,6.5s1.63-3.66,1.63-3.66,1-8.9,3.25-8.61.41-.49,5.08,0,6.3-.33,7.31-2.56-2.44-3.45,2.44-4.06,7.24-5.05,7.11-6.3l-.13-1.25Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#a2b96465-73bf-4c6c-bbd5-18e46360bed2)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M848.24,133.86c-7.08-1.77-9.88-9.53-18-10s-13.09,9-20.27,11.91c-6.58,2.64-48.46,32.67-55.43,37.68l.05,0-11.3,7.49A14.65,14.65,0,0,0,736.48,191a51.56,51.56,0,0,1-2.39,8.88L733,202.95a13.7,13.7,0,0,0,5.36,16.27c.09.06,5,1.88,10.94,4.11a13.58,13.58,0,0,0-11.82,9.46c-.08.28-3.18,35.6-3.18,35.6a25.29,25.29,0,0,0,7.28,24.22l5.9,5.55-4.08,2.49a14.65,14.65,0,0,0-6.82,10.07,51.56,51.56,0,0,1-2.39,8.88L733,322.71c-2.17,6,.24,12.46,5.36,16.27,4.76,3.54,8.63,13.54,7.7,21a35.23,35.23,0,0,0,1.77,17.19c-6.28,6.07-10.27,16.45-6.45,30.27,2,7.29-.38,17.74-4.57,21.93s125.16,5.13,151.87,5.31a17.1,17.1,0,0,0,8.9-2.43h0a14.65,14.65,0,0,0,6.91-10,51.56,51.56,0,0,1,2.47-8.86l1.15-3.1c2.22-6-.13-12.46-5.23-16.32-4.73-3.58-8.52-13.61-7.52-21.1a35.23,35.23,0,0,0-1.62-17.2c6.33-6,10.41-16.36,6.71-30.21-1.95-7.31.53-17.74,4.76-21.89,4.56-4.48,6.06-11.19,3.09-16.85l-1.54-2.93a51.57,51.57,0,0,1-3.58-8.47,14.65,14.65,0,0,0-8.13-9l-4.87-2.12a27.3,27.3,0,0,0,5.39-10.31,93.37,93.37,0,0,1,4.09-11.77l1.74-4.17c3.36-8.05,2.22-16.58-3.1-20.13-.09-.06-4.5-1.5-10.13-3.32L888,183a7.9,7.9,0,0,1,1-.71s10.84-15-1.12-31a40.51,40.51,0,0,0-6.33-6.62C860.09,126.5,855.31,135.63,848.24,133.86Z",
    style: {
      fill: "url(#1a7e7864-f451-41d4-a4fa-050775f0c193)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "771.24 235.9 811.3 212.93 844.35 232.1 844.35 435.32 804.29 458.29 771.24 439.11 771.24 235.9",
    style: {
      fill: "#3a2baf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "804.29 255.07 844.35 232.1 844.35 435.32 804.29 458.29 804.29 255.07",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "536.51 405.75 798.46 254.93 798.46 454.87 536.51 605.7 536.51 405.75",
    style: {
      fill: "url(#cc4b48e4-0a90-44e4-9c49-f5c89e462530)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 428.24,
    width: 1.63,
    height: 158.71,
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 548.95,
    y: 428.24,
    width: 1.63,
    height: 158.71,
    style: {
      fill: "url(#52e99a3a-b6d4-4fd4-8507-9427bcf6bacb)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M553.3,490.68c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07A4.44,4.44,0,0,0,545.9,495c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a4.54,4.54,0,0,0,.44-.21,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,553.3,490.68Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.45,491.59a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,554.45,491.59Z",
    style: {
      fill: "url(#9bc70b7d-b240-4087-bb33-42f1fd08ff54)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M553.3,461.94c.72-1.24,2.56-2.63,2.84-3.84L555,457.2a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,553.3,461.94Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.45,462.85a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,554.45,462.85Z",
    style: {
      fill: "url(#91730566-6812-4942-9e33-07d1682a954d)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M553.3,549.65c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a4.54,4.54,0,0,0,.44-.21,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,553.3,549.65Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.45,550.56a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,554.45,550.56Z",
    style: {
      fill: "url(#fc6b238f-00c6-47d3-a7cf-0cc4f4318b05)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M553.3,582.89c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a4.54,4.54,0,0,0,.44-.21,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,553.3,582.89Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.45,583.8a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,554.45,583.8Z",
    style: {
      fill: "url(#c4a5a206-76b5-4e1d-87aa-53829a95bb62)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M553.3,520.91c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a4.54,4.54,0,0,0,.44-.21,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,553.3,520.91Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.45,521.82a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,554.45,521.82Z",
    style: {
      fill: "url(#87e5edcf-81b6-4f5f-acb0-8d26b4adfb12)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M552.93,424.4a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17c1.06-1.84,3.15-3.84,3.49-5.61l-1.25-.68a17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a10.27,10.27,0,0,0-.22-3.83l-1.25-.68c-.18.4-.34.81-.49,1.21l-1-.37A15.48,15.48,0,0,0,546,423.8c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38l1.25.68c1.14.05,2-.86,3.4-1.66a14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05c1.63-.94,4.62-2,5.9-3.7l-1.25-.68A6.45,6.45,0,0,0,552.93,424.4Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.18,425.08a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17,17.64,17.64,0,0,0,2.24-6.29,17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a6.45,6.45,0,0,0-1.47-4.51,18.51,18.51,0,0,0-.73,1.92,4.74,4.74,0,0,0-.73-1.08,15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38,6.45,6.45,0,0,0,4.65-1,14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05,15.47,15.47,0,0,0,4.65-4.38A6.45,6.45,0,0,0,554.18,425.08Z",
    style: {
      fill: "url(#d225a2c9-0db1-4fe7-ae5e-c3065ee4f861)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 787.08,
    y: 294.15,
    width: 1.63,
    height: 158.71,
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 788.02,
    y: 294.15,
    width: 1.63,
    height: 158.71,
    style: {
      fill: "url(#6574283c-27f8-41bf-8ed5-874eb15604ce)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M792.37,356.6c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,792.37,356.6Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.52,357.5a13.3,13.3,0,0,0,1.69-4.74A13.3,13.3,0,0,0,792,356.6a14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,3.77,3.77,0,0,0,1.69,2.79,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31h0l.08-.06a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,793.52,357.5Z",
    style: {
      fill: "url(#8126f6e8-cd69-4be3-979e-de0f22600cfe)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M792.37,327.86c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91A13.3,13.3,0,0,0,790.8,327a14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31h0l.08-.06a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,792.37,327.86Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.52,328.77a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,3.77,3.77,0,0,0,1.69,2.79,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,793.52,328.77Z",
    style: {
      fill: "url(#9893b6f0-e9c4-482b-9029-9da706b0e3ca)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M792.37,415.56c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,792.37,415.56Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.52,416.47a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,793.52,416.47Z",
    style: {
      fill: "url(#6f68d9e5-ff9b-4806-9dc2-4bc682c1ef6a)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M792.37,448.81c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,792.37,448.81Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.52,449.71a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,793.52,449.71Z",
    style: {
      fill: "url(#ba0e71f5-f089-46a0-91d4-c7574a0b7e6d)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M792.37,386.83c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07A4.44,4.44,0,0,0,785,391.1c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,792.37,386.83Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.52,387.74a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,793.52,387.74Z",
    style: {
      fill: "url(#21cc8364-bd86-4429-8978-552974e9a4a3)"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 666.01,
    y1: 422,
    x2: 666.01,
    y2: 388.9,
    style: {
      fill: "none",
      stroke: "#191399",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M596.08,473.56l-13.49,7.79a2.94,2.94,0,0,1-4.41-2.55l4.53-57.38c0-5-7-6.43-8.94-5.3l-14.28,8.25a2.94,2.94,0,0,0-1.47,2.55v86.81c0,5.84,3.27,7.21,8.64,5.91l11.52-12.46,15-8.64a2.94,2.94,0,0,1,4.41,2.55v33.16c0,2.26,3.14,7.09,8.47,6l10.23-11.67a2.94,2.94,0,0,0,1.47-2.55V461.07l4.53-62.48c0-6.25-7-6.42-8.94-5.29L599,401.55a2.94,2.94,0,0,0-1.47,2.55V471A2.94,2.94,0,0,1,596.08,473.56Z",
    style: {
      fill: "#3a2baf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.35,313.56v66.93a2.94,2.94,0,0,1-1.47,2.55l-13.49,7.79a2.94,2.94,0,0,1-4.41-2.55l4.56-56.94a6.11,6.11,0,0,0-9-5.74l-14.28,8.25a2.94,2.94,0,0,0-1.47,2.55V423.2c0,4,4,8.38,8.7,5.88L735,416.65l15-8.64a2.94,2.94,0,0,1,4.41,2.55v33.16c0,4.3,4,8.23,9,5.74L773,438a2.94,2.94,0,0,0,1.47-2.55V370.54l4.56-62.44c0-5.52-6.21-7-9-5.33L755.82,311A2.94,2.94,0,0,0,754.35,313.56Z",
    style: {
      fill: "#3a2baf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.25,367.93l-18.69,10.79a2.94,2.94,0,0,0-1.47,2.55V511.43a6.62,6.62,0,0,0,8.48,6l11.69-12.52,19.37-11.18,18.69-10.79a2.94,2.94,0,0,0,1.47-2.55v-112l4.56-15c0-5.92-5.18-7.66-9-5.74l-15.75,9.1Zm17.9,103.33L661.66,479a2.94,2.94,0,0,1-4.41-2.55V392.91a2.94,2.94,0,0,1,1.47-2.55l13.49-7.79a2.94,2.94,0,0,1,4.41,2.55v83.59A2.94,2.94,0,0,1,675.15,471.26Z",
    style: {
      fill: "#3a2baf"
    }
  })), /*#__PURE__*/React.createElement("line", {
    x1: 667.68,
    y1: 502,
    x2: 667.68,
    y2: 530.87,
    style: {
      fill: "none",
      stroke: "#191399",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M600.65,476.76l-13.49,7.79a2.94,2.94,0,0,1-4.41-2.55V421.87a2.94,2.94,0,0,0-4.41-2.55l-14.28,8.25a2.94,2.94,0,0,0-1.47,2.55v86.81a2.94,2.94,0,0,0,4.41,2.55l15.75-9.1,15-8.64a2.94,2.94,0,0,1,4.41,2.55v33.16a2.94,2.94,0,0,0,4.41,2.55l14.28-8.25a2.94,2.94,0,0,0,1.47-2.55V399a2.94,2.94,0,0,0-4.41-2.55l-14.28,8.25a2.94,2.94,0,0,0-1.47,2.55v66.93A2.94,2.94,0,0,1,600.65,476.76Z",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.92,316.76v66.93a2.94,2.94,0,0,1-1.47,2.55L744,394a2.94,2.94,0,0,1-4.41-2.55V331.34a2.94,2.94,0,0,0-4.41-2.55L720.86,337a2.94,2.94,0,0,0-1.47,2.55V426.4a2.94,2.94,0,0,0,4.41,2.55l15.75-9.1,15-8.64a2.94,2.94,0,0,1,4.41,2.55v33.16a2.94,2.94,0,0,0,4.41,2.55l14.28-8.25a2.94,2.94,0,0,0,1.47-2.55V308.51a2.94,2.94,0,0,0-4.41-2.55l-14.28,8.25A2.94,2.94,0,0,0,758.92,316.76Z",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.82,371.12l-18.69,10.79a2.94,2.94,0,0,0-1.47,2.55V514.62a2.94,2.94,0,0,0,4.41,2.55l15.75-9.1,19.37-11.18,18.69-10.79a2.94,2.94,0,0,0,1.47-2.55V353.39a2.94,2.94,0,0,0-4.41-2.55l-15.75,9.1Zm17.9,103.33-13.49,7.79a2.94,2.94,0,0,1-4.41-2.55V396.11a2.94,2.94,0,0,1,1.47-2.55l13.49-7.79a2.94,2.94,0,0,1,4.41,2.55v83.59A2.94,2.94,0,0,1,679.72,474.45Z",
    style: {
      fill: "#2cd4d9"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "666.01 331.05 666.01 362.77 671.5 365.53 671.5 389.47",
    style: {
      fill: "none",
      stroke: "#191399",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "666.01 420.63 666.01 476.49 671.5 479.26 671.5 503.2",
    style: {
      fill: "none",
      stroke: "#191399",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M647.64,345.78c0,12.67-7.43,28.86-18.4,35.19-7,4-13.38,4.93-18.53-.74-2.13-2.34-2.8-6.91-2.8-11.52,0-12.67,8.89-28.07,19.87-34.41S647.64,333.11,647.64,345.78Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.28,335.7l5.84-14.88a12,12,0,0,1,1.61,1.58l3.09,6.44L624.54,336A3,3,0,0,1,622.28,335.7Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.35,386.94l3.14,4.46a13.88,13.88,0,0,0,3.1,3.18h0l5-13-1.81-1.34-9.16,5.29A1,1,0,0,0,623.35,386.94Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.78,339.25l6.5.58a8,8,0,0,1,4,1.54h0l-8.74,10.87-1.81-1.34Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.78,363.56l-10,12.62a8.49,8.49,0,0,0,2.54.31l6.93-.56L607,365.63A4.2,4.2,0,0,0,605.78,363.56Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.87,352.65l-2.24-8.35,8.68-2.33a2.28,2.28,0,0,1,1.95.37l.92.68-7.13,12.36-.64-.48A4.14,4.14,0,0,1,607.87,352.65Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "639.33 371.94 641.13 373.27 649.07 369.33 648.27 360.92 646.46 359.58 639.33 371.94",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639,329.69l11-9.54a3.19,3.19,0,0,1,.59,2.23l-4.42,11.42-5.75-2.44A3.06,3.06,0,0,1,639,329.69Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.1,383.4l-2.46,12a5,5,0,0,0,2.27-.78l9.28-6.53-1.81-1.34L608.89,383A.53.53,0,0,0,608.1,383.4Z",
    style: {
      fill: "#5333ed"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M649.33,347.19c0,12.67-8.89,28.07-19.87,34.41s-19.87,1.2-19.87-11.47,8.89-28.07,19.87-34.41S649.33,334.52,649.33,347.19Z",
    style: {
      fill: "url(#3f818ae9-b675-4790-94d1-8a144008856a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.42,336.06l5.2-13.6,4.46,7.17a.68.68,0,0,1-.22,1Z",
    style: {
      fill: "url(#2516b905-f280-4a7f-aca4-4e328f62807e)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "624.42 387.47 629.46 394.64 634.51 381.64 624.42 387.47",
    style: {
      fill: "url(#921e206e-e3b8-4805-8c82-222d5f4c818e)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "650.47 340.66 659.21 341.44 650.47 352.31 650.47 340.66",
    style: {
      fill: "url(#84b11a00-ffad-48b6-a9b9-69622d98ac39)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "606.89 365.7 598.15 376.57 606.89 377.35 606.89 365.7",
    style: {
      fill: "url(#3d2ede0d-b634-460e-a157-4119f03511e0)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "609.93 355.45 607.32 345.71 617.07 343.1 609.93 355.45",
    style: {
      fill: "url(#67817f50-1caa-4c57-9d5d-203d5d9a9ccf)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "641.01 373.34 650.76 370.73 648.15 360.98 641.01 373.34",
    style: {
      fill: "url(#89fd671f-690b-4d83-8c2e-851ef93f4982)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "640.3 331.44 650.47 322.46 647.86 335.22 640.3 331.44",
    style: {
      fill: "url(#ff75ce77-7ee5-4c6c-a3fe-7502dff28e8a)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "609.93 384.08 607.79 394.72 617.07 388.19 609.93 384.08",
    style: {
      fill: "url(#d19616e4-f720-4042-96be-8f3b050deec9)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M724.85,301.34c0,12.67-7.43,28.86-18.4,35.19-7,4-13.38,4.93-18.53-.74-2.13-2.34-2.8-6.91-2.8-11.52,0-12.67,8.89-28.07,19.87-34.41S724.85,288.68,724.85,301.34Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.49,291.26l5.84-14.88a12,12,0,0,1,1.61,1.58l3.09,6.44-8.28,7.16A3,3,0,0,1,699.49,291.26Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.56,342.5l3.14,4.46a13.88,13.88,0,0,0,3.1,3.18h0l5-13L710,335.8l-9.16,5.29A1,1,0,0,0,700.56,342.5Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726,294.82l6.5.58a8,8,0,0,1,4,1.54h0L727.8,307.8,726,306.47Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683,319.13l-10,12.62a8.49,8.49,0,0,0,2.54.31l6.93-.56,1.81-10.31A4.2,4.2,0,0,0,683,319.13Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.08,308.21l-2.24-8.35,8.68-2.33a2.28,2.28,0,0,1,1.95.37l.92.68-7.13,12.36-.64-.48A4.14,4.14,0,0,1,685.08,308.21Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "716.54 327.5 718.34 328.84 726.28 324.89 725.48 316.48 723.67 315.14 716.54 327.5",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.25,285.26l11-9.54a3.19,3.19,0,0,1,.59,2.23l-4.42,11.42-5.75-2.44A3.06,3.06,0,0,1,716.25,285.26Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.31,339l-2.46,12a5,5,0,0,0,2.27-.78l9.28-6.53-1.81-1.34-6.49-3.75A.53.53,0,0,0,685.31,339Z",
    style: {
      fill: "#5333ed"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M726.54,302.75c0,12.67-8.89,28.07-19.87,34.41s-19.87,1.2-19.87-11.47,8.89-28.07,19.87-34.41S726.54,290.08,726.54,302.75Z",
    style: {
      fill: "url(#8f693be7-2592-41a0-b31a-f64758f4e297)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.63,291.62l5.2-13.6,4.46,7.17a.68.68,0,0,1-.22,1Z",
    style: {
      fill: "url(#bcec5291-3d67-4599-b8d7-279c66c75057)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "701.63 343.03 706.67 350.21 711.72 337.2 701.63 343.03",
    style: {
      fill: "url(#02b10fc2-c1c0-4144-a638-56b4014108ed)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "727.68 296.22 736.42 297 727.68 307.87 727.68 296.22",
    style: {
      fill: "url(#efa6b0c3-6d6c-4591-954f-dd75ea5b42e6)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "684.1 321.26 675.36 332.13 684.1 332.91 684.1 321.26",
    style: {
      fill: "url(#9112ba91-1a34-4c30-bc56-0910add3b265)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "687.14 311.02 684.53 301.27 694.28 298.66 687.14 311.02",
    style: {
      fill: "url(#a4d9f7ba-2af6-4597-b0b8-61c89eda5208)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "718.22 328.9 727.97 326.29 725.36 316.55 718.22 328.9",
    style: {
      fill: "url(#06ac836a-ce44-40e6-adc4-f426e053f040)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "717.51 287 727.68 278.02 725.07 290.78 717.51 287",
    style: {
      fill: "url(#de35fc46-6571-41be-9eb9-c94f020557cc)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "687.14 339.64 685 350.29 694.28 343.76 687.14 339.64",
    style: {
      fill: "url(#f05fb7c1-02dc-4691-9299-0ec1912346ad)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M660.67,362.08s-10.22-1.9-11.34-2.76.08-3.13.08-3.13l.58-.95a1.22,1.22,0,0,1,1.75-.06l9.78,6.34A.93.93,0,0,1,660.67,362.08Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.39,355.7l-.76,2.13a.82.82,0,0,0,.54,1.07l10.32,3a.92.92,0,0,0,1.15-.65h0a.92.92,0,0,0-.46-1l-9.44-5A1,1,0,0,0,650.39,355.7Z",
    style: {
      fill: "url(#8d12bae7-6546-4a3d-ace7-0e4f050a7c32)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.92,379.55s-1-1.16-1.83-.59c-.19.13-8.88,9.37-11.07,11.66a2,2,0,0,0-.57,1.64c.08.55.42,1,1.46.86l12.74-12.39Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.07,379.73c.27.45.58,1,.86,1.48a1.77,1.77,0,0,1-.46,2.28L594.15,393a.72.72,0,0,1-1-.16h0a.72.72,0,0,1,.06-.91l11.47-12.34A.89.89,0,0,1,606.07,379.73Z",
    style: {
      fill: "url(#3d40e1fa-6c0d-4e68-a56b-d021f10e60ae)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.36,317.33s-10.22-1.9-11.34-2.76.08-3.13.08-3.13l.58-.95a1.22,1.22,0,0,1,1.75-.06l9.78,6.34A.93.93,0,0,1,738.36,317.33Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.08,311l-.76,2.13a.82.82,0,0,0,.54,1.07l10.32,3a.92.92,0,0,0,1.15-.65h0a.92.92,0,0,0-.46-1l-9.44-5A1,1,0,0,0,728.08,311Z",
    style: {
      fill: "url(#792f2d07-e6af-4376-950c-61466021a52f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.33,334.62s-.51-.94-1.2-.59c-.21.11-9.24,9.55-11.42,11.84a2,2,0,0,0-.57,1.64c.08.55.42,1,1.46.86L684.34,336Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.76,335c.27.45.58,1,.86,1.48a1.77,1.77,0,0,1-.46,2.28l-12.32,9.5a.72.72,0,0,1-1-.16h0a.72.72,0,0,1,.06-.91l11.47-12.34A.89.89,0,0,1,683.76,335Z",
    style: {
      fill: "url(#e14dc49b-e00c-4195-885a-226534a8e12d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.57,396.82l-.44-.44a1.57,1.57,0,0,0-1.79-.3c-1,.47-2.39,1.18-3.42,1.71a1.9,1.9,0,0,0-1,2l1.7,9.8L628.9,415s.33,1.56,2.4,1.13Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628,398.69c1-.59,2.68-1.47,3.73-2a.67.67,0,0,1,1,.61L632.23,415a1.09,1.09,0,0,1-.75,1h0a1.09,1.09,0,0,1-1.4-.83l-2.87-14.82A1.61,1.61,0,0,1,628,398.69Z",
    style: {
      fill: "url(#f3da74d3-37ac-4abc-9233-e4d97d85806c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711,352.34l-.44-.44a1.57,1.57,0,0,0-1.79-.3c-1,.47-2.39,1.18-3.42,1.71a1.9,1.9,0,0,0-1,2l1.7,9.8,1.29,5.35s.33,1.56,2.4,1.13Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.42,354.21c1-.59,2.68-1.47,3.73-2a.67.67,0,0,1,1,.61l-.49,17.79a1.09,1.09,0,0,1-.75,1h0a1.09,1.09,0,0,1-1.4-.83l-2.87-14.82A1.61,1.61,0,0,1,706.42,354.21Z",
    style: {
      fill: "url(#c40d2838-19fc-4f71-8bc2-b5201ce73060)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 588.08,
    y: 406.26,
    width: 1.63,
    height: 67.04,
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.03,
    y: 406.26,
    width: 1.63,
    height: 67.04,
    style: {
      fill: "url(#562a9a7a-7638-48a7-b03e-9ccfee3fee5e)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M593.38,468.7c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07A4.44,4.44,0,0,0,586,473c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a4.54,4.54,0,0,0,.44-.21,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,593.38,468.7Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.53,469.61a13.3,13.3,0,0,0,1.69-4.74A13.3,13.3,0,0,0,593,468.7a14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,594.53,469.61Z",
    style: {
      fill: "url(#499f0eba-01fc-46c3-8004-86903303bd18)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M593.38,440c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a4.54,4.54,0,0,0,.44-.21,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,593.38,440Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.53,440.87a13.3,13.3,0,0,0,1.69-4.74A13.3,13.3,0,0,0,593,440a14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,594.53,440.87Z",
    style: {
      fill: "url(#3d1b376f-2dfa-44a5-9b0a-33c43b1e35d2)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M593,402.42a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17c1.06-1.84,3.15-3.84,3.49-5.61l-1.25-.68a17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a10.27,10.27,0,0,0-.22-3.83l-1.25-.68c-.18.4-.34.81-.49,1.21l-1-.37a15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38l1.25.68c1.14.05,2-.86,3.4-1.66a14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05c1.63-.94,4.62-2,5.9-3.7l-1.25-.68A6.45,6.45,0,0,0,593,402.42Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.26,403.11a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17,17.64,17.64,0,0,0,2.24-6.29,17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a6.45,6.45,0,0,0-1.47-4.51,18.51,18.51,0,0,0-.73,1.92,4.74,4.74,0,0,0-.73-1.08,15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38,6.45,6.45,0,0,0,4.65-1,14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05,15.47,15.47,0,0,0,4.65-4.38A6.45,6.45,0,0,0,594.26,403.11Z",
    style: {
      fill: "url(#0e1127ee-4742-48d8-abd6-cc1e3f16f172)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 744.62,
    y: 316.13,
    width: 1.63,
    height: 67.04,
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.57,
    y: 316.13,
    width: 1.63,
    height: 67.04,
    style: {
      fill: "url(#57f72219-d701-4e94-b80d-88fb83a9b25d)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M749.92,378.58c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31h0l.08-.06a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,749.92,378.58Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.07,379.48a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,751.07,379.48Z",
    style: {
      fill: "url(#1ba9cca0-98fb-496b-a2d8-feb09b7d1245)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M749.92,349.84c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,749.92,349.84Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.07,350.75a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,3.77,3.77,0,0,0,1.69,2.79,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,751.07,350.75Z",
    style: {
      fill: "url(#562926de-a7bc-4879-9493-336b7f5972ee)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M749.55,312.3a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17c1.06-1.84,3.15-3.84,3.49-5.61l-1.25-.68a17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a10.27,10.27,0,0,0-.22-3.83l-1.25-.68c-.18.4-.34.81-.49,1.21l-1-.37a15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38l1.25.68c1.14.05,2-.86,3.4-1.66a14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0h0l.09,0a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05c1.63-.94,4.62-2,5.9-3.7l-1.25-.68A6.45,6.45,0,0,0,749.55,312.3Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.8,313a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17,17.64,17.64,0,0,0,2.24-6.29,17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a6.45,6.45,0,0,0-1.47-4.51,18.51,18.51,0,0,0-.73,1.92,4.74,4.74,0,0,0-.73-1.08,15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38,6.45,6.45,0,0,0,4.65-1,14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05,15.47,15.47,0,0,0,4.65-4.38A6.45,6.45,0,0,0,750.8,313Z",
    style: {
      fill: "url(#c9d3a150-864d-4ff6-a20e-63a630843aee)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M588.14,518.9h0l-8.92,5.15.84-3.3a2.15,2.15,0,0,0-3.14-1.69h0a5.09,5.09,0,0,0-2.3,4v.09l-1.15.67a2.68,2.68,0,0,0-1.21,2.1v1.5l.84.5c.47-.27.1-1.42.2-2l1.32-.6v1.39l-8.91,5.14h0l-5.78,7.2.84.5c2.89-.35,6.16-2.63,9.22-5.55h0a10.14,10.14,0,0,0,4.68-.74c.06.8.16,1.47.3,2.85l0,.21-.61.35a1.72,1.72,0,0,0-.74,1.07l-.69.4-1.24,0h-.06l0,0,0,0,0,0,0,0L571,539a.34.34,0,0,0-.07.37,1.17,1.17,0,0,0,.18.11l-.27.48a.34.34,0,0,0-.07.37,5.58,5.58,0,0,0,.49.4.22.22,0,0,0,.07.29c.09.08.82.49.82.49l.75-1.41.63-1s.52-.39.87-.6l1-.56.1.43a2.67,2.67,0,0,0,.05.31l-1.29,6.67.84.5,4.53-3.61L578.31,537c0-.12,0-.25.05-.37l.1-.54,1-.57a1.72,1.72,0,0,0,.74-1.07l.71.21,1-.44.3.38c.06.08.19,0,.29-.09h0c.1-.13.62-.22.56-.3l-.51-.3a4.08,4.08,0,0,0,1.31-.51l-.64-.35c.06-.15.47-.18.53-.32s-.93-.61-.93-.61l-.53-.06h-.06l0,0,0,0,0,0,0,0-1.24,1.4-.69.4c-.09-.32-.38-.42-.74-.22l-.64.37,0-.26c.14-1.53.24-2.32.3-3.18a27.28,27.28,0,0,0,4.71-4.7,21.64,21.64,0,0,0,10.91-6.07l-.84-.5Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589,519.4h0l-8.92,5.15v-3.66c0-1.47-1-2.06-2.3-1.33h0a5.09,5.09,0,0,0-2.3,4v.09l-1.15.67a2.68,2.68,0,0,0-1.21,2.1v1.5l.09,0a2.21,2.21,0,0,0,1-1.43l1.32-.6v1.39l-8.91,5.14h0l-5.78,7.2c3.09-.09,6.7-1.84,10.07-5.05h0a10.11,10.11,0,0,0,4.68-.73c.06.8.16,1.47.3,2.85l0,.21-.61.35a1.72,1.72,0,0,0-.74,1.07l-.69.4-1.24,0h-.06l0,0,0,0,0,0,0,0-.53.67a.34.34,0,0,0-.07.37c.06.08.19,0,.29-.08l.44-.55h.5l-.7.48a.41.41,0,0,0-.1.1l-.52.66a.34.34,0,0,0-.07.37c.06.08.19,0,.29-.08l.49-.63.57-.39-.46.59h0l0,.07,0,0h0l-.33.8c-.06.15,0,.28.07.29s.23-.09.29-.24l.3-.73,1.13-1.44.63-.36c.09.32.38.42.74.22l1-.56.1.43a2.67,2.67,0,0,0,.05.31l-1.29,6.67,5.38-3.1-1.29-5.18c0-.12,0-.25.05-.37l.1-.54,1-.57A1.72,1.72,0,0,0,581,535l.63-.36,1.13.14.3.38c.06.08.19,0,.29-.09h0a.34.34,0,0,0,.07-.37l-.33-.41h0l0,0h0l-.46-.06.57-.26.49.06c.1,0,.23-.1.29-.25h0c.06-.15,0-.28-.07-.29l-.52-.06a.15.15,0,0,0-.1,0l-.7.33.5-.57.44,0c.1,0,.23-.1.29-.25s0-.28-.07-.29l-.53-.06h-.06l0,0,0,0,0,0,0,0-1.24,1.4-.69.4c-.09-.32-.38-.42-.74-.22l-.64.37,0-.26c.14-1.53.24-2.32.3-3.18a27.28,27.28,0,0,0,4.71-4.7c3.37-.67,7-3.09,10.07-6.57Z",
    style: {
      fill: "url(#3bccb5bd-59b6-4141-9265-51e33fbbac9b)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M576.21,389.56h0l-8.92,5.15.84-3.3a2.15,2.15,0,0,0-3.14-1.69h0a5.09,5.09,0,0,0-2.3,4v.09l-1.15.67a2.68,2.68,0,0,0-1.21,2.1v1.5l.84.5c.47-.27.1-1.42.2-2l1.32-.6v1.39l-8.91,5.14h0l-5.78,7.2.84.5c2.89-.35,6.16-2.63,9.22-5.55h0a10.11,10.11,0,0,0,4.68-.73c.06.8.16,1.47.3,2.85l0,.21-.61.35a1.72,1.72,0,0,0-.74,1.07l-.69.4-1.24,0h-.06l0,0,0,0,0,0,0,0-.53.67a.34.34,0,0,0-.07.37,1.17,1.17,0,0,0,.18.11l-.27.48a.34.34,0,0,0-.07.37,5.58,5.58,0,0,0,.49.4.22.22,0,0,0,.07.29c.09.08.82.49.82.49l.75-1.41.63-1s.52-.39.87-.6l1-.56.1.43a2.67,2.67,0,0,0,.05.31L562.3,416l.84.5,4.53-3.61-1.29-5.18c0-.12,0-.25.05-.37l.1-.54,1-.57a1.72,1.72,0,0,0,.74-1.07l.71.21,1-.44.3.38c.06.08.19,0,.29-.09h0c.1-.13.62-.22.56-.3l-.51-.3a4.08,4.08,0,0,0,1.31-.51l-.64-.35c.06-.15.47-.18.53-.32s-.93-.61-.93-.61l-.53-.06h-.06l0,0,0,0,0,0,0,0-1.24,1.4-.69.4c-.09-.32-.38-.42-.74-.22l-.64.37,0-.26c.14-1.53.24-2.32.3-3.18a27.28,27.28,0,0,0,4.71-4.7,21.64,21.64,0,0,0,10.91-6.07l-.84-.5Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.05,390.06h0l-8.92,5.15v-3.66c0-1.47-1-2.06-2.3-1.33h0a5.09,5.09,0,0,0-2.3,4v.09l-1.15.67a2.68,2.68,0,0,0-1.21,2.1v1.5l.09,0a2.21,2.21,0,0,0,1-1.43l1.32-.6v1.39L554.62,403h0l-5.78,7.2c3.09-.09,6.7-1.84,10.07-5.05h0a10.11,10.11,0,0,0,4.68-.73c.06.8.16,1.47.3,2.85l0,.21-.61.35a1.72,1.72,0,0,0-.74,1.07l-.69.4-1.24,0h-.06l0,0,0,0,0,0,0,0-.53.67a.34.34,0,0,0-.07.37c.06.08.19,0,.29-.08l.44-.55h.5l-.7.48a.41.41,0,0,0-.1.1l-.52.66a.34.34,0,0,0-.07.37c.06.08.19,0,.29-.08l.49-.63.57-.39-.46.59h0l0,.08,0,0h0l-.33.8c-.06.15,0,.28.07.29s.23-.09.29-.24l.3-.73,1.13-1.44.63-.36c.09.32.38.42.74.22l1-.56.1.43a2.67,2.67,0,0,0,.05.31l-1.29,6.67,5.38-3.1-1.29-5.18c0-.12,0-.25.05-.37l.1-.54,1-.57a1.72,1.72,0,0,0,.74-1.07l.63-.36,1.13.14.3.38c.06.08.19,0,.29-.09h0a.34.34,0,0,0,.07-.37l-.33-.41h0l0,0h0l-.46-.06.57-.26.49.06c.1,0,.23-.1.29-.25h0c.06-.15,0-.28-.07-.29l-.52-.06a.15.15,0,0,0-.1,0l-.7.33.5-.57.44,0c.1,0,.23-.1.29-.25s0-.28-.07-.29l-.53-.06h-.06l0,0,0,0,0,0,0,0-1.24,1.4-.69.4c-.09-.32-.38-.42-.74-.22l-.64.37,0-.26c.14-1.53.24-2.32.3-3.18a27.28,27.28,0,0,0,4.71-4.7c3.37-.67,7-3.09,10.07-6.57Z",
    style: {
      fill: "url(#90cf597e-f19a-4d53-8e22-c8fa0c11430d)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M630,486.46l-.61.19a2.45,2.45,0,0,1-3-2.51V435.85a4.57,4.57,0,0,1,2.27-3.95h0a2.55,2.55,0,0,1,3.61,1.17l.14.32Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,486l-.3.17a2,2,0,0,1-3-1.71V436.45a4.55,4.55,0,0,1,2.26-3.93h0a1.64,1.64,0,0,1,2.47,1.42v49.59A2.91,2.91,0,0,1,631,486Z",
    style: {
      fill: "url(#9d5ab12b-28e9-4d1f-95a4-eb42700a8053)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M630,532.8l-.61.19a2.45,2.45,0,0,1-3-2.51V503.84a4.57,4.57,0,0,1,2.27-3.95h0a2.55,2.55,0,0,1,3.61,1.17l.14.32Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631,532.38l-.3.17a2,2,0,0,1-3-1.71V504.45a4.55,4.55,0,0,1,2.26-3.93h0a1.64,1.64,0,0,1,2.47,1.42v27.93A2.91,2.91,0,0,1,631,532.38Z",
    style: {
      fill: "url(#4ea928cc-762c-4b51-aabb-29f9a69c0312)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M631.13,491.5a4.67,4.67,0,0,1-2.11,3.66,1.49,1.49,0,0,0-.66.93s-1-.87-1.06-1a1.68,1.68,0,0,1-.39-1.19,4.67,4.67,0,0,1,2.11-3.66,1.39,1.39,0,0,1,1.65,0l.93.85S631.13,491.21,631.13,491.5Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632,492.34a4.67,4.67,0,0,1-2.11,3.66c-1.17.67-2.11.13-2.11-1.22a4.67,4.67,0,0,1,2.11-3.66C631.1,490.44,632,491,632,492.34Z",
    style: {
      fill: "url(#b13e018c-7be5-4dda-8605-abdc953a3fd3)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M631.13,538.75a4.67,4.67,0,0,1-2.11,3.66,1.49,1.49,0,0,0-.66.93s-1-.87-1.06-1a1.68,1.68,0,0,1-.39-1.19,4.67,4.67,0,0,1,2.11-3.66,1.39,1.39,0,0,1,1.65,0l.93.85S631.13,538.46,631.13,538.75Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632,539.59a4.67,4.67,0,0,1-2.11,3.66c-1.17.67-2.11.13-2.11-1.22a4.67,4.67,0,0,1,2.11-3.66C631.1,537.69,632,538.24,632,539.59Z",
    style: {
      fill: "url(#d5689d48-90c8-4d6d-b028-2d1ed887616f)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M778.65,447.64a4.67,4.67,0,0,1-2.11,3.66,1.49,1.49,0,0,0-.66.93s-1-.87-1.06-1a1.68,1.68,0,0,1-.39-1.19,4.67,4.67,0,0,1,2.11-3.66,1.39,1.39,0,0,1,1.65,0l.93.85S778.65,447.35,778.65,447.64Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.57,448.48a4.67,4.67,0,0,1-2.11,3.66c-1.17.67-2.11.13-2.11-1.22a4.67,4.67,0,0,1,2.11-3.66C778.62,446.58,779.57,447.13,779.57,448.48Z",
    style: {
      fill: "url(#af248fab-4522-463f-9c82-02c9c28bcd5b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706,497.21a4.67,4.67,0,0,1-2.11,3.66,1.49,1.49,0,0,0-.66.93s-1-.87-1.06-1a1.68,1.68,0,0,1-.39-1.19,4.67,4.67,0,0,1,2.11-3.66,1.39,1.39,0,0,1,1.65,0l.93.85S706,496.92,706,497.21Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.89,498a4.67,4.67,0,0,1-2.11,3.66c-1.17.67-2.11.13-2.11-1.22a4.67,4.67,0,0,1,2.11-3.66C705.94,496.15,706.89,496.7,706.89,498Z",
    style: {
      fill: "url(#d02d15a4-32ba-4600-8325-8a0d4f85f39c)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M631.13,423.51a4.67,4.67,0,0,1-2.11,3.66,1.49,1.49,0,0,0-.66.93s-1-.87-1.06-1a1.68,1.68,0,0,1-.39-1.19,4.67,4.67,0,0,1,2.11-3.66,1.39,1.39,0,0,1,1.65,0l.93.85S631.13,423.22,631.13,423.51Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632,424.35a4.67,4.67,0,0,1-2.11,3.66c-1.17.67-2.11.13-2.11-1.22a4.67,4.67,0,0,1,2.11-3.66C631.1,422.45,632,423,632,424.35Z",
    style: {
      fill: "url(#a10db361-5c52-48b2-9a69-5b25e809a210)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M709.11,442.18l-.61.19a2.45,2.45,0,0,1-3-2.51V391.56a4.57,4.57,0,0,1,2.27-3.95h0a2.55,2.55,0,0,1,3.61,1.17l.14.32Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.06,441.76l-.3.17a2,2,0,0,1-3-1.71V392.17a4.55,4.55,0,0,1,2.26-3.93h0a1.64,1.64,0,0,1,2.47,1.42v49.59A2.91,2.91,0,0,1,710.06,441.76Z",
    style: {
      fill: "url(#f068d1b2-6591-4fc9-b4ec-3a918dfa5732)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M709.11,488.52l-.61.19a2.45,2.45,0,0,1-3-2.51V459.56a4.57,4.57,0,0,1,2.27-3.95h0a2.55,2.55,0,0,1,3.61,1.17l.14.32Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.06,488.1l-.3.17a2,2,0,0,1-3-1.71V460.17a4.55,4.55,0,0,1,2.26-3.93h0a1.64,1.64,0,0,1,2.47,1.42v27.93A2.91,2.91,0,0,1,710.06,488.1Z",
    style: {
      fill: "url(#8785dfdf-6e9e-49f3-91ee-72832470c82e)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M710.21,447.22a4.67,4.67,0,0,1-2.11,3.66,1.49,1.49,0,0,0-.66.93s-1-.87-1.06-1a1.68,1.68,0,0,1-.39-1.19,4.67,4.67,0,0,1,2.11-3.66,1.39,1.39,0,0,1,1.65,0l.93.85S710.21,446.93,710.21,447.22Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.12,448.06a4.67,4.67,0,0,1-2.11,3.66c-1.17.67-2.11.13-2.11-1.22a4.67,4.67,0,0,1,2.11-3.66C710.17,446.16,711.12,446.71,711.12,448.06Z",
    style: {
      fill: "url(#e4464efe-4c4a-48b7-bb18-3df5085682b5)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M710.21,379.22a4.67,4.67,0,0,1-2.11,3.66,1.49,1.49,0,0,0-.66.93s-1-.87-1.06-1a1.68,1.68,0,0,1-.39-1.19,4.67,4.67,0,0,1,2.11-3.66,1.39,1.39,0,0,1,1.65,0l.93.85S710.21,378.94,710.21,379.22Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.12,380.06a4.67,4.67,0,0,1-2.11,3.66c-1.17.67-2.11.13-2.11-1.22a4.67,4.67,0,0,1,2.11-3.66C710.17,378.17,711.12,378.71,711.12,380.06Z",
    style: {
      fill: "url(#9348533f-f77e-4823-b556-05b97df64eaa)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M593.26,405.64c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,593.26,405.64Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.41,406.55a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31h0l.08-.06a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,594.41,406.55Z",
    style: {
      fill: "url(#65be7f8f-1174-447f-affd-60f773f5a484)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M750.08,314.73c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,750.08,314.73Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.23,315.64a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,3.77,3.77,0,0,0,1.69,2.79,3.53,3.53,0,0,0,2.73.22A2.8,2.8,0,0,0,747,320l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31h0l.08-.06a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,751.23,315.64Z",
    style: {
      fill: "url(#9e4eadc5-ed30-4524-97e2-b68429d5d043)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M607.48,546.17l-3.54,2c0-.11,0-.22,0-.33a13,13,0,0,0-.51-2.23s-1-.81-1.14-.93a4.22,4.22,0,0,0-4.3-.13,13.66,13.66,0,0,0-6.08,6.3l-8.76,5.05c-2.17,1.26-4.22,1.25-5.52,0a6.8,6.8,0,0,0,.18-1.5,2.85,2.85,0,0,0-1.34-2.76,8.07,8.07,0,0,1,.75-1.53s-.85-.65-1-.8a.18.18,0,0,0-.16-.06c-.42.05-1.24,1.56-1.66,2.38-.05,0,0-.49,0-.49l-.71-.61c-.23-.19-.43-.34-.62-.21-.45.3-.85,2-1,2.93a10,10,0,0,0-2.31,4.06L567,559a1.66,1.66,0,0,0-.75,1.3,1.47,1.47,0,0,0,.36,1.05,12,12,0,0,0,1.07.88l1.54-1.5.78-.46c.58-.34,1,0,.88.83a2.11,2.11,0,0,1-.68,1.14c-.32.27-.62.32-.83.21a1.05,1.05,0,0,0-1,.16l-.13.07a1.44,1.44,0,0,0-.65,1.13.47.47,0,0,0,.18.41c.12.08,1,.79,1,.79s3.86-2.8,4.45-3.06v5.4a1.62,1.62,0,0,0,.48,1.29l.58.48.36,1.42-8,4.61a7,7,0,0,0-3.18,5.52.58.58,0,0,0,.3.53c.14.09.94.79.94.79l12.52-8.37a3.71,3.71,0,0,0,1.68-2.91V568l-.33-1.33,12.32-7.11a4,4,0,0,0,.73,1.1l-5,2.89a6.75,6.75,0,0,0-3.05,5.29h0a.65.65,0,0,0,.24.57c.16.11.92.75.92.75l8.64-5.94a1.62,1.62,0,0,0-.12.58.66.66,0,0,0,.22.55l.95.77,13.12-8.55c2.45-1.41,4.28-5.35,4.28-7.92a10.17,10.17,0,0,0-.39-2.61s-1.09-.89-1.25-1A2.49,2.49,0,0,0,607.48,546.17Zm0,9.38-4.61,2.66a31.5,31.5,0,0,0,1.77-3.1s-.73-.6-.94-.76a.92.92,0,0,0-1-.08,14.17,14.17,0,0,0,1.18-4l3.59-2.07c1.3-.75,2.52.76,2.52,2.47A6.54,6.54,0,0,1,607.48,555.55Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.48,547l-3.54,2c0-.11,0-.22,0-.33-.42-3.27-2.9-4.64-5.95-3.29a13.66,13.66,0,0,0-6.08,6.3l-8.76,5.05c-2.17,1.26-4.22,1.25-5.52,0a6.8,6.8,0,0,0,.18-1.5,2.85,2.85,0,0,0-1.34-2.76c0-.62.09-2.45-.39-2.39s-1.24,1.56-1.66,2.38l-.15.06c-.25-.63-.73-1.66-1.17-1.37s-.85,2-1,2.93a10,10,0,0,0-2.31,4.06l-2.77,1.6a1.66,1.66,0,0,0-.75,1.3c0,1.18.84,1.66,1.86,1.07l1.1-.64.78-.46c.58-.34,1,0,.88.83a2.11,2.11,0,0,1-.68,1.14c-.32.27-.62.32-.83.21a1.05,1.05,0,0,0-1,.16l-.13.07a1.44,1.44,0,0,0-.65,1.13c0,.42.29.58.65.38l3.32-1.92a3.25,3.25,0,0,0,1.61-.32v5.4c0,.88.4,1.42,1,1.52l.42,1.67-8,4.61a7,7,0,0,0-3.18,5.52c0,.49.35.68.77.44l13-7.5a3.71,3.71,0,0,0,1.68-2.91v-2.62l-.33-1.33,12.32-7.11a4,4,0,0,0,.73,1.1l-5,2.89a6.75,6.75,0,0,0-3.05,5.29h0c0,.57.4.81.9.52l8.91-5.14a1.62,1.62,0,0,0-.12.58c0,.56.39.79.88.51l13.41-7.74c2.45-1.41,4.28-5.35,4.28-7.92C612.76,547.71,610.89,545.58,608.48,547Zm0,9.38L603.87,559A5.45,5.45,0,0,0,605,556c0-.85-.56-1.21-1.27-.89a14.17,14.17,0,0,0,1.18-4l3.59-2.07c1.3-.75,2.52.76,2.52,2.47A6.54,6.54,0,0,1,608.48,556.36Z",
    style: {
      fill: "url(#22d9647c-0a4a-4890-bc96-b2b956d92fb4)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M656.4,525.23a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17c1.06-1.84,3.15-3.84,3.49-5.61l-1.25-.68a17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a10.27,10.27,0,0,0-.22-3.83l-1.25-.68c-.18.4-.34.81-.49,1.21l-1-.37a15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38l1.25.68c1.14.05,2-.86,3.4-1.66a14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05c1.63-.94,4.62-2,5.9-3.7l-1.25-.68A6.45,6.45,0,0,0,656.4,525.23Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.65,525.91a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17,17.64,17.64,0,0,0,2.24-6.29,17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a6.45,6.45,0,0,0-1.47-4.51,18.51,18.51,0,0,0-.73,1.92,4.74,4.74,0,0,0-.73-1.08,15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38,6.45,6.45,0,0,0,4.65-1,14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05,15.47,15.47,0,0,0,4.65-4.38A6.45,6.45,0,0,0,657.65,525.91Z",
    style: {
      fill: "url(#2c474ba5-717b-4e81-821f-764c9efde5b2)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M656.64,528.44c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31h0l.08-.06a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,656.64,528.44Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.8,529.35a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4A11.67,11.67,0,0,0,653,530a6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,657.8,529.35Z",
    style: {
      fill: "url(#046e315f-f1ad-4712-84ca-1dffab8c8062)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M691.65,504.95a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17c1.06-1.84,3.15-3.84,3.49-5.61l-1.25-.68a17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a10.27,10.27,0,0,0-.22-3.83l-1.25-.68c-.18.4-.34.81-.49,1.21l-1-.37a15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38l1.25.68c1.14.05,2-.86,3.4-1.66a14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05c1.63-.94,4.62-2,5.9-3.7L696.3,504A6.45,6.45,0,0,0,691.65,504.95Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.9,505.63A12.73,12.73,0,0,0,691,507h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17,17.64,17.64,0,0,0,2.24-6.29,17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a6.45,6.45,0,0,0-1.47-4.51,18.51,18.51,0,0,0-.73,1.92,4.74,4.74,0,0,0-.73-1.08A15.48,15.48,0,0,0,686,505c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38,6.45,6.45,0,0,0,4.65-1,14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05,15.47,15.47,0,0,0,4.65-4.38A6.45,6.45,0,0,0,692.9,505.63Z",
    style: {
      fill: "url(#dd2ef2e8-f972-42bc-9f7c-ec0061e48ebd)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M691.9,508.16c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,691.9,508.16Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693,509.07a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,693,509.07Z",
    style: {
      fill: "url(#b348af3b-eb3b-42cc-94d0-3b175f13846d)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M792,290.32a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17c1.06-1.84,3.15-3.84,3.49-5.61l-1.25-.68a17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a10.27,10.27,0,0,0-.22-3.83l-1.25-.68c-.18.4-.34.81-.49,1.21l-1-.37a15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38l1.25.68c1.14.05,2-.86,3.4-1.66a14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05c1.63-.94,4.62-2,5.9-3.7l-1.25-.68A6.45,6.45,0,0,0,792,290.32Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.26,291a12.73,12.73,0,0,0-1.87,1.36h0l-1.12.86h0a18.87,18.87,0,0,0,2.31-3.17,17.64,17.64,0,0,0,2.24-6.29,17.51,17.51,0,0,0-4.09,4.72c0-.21,0-.43,0-.63a6.45,6.45,0,0,0-1.47-4.51,18.51,18.51,0,0,0-.73,1.92,4.74,4.74,0,0,0-.73-1.08,15.48,15.48,0,0,0-1.47,6.21c0,.21,0,.39,0,.59a5.09,5.09,0,0,0-4.09,0,5,5,0,0,0,2.24,3.7,4.19,4.19,0,0,0,2.31.51h0l-1.12.43,0,0a8.65,8.65,0,0,0-1.87.8,15.47,15.47,0,0,0-4.65,4.38,6.45,6.45,0,0,0,4.65-1,14.84,14.84,0,0,0,4-3.59c.18-.21.36-.43.53-.67l.09-.12h0l.11-.17.11,0v0h.09a2.33,2.33,0,0,0,.53.06,6.86,6.86,0,0,0,4-1.05A15.47,15.47,0,0,0,797.9,290,6.45,6.45,0,0,0,793.26,291Z",
    style: {
      fill: "url(#e5eee40a-6e0f-482c-877b-2b0781453213)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M772.83,277.37h0l-8.92,5.15.84-3.3a2.15,2.15,0,0,0-3.14-1.69h0a5.09,5.09,0,0,0-2.3,4v.09l-1.15.67a2.68,2.68,0,0,0-1.21,2.1v1.5l.84.5c.47-.27.1-1.42.2-2l1.32-.6v1.39l-8.91,5.14h0l-5.78,7.2.84.5c2.89-.35,6.16-2.63,9.22-5.55h0a10.11,10.11,0,0,0,4.68-.73c.06.8.16,1.47.3,2.85l0,.21-.61.35a1.72,1.72,0,0,0-.74,1.07l-.69.4-1.24,0h-.06l0,0,0,0,0,0,0,0-.53.67a.34.34,0,0,0-.07.37,1.17,1.17,0,0,0,.18.11l-.27.48a.34.34,0,0,0-.07.37,5.58,5.58,0,0,0,.49.4.22.22,0,0,0,.07.29c.09.08.82.49.82.49l.75-1.41.63-1s.52-.39.87-.6l1-.56.1.43a2.67,2.67,0,0,0,.05.31l-1.29,6.67.84.5,4.53-3.61L763,295.5c0-.12,0-.25.05-.37l.1-.54,1-.57a1.72,1.72,0,0,0,.74-1.07l.71.21,1-.44.3.38c.06.08.19,0,.29-.09h0c.1-.13.62-.22.56-.3l-.51-.3a4.08,4.08,0,0,0,1.31-.51l-.64-.35c.06-.15.47-.18.53-.32s-.93-.61-.93-.61l-.53-.06h-.06l0,0,0,0,0,0,0,0-1.24,1.4-.69.4c-.09-.32-.38-.42-.74-.22l-.64.37,0-.26c.14-1.53.24-2.32.3-3.18a27.28,27.28,0,0,0,4.71-4.7,21.64,21.64,0,0,0,10.91-6.07l-.84-.5Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.67,277.87h0L764.75,283v-3.66c0-1.47-1-2.06-2.3-1.33h0a5.09,5.09,0,0,0-2.3,4v.09l-1.15.67a2.68,2.68,0,0,0-1.21,2.1v1.5l.09,0a2.21,2.21,0,0,0,1-1.43l1.32-.6v1.39l-8.91,5.14h0l-5.78,7.2c3.09-.09,6.7-1.84,10.07-5.05h0a10.11,10.11,0,0,0,4.68-.73c.06.8.16,1.47.3,2.85l0,.21-.61.35a1.72,1.72,0,0,0-.74,1.07l-.69.4-1.24,0h-.06l0,0,0,0,0,0,0,0-.53.67a.34.34,0,0,0-.07.37c.06.08.19,0,.29-.08l.44-.55h.5l-.7.48a.41.41,0,0,0-.1.1l-.52.66a.34.34,0,0,0-.07.37c.06.08.19,0,.29-.08l.49-.63.57-.39-.46.59h0l0,.07,0,0h0l-.33.8c-.06.15,0,.28.07.29s.23-.09.29-.24l.3-.73,1.13-1.44.63-.36c.09.32.38.42.74.22l1-.56.1.43a2.67,2.67,0,0,0,.05.31l-1.29,6.67,5.38-3.1L763.84,296c0-.12,0-.25.05-.37l.1-.54,1-.57a1.72,1.72,0,0,0,.74-1.07l.63-.36,1.13.14.3.38c.06.08.19,0,.29-.09h0a.34.34,0,0,0,.07-.37l-.33-.41h0l0,0h0l-.46-.06.57-.26.49.06c.1,0,.23-.1.29-.25h0c.06-.15,0-.28-.07-.29l-.52-.06a.15.15,0,0,0-.1,0l-.7.33.5-.57.44,0c.1,0,.23-.1.29-.25s0-.28-.07-.29l-.53-.06h-.06l0,0,0,0,0,0,0,0-1.24,1.4-.69.4c-.09-.32-.38-.42-.74-.22l-.64.37,0-.26c.14-1.53.24-2.32.3-3.18a27.28,27.28,0,0,0,4.71-4.7c3.37-.67,7-3.09,10.07-6.57Z",
    style: {
      fill: "url(#d2b49d87-33ec-4f52-a9b8-abd62dc0a166)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M789.68,271a4.67,4.67,0,0,1-2.11,3.66,1.49,1.49,0,0,0-.66.93s-1-.87-1.06-1a1.68,1.68,0,0,1-.39-1.19,4.67,4.67,0,0,1,2.11-3.66,1.39,1.39,0,0,1,1.65,0l.93.85S789.68,270.71,789.68,271Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.59,271.83a4.67,4.67,0,0,1-2.11,3.66c-1.17.67-2.11.13-2.11-1.22a4.67,4.67,0,0,1,2.11-3.66C789.64,269.94,790.59,270.49,790.59,271.83Z",
    style: {
      fill: "url(#b32edbc3-d54f-490c-add3-b5ff43c313d5)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M711.84,493.51c0,2.55,1.82,4.36,4.25,3l13.31-7.68a1.93,1.93,0,0,0,.87-1.51.74.74,0,0,0-.12-.43l8.84-5.1c.49-.28,1.22-2.67,1.22-2.67l-1.28-.87a2.82,2.82,0,0,0-2.08.25l-5,2.86a15.33,15.33,0,0,0,.73-1.93l12.22-7.06-.33,1.7v2.6a1.18,1.18,0,0,0,.48,1.07c.3.18,1.08.75,1.08.75l13-8.3a8.94,8.94,0,0,0,1.19-2.43s-.76-.56-1.3-.91a2.18,2.18,0,0,0-2.29.19l-7.91,4.57.41-2.14a4.64,4.64,0,0,0,1-2.66v-5.36c.58-.41,4.17-1.75,4.65-2.35l1.9-1.79s-1-.65-1.08-.73-.32-.2-.57-.06l-.13.07a2.74,2.74,0,0,0-1,1,1.64,1.64,0,0,1-.82.74.49.49,0,0,1-.67-.35,1.89,1.89,0,0,1,.87-1.83l.77-.43,1.09-.63a15.6,15.6,0,0,0,2.77-2.89s-1-.6-1-.69-.37-.2-.63,0L753.55,453a2.12,2.12,0,0,0-2.3-1.38c-.08-.31.3-1,.3-1s-.87-.57-1-.69a.27.27,0,0,0-.33-.09c-.43.21-.92,1.79-1.16,2.69l-.15.11c-.41-.33-1.23-.88-1.65-.46s-.42,2.24-.39,2.82a8.57,8.57,0,0,0-1.33,4.28,4.35,4.35,0,0,0,.18,1.28,14.59,14.59,0,0,1-5.48,6.34l-8.69,5c-1.4-1.13-3.61-1-6,.71a15.51,15.51,0,0,0-5.9,10.08c0,.12,0,.24,0,.36l-3.51,2C713.7,486.53,711.84,490.78,711.84,493.51Zm1.74-1c0-1.7,1.21-4.6,2.51-5.35l3.56-2.06a4.73,4.73,0,0,0,1.17,2.61,3.14,3.14,0,0,0-1.26,2.34c0,1,.44,1.62,1.1,1.76l-4.57,2.64C714.68,495.27,713.58,494.08,713.58,492.51Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713,494.29c0,2.55,1.82,4.36,4.25,3l13.31-7.68a1.93,1.93,0,0,0,.87-1.51.74.74,0,0,0-.12-.43l8.84-5.1A2,2,0,0,0,741,481h0c0-1.93-1.36-2.71-3-1.75l-5,2.86a15.33,15.33,0,0,0,.73-1.93L746,473.1l-.33,1.7v2.6c0,1.06.75,1.49,1.67,1l12.89-7.44a1.69,1.69,0,0,0,.76-1.32c0-2-1.41-2.83-3.16-1.83l-7.91,4.57.41-2.14a4.64,4.64,0,0,0,1-2.66V462.2a8,8,0,0,0,1.6-1.53l3.29-1.9a1.43,1.43,0,0,0,.65-1.12c0-.41-.29-.58-.65-.37l-.13.07a2.74,2.74,0,0,0-1,1,1.64,1.64,0,0,1-.82.74.49.49,0,0,1-.67-.35,1.89,1.89,0,0,1,.87-1.83l.77-.43,1.09-.63a4.09,4.09,0,0,0,1.85-3.2c0-.47-.33-.67-.74-.43l-2.75,1.59a2.12,2.12,0,0,0-2.3-1.38c-.18-.68-.57-2-1-1.73s-.92,1.79-1.16,2.69l-.15.11c-.41-.33-1.23-.88-1.65-.46s-.42,2.24-.39,2.82a8.57,8.57,0,0,0-1.33,4.28,4.35,4.35,0,0,0,.18,1.28,14.59,14.59,0,0,1-5.48,6.34l-8.69,5c-1.4-1.13-3.61-1-6,.71a15.51,15.51,0,0,0-5.9,10.08c0,.12,0,.24,0,.36l-3.51,2C714.82,487.31,713,491.56,713,494.29Zm1.74-1c0-1.7,1.21-4.6,2.51-5.35l3.56-2.06a4.73,4.73,0,0,0,1.17,2.61,3.14,3.14,0,0,0-1.26,2.34c0,1,.44,1.62,1.1,1.76l-4.57,2.64C715.8,496,714.7,494.85,714.7,493.28Z",
    style: {
      fill: "url(#7c2c793d-d9d7-4398-b944-affb54f9ddaa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.18,461.29c.72-1.24,2.56-2.63,2.84-3.84l-1.15-.91a13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64c0-.85-.18-3.12,0-2.5,0,0-1.15-.91-1.15-.91a11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,3.77,3.77,0,0,0-3.26-.07,4.44,4.44,0,0,0,1.69,2.79c.18.15.84,1.1,1.83.83.15,0,1.19-.67,1.35-.73l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31v0l.08-.07a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,771.18,461.29Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.33,462.19a13.3,13.3,0,0,0,1.69-4.74,13.3,13.3,0,0,0-3.26,3.84,14.48,14.48,0,0,0-.87,1.81l0,0-.5,1.11h0a10.24,10.24,0,0,0,.39-2.64,4.87,4.87,0,0,0-1.11-3.4,11.67,11.67,0,0,0-1.11,4.69,6,6,0,0,0,.38,2.18h0l-.5-.52h0a3,3,0,0,0-.87-.8,1.86,1.86,0,1,0-1.57,2.72,3.53,3.53,0,0,0,2.73.22,2.8,2.8,0,0,0,.45-.13l.08,0h0a3.6,3.6,0,0,0,.44-.2,4.86,4.86,0,0,0,.44-.31h0l.08-.06a5.77,5.77,0,0,0,.45-.39A13.6,13.6,0,0,0,772.33,462.19Z",
    style: {
      fill: "url(#11aebe28-fce0-4f05-ba93-548d82f87400)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M723.06,442.8h0l8.92-5.15V434a5.09,5.09,0,0,1,2.3-4h0c1.27-.73,2.3-.14,2.3,1.33v.09l1.15-.67a.87.87,0,0,1,.88-.1,1.53,1.53,0,0,1,1.08,1.29l-.74,1-.09,0c-.47.27-.85.12-1-.32l-1.32.92V435l8.91-5.14h0l5.78.52.74.57s-7.52,5.34-10.81,6h0a27.36,27.36,0,0,1-4.68,4.66c-.06.86-.16,1.65-.3,3.19l0,.26.61-.35c.35-.2.64-.1.74.22l.69-.4,1.24-1.4,0,0,0,0,0,0,0,0h.06l.53.06a.33.33,0,0,1,.14.07l.66.53s-.53.23-.5.26.67.52.67.52l-1.26.46.45.34c.06.08-.38.09-.48.22s-.23.17-.29.09l-.3-.38s-2.14,1.09-2.49,1.29l-1,.56-.1.54c0,.12,0,.25-.05.37l1.29,5.18-4.63,3.67-.74-.57,1.29-6.67a2.67,2.67,0,0,1-.05-.31l-.1-.43-1,.57a12.44,12.44,0,0,0-1.44,1.52l-.94,1.58-.71-.53c-.12-.09-.12-.16-.05-.31s-.28-.21-.32-.25-.14-.11-.17-.14h0a.34.34,0,0,1,.07-.37l.32-.41a1.06,1.06,0,0,1-.23-.18.34.34,0,0,1,.07-.37l.53-.67,0,0,0,0,0,0,0,0h.06l1.24,0,.69-.4a1.72,1.72,0,0,1,.74-1.07l.64-.37,0-.21c-.14-1.37-.24-2-.3-2.84a10.11,10.11,0,0,1-4.71.74c-3.1,3-9.32,5.62-9.32,5.62l-.74-.57Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.81,443.36h0l8.92-5.15v-3.66a5.09,5.09,0,0,1,2.3-4h0c1.27-.73,2.3-.14,2.3,1.33V432l1.15-.67c.67-.39,1.21-.07,1.21.7v1.5l-.09,0c-.47.27-.85.12-1-.32l-1.32.92v1.39l8.91-5.14h0L752,431c-3.09,3.48-6.7,5.9-10.07,6.57h0a27.28,27.28,0,0,1-4.68,4.66c-.06.86-.16,1.65-.3,3.19l0,.26.61-.35c.35-.2.64-.1.74.22l.69-.4,1.24-1.4,0,0,0,0,0,0,0,0h.06l.53.06c.1,0,.13.14.07.29s-.19.26-.29.25l-.44,0-.5.57.7-.33a.15.15,0,0,1,.1,0l.52.06c.1,0,.13.14.07.29s-.19.26-.29.25l-.49-.06-.57.26.46.06h0l0,0h0l.33.41a.34.34,0,0,1-.07.37c-.1.13-.23.17-.29.09l-.3-.38-1.13-.14-.63.36a1.72,1.72,0,0,1-.74,1.07l-1,.56-.1.54c0,.12,0,.25-.05.37l1.29,5.18-5.38,3.1,1.29-6.67a2.67,2.67,0,0,1-.05-.31l-.1-.43-1,.57c-.35.2-.64.1-.74-.22l-.63.36L730,451.54l-.3.73c-.06.15-.19.26-.29.24h0c-.1,0-.13-.14-.07-.29l.33-.8h0l0,0,0-.07h0l.46-.59-.57.39-.49.63c-.1.13-.23.16-.29.08h0a.34.34,0,0,1,.07-.37l.52-.66a.42.42,0,0,1,.1-.1l.7-.48h-.5l-.44.55c-.1.13-.23.16-.29.08a.34.34,0,0,1,.07-.37l.53-.67,0,0,0,0,0,0,0,0h.06l1.24,0,.69-.4a1.72,1.72,0,0,1,.74-1.07l.64-.37,0-.21c-.14-1.37-.24-2-.3-2.84a10.11,10.11,0,0,1-4.71.74c-3.37,3.21-7,5-10.07,5.05Z",
    style: {
      fill: "url(#22f40412-3f7a-4c52-8eb7-98d2e7811451)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M875.47,166.54c-1.9-7,1.09-12.54,0-20.59-2.18-16.05-37-12.32-50.56-23.24-23.16-18.69-70.87-12.8-75.76.9a13.58,13.58,0,0,0-14-5.73c-.28.06-32.65,14.54-32.65,14.54a25.29,25.29,0,0,0-17.62,18.15l-2,7.85-4.16-2.36A14.65,14.65,0,0,0,666.6,155a51.55,51.55,0,0,1-8.92,2.23l-3.27.53c-6.31,1-10.77,6.27-11.61,12.6-.78,5.88-7.62,14.13-14.63,17a35.23,35.23,0,0,0-14.15,9.9c-8.36-2.53-19.36-1-29.59,9.09-5.39,5.3-15.68,8.3-21.39,6.68-6.15-1.75-12.72.26-16.18,5.64l-1.79,2.78a51.59,51.59,0,0,1-5.59,7.3,14.65,14.65,0,0,0-3.85,11.54l.56,5.28a27.3,27.3,0,0,0-11.63.41,93.37,93.37,0,0,1-12.25,2.26l-4.48.54c-8.66,1.05-15.51,6.26-16,12.64,0,0,0,.11,0,.27a14.63,14.63,0,0,0-4.09-1.1,51.55,51.55,0,0,1-9-1.91l-3.17-1c-6.12-1.84-12.43.9-16,6.23-3.28,4.94-13.05,9.35-20.6,8.82-27-1.89-36.48,21.06-30.07,31.35.17.27.35.54.53.8l-.4-.12c-6.22-2-13.19-3.48-16.11-1.45-1.8,1.25-2.75,4.82-3.22,8.79a30.21,30.21,0,0,1-15.52,22.77l-11.42,6.29c-21.14,11.65-24.74,41-6.51,56.82,6.44,5.59,15,9.69,26.24,10.47,42.45,3,50.8,28.13,58.39,30.44s14.52-6.7,20.59-4.8,14,12.36,24.33,12.44,21.72-15.18,15.76-22.45l4.6-2.65V623l40.06-23V413.28a52.32,52.32,0,0,1,8.38-2l3.27-.51a13.7,13.7,0,0,0,11.71-12.5c0-.11-.72-5.24-1.63-11.57a13.58,13.58,0,0,0,14,5.84c.28-.06,32.77-14.26,32.77-14.26a25.29,25.29,0,0,0,17.77-18l2-7.83,4.14,2.39A14.65,14.65,0,0,0,650.85,356a51.57,51.57,0,0,1,8.94-2.15l3.27-.51c6.32-1,10.82-6.18,11.71-12.5.83-5.87,7.74-14.06,14.78-16.84a35.23,35.23,0,0,0,14.24-9.78c8.34,2.6,19.35,1.13,29.66-8.84,5.43-5.26,15.75-8.17,21.44-6.5,6.13,1.8,12.73-.15,16.23-5.5l1.81-2.77a51.58,51.58,0,0,1,5.65-7.25,14.65,14.65,0,0,0,3.94-11.5l-.52-5.28a27.3,27.3,0,0,0,11.63-.31,93.37,93.37,0,0,1,12.27-2.15l4.49-.51c8.67-1,15.56-6.13,16.08-12.5,0-.1,16.66-4.56,15.51-10.37,0,0,21.94-11.38,27.45-15.43.33-.24,4.9-2.65,10.08-15.62a48.14,48.14,0,0,0,2.71-8.75C887.66,173.31,877.36,173.58,875.47,166.54Z",
    style: {
      fill: "#2cd4d9",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "467.3 411.88 507.37 388.92 540.41 408.09 540.41 611.31 500.35 634.27 467.3 615.1 467.3 411.88",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "500.35 431.06 540.41 408.09 540.41 611.31 500.35 634.27 500.35 431.06",
    style: {
      fill: "#5333ed"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M804.29,276.28s17.95-9.24,20.94-12,2.23-22.85,2.05-24.57,2.57-2,2.57-2,.68,21.51.68,24.09c0,.6,5.09-.73,13.81-9.29v2.65s-8.08,9.07-12.27,9.33-5.39,2-6.68,3.17-7.53,4.54-10.53,6.08-7.73,3.68-10.59,5.73Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#6a56fef2-4b34-4cef-8d18-5bb90eb32ea2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.29,368s17.95-9.24,20.94-12,2.23-22.85,2.05-24.57,2.57-2,2.57-2,.68,21.51.68,24.09c0,.6,5.09-.73,13.81-9.29V347s-8.08,9.07-12.27,9.33-5.39,2-6.68,3.17-7.53,4.54-10.53,6.08-7.73,3.68-10.59,5.73Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#1eb4ccee-a5e1-4eb2-b24e-c434ae3aa256)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.29,302.7s12.33-8.22,17.23-10.16,13.47-6.16,16.21-8.45a29.76,29.76,0,0,1,6.62-3.88V283a41.76,41.76,0,0,1-8.79,5,47.69,47.69,0,0,0-10.16,5.36c-1.26,1-8.45,6.85-12.55,7.42s-8.56,5.48-8.56,5.48Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#ea41af92-f9e0-4ec5-8e64-24a269349948)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.29,322.49s17.95-9.24,20.94-12,2.23-17.31,2.05-19,2.57-2,2.57-2,.68,16,.68,18.55c0,.6,5.09-.73,13.81-9.29v2.65s-8.08,9.07-12.27,9.33-5.39,2-6.68,3.17-7.53,4.54-10.53,6.08-7.73,3.68-10.59,5.73Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#9208dde3-4170-4f98-acbc-56ceb7b13aa5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.29,415.1s17.95-9.24,20.94-12,2.23-22.85,2.05-24.57,2.57-2,2.57-2,.68,21.51.68,24.09c0,.6,5.09-.73,13.81-9.29V394s-8.08,9.07-12.27,9.33-5.39,2-6.68,3.17-7.53,4.54-10.53,6.08-7.73,3.68-10.59,5.73Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#4983b9f4-6c7a-40ee-a83a-fbe18546d58b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.29,436.93s12.33-8.22,17.23-10.16,13.47-6.16,16.21-8.45a29.76,29.76,0,0,1,6.62-3.88v2.74a41.76,41.76,0,0,1-8.79,5,47.69,47.69,0,0,0-10.16,5.36c-1.26,1-8.45,6.85-12.55,7.42s-8.56,5.48-8.56,5.48Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#bda80835-6da6-4866-846d-b4ca49d6a9d2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827,445.27c.76-5.32.39-18.37.27-19.56-.17-1.71,2.57-2,2.57-2s.36,14,.56,19.57Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#5ad62196-16ea-4a0a-aa14-ecea9f37c403)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.29,342.87s12.33-8.22,17.23-10.16,13.47-6.16,16.21-8.45a29.76,29.76,0,0,1,6.62-3.88v2.74a41.76,41.76,0,0,1-8.79,5,47.69,47.69,0,0,0-10.16,5.36c-1.26,1-8.45,6.85-12.55,7.42s-8.56,5.48-8.56,5.48Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#1b351e0e-0bd7-4e44-8e80-659810dc319e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.29,389.66s12.33-8.22,17.23-10.16,13.47-6.16,16.21-8.45a29.76,29.76,0,0,1,6.62-3.88v2.74a41.76,41.76,0,0,1-8.79,5,47.69,47.69,0,0,0-10.16,5.36c-1.26,1-8.45,6.85-12.55,7.42s-8.56,5.48-8.56,5.48Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#5a9c6035-4e14-445f-adc7-41e35bd46a2a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.35,453.34s17.95-9.24,20.94-12,2.23-22.85,2.05-24.57,2.57-2,2.57-2,.68,21.51.68,24.09c0,.6,5.09-.73,13.81-9.29v2.65s-8.08,9.07-12.27,9.33-5.39,2-6.68,3.17-7.53,4.54-10.53,6.08-7.73,3.68-10.59,5.73Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#060bb362-88a2-4c3c-a5a3-f4a206541b29)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.35,545.1s17.95-9.24,20.94-12,2.23-22.85,2.05-24.57,2.57-2,2.57-2,.68,21.51.68,24.09c0,.6,5.09-.73,13.81-9.29V524s-8.08,9.07-12.27,9.33-5.39,2-6.68,3.17-7.53,4.54-10.53,6.08-7.73,3.68-10.59,5.73Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#40b8b5c7-6699-4286-a414-e211874e33de)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.35,473s12.33-8.22,17.23-10.16,13.47-6.16,16.21-8.45a29.76,29.76,0,0,1,6.62-3.88v2.74a41.76,41.76,0,0,1-8.79,5,47.69,47.69,0,0,0-10.16,5.36c-1.26,1-8.45,6.85-12.55,7.42s-8.56,5.48-8.56,5.48Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#d4e49bff-8d0d-4e68-ae80-3008b669a193)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.35,492.75s17.95-9.24,20.94-12,2.23-17.31,2.05-19,2.57-2,2.57-2,.68,16,.68,18.55c0,.6,5.09-.73,13.81-9.29v2.65s-8.08,9.07-12.27,9.33-5.39,2-6.68,3.17-7.53,4.54-10.53,6.08-7.73,3.68-10.59,5.73Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#7f68e2e6-d9b2-4521-accf-ba4e7671d2c5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.35,592.17s17.95-9.24,20.94-12,2.23-17,2.05-18.7,2.57-2,2.57-2,.68,15.65.68,18.23c0,.6,5.09-.73,13.81-9.29v2.65s-8.08,9.07-12.27,9.33-5.39,2-6.68,3.17-7.53,4.54-10.53,6.08-7.73,3.68-10.59,5.73Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#2881e08d-def5-4d3b-9132-859b76cf1c77)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.35,614s12.33-8.22,17.23-10.16,13.47-6.16,16.21-8.45a29.76,29.76,0,0,1,6.62-3.88v2.74a41.76,41.76,0,0,1-8.79,5,47.69,47.69,0,0,0-10.16,5.36c-1.26,1-8.45,6.85-12.55,7.42s-8.56,5.48-8.56,5.48Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#66fd8806-6988-4cc4-9dc9-ad8cae05bf09)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.07,621.25c.76-5.32.39-17.29.27-18.47-.17-1.71,2.57-2,2.57-2s.36,12.89.56,18.49Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#0e19ee3e-7feb-49b1-9e16-eef518454e8c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.35,519.94s12.33-8.22,17.23-10.16,13.47-6.16,16.21-8.45a29.76,29.76,0,0,1,6.62-3.88v2.74a41.76,41.76,0,0,1-8.79,5,47.69,47.69,0,0,0-10.16,5.36c-1.26,1-8.45,6.85-12.55,7.42s-8.56,5.48-8.56,5.48Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#484813ad-e47a-4a6e-8d0d-1264554ee915)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.35,572.72s12.33-8.22,17.23-10.16,13.47-6.16,16.21-8.45a29.76,29.76,0,0,1,6.62-3.88V553a41.76,41.76,0,0,1-8.79,5,47.69,47.69,0,0,0-10.16,5.36c-1.26,1-8.45,6.85-12.55,7.42s-8.56,5.48-8.56,5.48Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#7419ee29-0ffe-4448-a7cf-1ebb5ad5bf59)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410,376.5c6.82,1.71,11.62,12,19.5,10.18C436.8,385,439,375.11,451,372.9c9.9-1.82,20.34-21.22,50-8.14,5.74,2.53,14.08-.62,16.77,1h0a14.65,14.65,0,0,1,6.91,10c.54,3,12.63,1.56,17.08,13.93l1.83,5.3c2.22,6-.13,12.46-5.23,16.32-4.73,3.58-8.87,14.39-11.58,18.29-3.88,5.59-12.5,5.37-12.86,12.74,6.33,6,10.41,16.36,6.71,30.21-1.95,7.31.53,17.74,4.76,21.89,4.56,4.48,6.06,11.19,3.09,16.85l-1.54,2.93a51.57,51.57,0,0,0-3.58,8.47,14.65,14.65,0,0,1-8.13,9l-4.87,2.12a27.3,27.3,0,0,1,5.39,10.31,93.37,93.37,0,0,0,4.09,11.77l1.74,4.17c3.36,8.05,2.22,16.58-3.1,20.13-.09.06-4.5,1.5-10.13,3.32l-.13,31.49a7.9,7.9,0,0,0,1,.71,27.57,27.57,0,0,1,4.2,11L505,631.6S403.78,374.94,410,376.5Z",
    style: {
      fill: "#595959",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.49,656.42c-7.08,1.77-9.88,9.53-18,10s-13.09-9-20.27-11.91c-6.58-2.64-51.93-29.41-58.9-34.42l.05,0-11.3-7.49a14.65,14.65,0,0,1-6.82-10.07,51.56,51.56,0,0,0-2.39-8.88l-1.12-3.11a13.7,13.7,0,0,1,5.36-16.27c.09-.06,5-1.88,10.94-4.11a13.58,13.58,0,0,1-11.82-9.46c-.08-.28-3.18-35.6-3.18-35.6a25.29,25.29,0,0,1,7.28-24.22l5.9-5.55-4.08-2.49a14.65,14.65,0,0,1-6.82-10.07c-.51-3-5-28.91-6-31.8l-1.74-5.48c-2.17-6,.67-15.29,5.8-19.1,4.76-3.54,20.14-16.77,13.27-29.25-6.5-11.82-8.86-27.45,6-31.42,1.66-.44,10.44-4.1,17.88-.27a85.62,85.62,0,0,0,18.15,6.5c6.82,1.71,11.62,12,19.5,10.18,7.31-1.66,9.53-11.57,21.52-13.77,9.9-1.82,20.34-21.22,50-8.14,5.74,2.53,14.08-.62,16.77,1h0a14.65,14.65,0,0,1,6.91,10c.54,3,12.63,1.56,17.08,13.93l1.83,5.3c2.22,6-.13,12.46-5.23,16.32-4.73,3.58-8.87,14.39-11.58,18.29-3.88,5.59-12.5,5.37-12.86,12.74,6.33,6,10.41,16.36,6.71,30.21-1.95,7.31.53,17.74,4.76,21.89,4.56,4.48,6.06,11.19,3.09,16.85l-1.54,2.93A51.57,51.57,0,0,0,517,518.2a14.65,14.65,0,0,1-8.13,9L504,529.36a27.3,27.3,0,0,1,5.39,10.31,93.37,93.37,0,0,0,4.09,11.77l1.74,4.17c3.36,8.05,2.22,16.58-3.1,20.13-.09.06-4.5,1.5-10.13,3.32l-.13,31.49a7.9,7.9,0,0,0,1,.71s10.84,15-1.12,31a40.51,40.51,0,0,1-6.33,6.62C473.87,667,472.56,654.65,465.49,656.42Z",
    style: {
      fill: "url(#b2e4c2e3-6b1a-4577-aef0-0b6f40451e3e)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M507.52,437.84s-11.22,13.12-37,7-33.66-2.23-42.8-3.39-5.89-8.74-11-14.42a10.21,10.21,0,0,0-11.38-3s-7.52,2.81-7.52-2.08-2.44-5.51-4.88-5.3-7.72.33-7.31-1.87-5.08-5.65-6.3-2.4-4.27.61-4.27.61-.41-4.06-3-3.66-6.3,1-6.3,0c0,0-1.22,2,5.23,1.7,0,0,1.68-.46,1.42,2s3.4,3.45,3.4,3.45,3.15.56,4.42-1.78,2.49-1.52,2.49-1.52-2.66,3.54-.78,4.86,7.18,1.35,7.18,1.35,4.69-.3,5.55.41-1.07,2.93.41,5,5.87,2.69,8.57,1.73,5.08-2,6.6-1.63.36,4.82,3.71,5.69,4,1,4.11,2.08-.46,4,.81,4.82,1.37,2.08,2,3.45,5.74,4.22,12.09,3.45c.27,0,.1-.66,2.79-.05s5.23-.76,7.36.1,7.26-.1,8.74-.2,16.86,4.82,21.48,4.52,10-.3,11.12-.2,4.77.84,7.21.22,8.74-4.74,9.19-4.79,8.57-2.62,8-4.81Z",
    style: {
      fill: "url(#77de7ae9-5292-4866-9f70-0faf5d55fd31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.7,456.6s2.13-11.05,5.79-14.1,5.49-.8,8.33-2,2.44-3.46,4.67-4.27,3.32.11,4.2-.49.61-1.82,1.49-2.09.68-1.08.95-1.35,3.11-3.22,4.6-3.52c7.35-1.49,6.13,8.77,6.13,8.77s-5.28-2.61-6.5-2.34A15.53,15.53,0,0,0,408.8,437c-1,.55-2.23.61-4.47.47s-2.57,4-4.81,5a6,6,0,0,1-4.2.32c-1-.14-1.63.14-3,1s-1.76,0-3.12,0-1.42.74-1.49,1.63a7.25,7.25,0,0,1-1.83,3.18C385.17,449.27,385.71,456.48,382.7,456.6Z",
    style: {
      fill: "url(#d789e14a-c0f5-4108-b016-5f56aca01df9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.21,479.44s7.81,9.32,6.34,16.56-10.42,9.9-12.24,14.46-1,6.39-3.85,7.1-2.84,3.39-2.84,5.91-3-2.76-3-3.88,1.22-2.54,2.23-3.56a27.89,27.89,0,0,1,3.35-2.84c1.73-1.32-.41-4.37.81-6s2.84-2.34,5.18-3.15a3.55,3.55,0,0,0,2.64-4c-.2-1.32.61-1.37,2.13-4.09s1.22-5.66-1.42-7.59.3-3.86.3-3.86A4.09,4.09,0,0,1,473.21,479.44Z",
    style: {
      fill: "url(#035f6a32-46b3-4448-8c7a-4e47417c1a97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504,529.36s-3.94,0-7.19,6.25-20.82,15.58-42.36,3.49c-26.1-14.65-19.67-19.92-21.3-21.45s-3.52-12.08-15.71-6.54-17.07,1.29-17.61-1.6a3.85,3.85,0,0,0-5.15-2.93,6,6,0,0,1-7.58-4.17,4.13,4.13,0,0,0,0,3.74c1,2,1.76,1.29,2,1.29s2.17.34,2.71,1.15,3.52-.68,4.13-.41.34,4.6,2.64,5.08,4.54,2.71,6.5,1.63,12.46,2.57,15-1.15,4.6-2.51,6-1.15,4.13,7,5.62,6a9.14,9.14,0,0,0,.64,7.79c2.42,4.25,3.76,1.83,4.3,4.94s2.94,5.72,7.18,7c2.29.71,4.66,2.42,7.16,3.5s2.39,4,5.64,4.28,13.75,3.25,16,2.84c1.83-.32,9.84-.55,13.07-.63a4.11,4.11,0,0,0,2.46-.9c2.31-1.84,8.66-6,9-7.85.41-2.37,2-4.81,3.25-4.81s2.11-2.34,2.11-2.95,3.55.28,3.55.28Z",
    style: {
      fill: "url(#af016eb0-8c4f-4450-9ce5-ade4c8f677f2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502,579.07s-8.84,2.39-11.88,7.47-3.86,7.81-6.3,8.88-4,5.39-4,5.39-2.26,4.62-7.95,2-7.31-2.54-9.35-2-6.09,4.22-9.35,2.8-4.88-3.66-8.74-5.69-9.35,3.66-12.19,4.67-7.72,4.3-10.36,3.27-7.52,1.41-8.94,2-1.22-.17-7.31-2c0,0,4.54-.29,6.23-.63s3.79-3.39,10.43-2.64,6.77.34,9.41-1.63-2-3,6.7-5.42,9.75-1.42,12.26.54,1.15,2.91,4.74,2.78,7.25-2.51,13.81-3.79,11.11-.07,13.21-2.44,2.57-11.48,8.46-13.56,11.44-3.84,15.78-4,5.49.65,5.49.65Z",
    style: {
      fill: "url(#ccf776c7-9399-4702-af0a-28f4c82d6d9f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.81,556.67s6.5,1.63,8.13,2.84.2,6.53,3.76,9.06,3.76,1.51,6.6,5,2.23,5.89,3.86,8.94,1.83,4.47,4.47,5.08,7.11,2.64,9.55,5.49c0,0-2-.41-1.63-3.25s-1.63-3-3-3.25-4.06,0-4.27-2.64a14.82,14.82,0,0,0-1-5.08c-.61-1.63-2.64-2-3.86-3.74s-1.22-3-1.83-4.79-3.75-2.84-4.92-3.66-2-.87-3-3.38,1.83-4.14-1.83-6.58S370.81,556.67,370.81,556.67Z",
    style: {
      fill: "url(#6f2516f3-5ac8-4a4c-af70-1000de7ed6cb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.7,629.14s-4-8.79-5.65-11.61-3.79-5.31-6.23-6.51-2.71-1.57-2.17-5.18,1.16-6.31-.23-8.21a15,15,0,0,1,4.47,6.88c1.19,4.22-.17,4.71,2.68,6.09a8.13,8.13,0,0,1,4.2,4.91c.54,1.35.2,5,2.95,5.73s4.55,2.4,3.92,4-1.29.75,0,3.87a12.54,12.54,0,0,0,4.64,5.13Z",
    style: {
      fill: "url(#02822717-174b-4a42-856b-90e0fa21d2e9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.22,495.38s10.54,1.63,14.88,4.34a45.1,45.1,0,0,0-6.64,0c-1.63.19-3.66,3.63-4.74,2.7s-4.33-1-4.74.18-3.32,1.06-5,.78-3.67,2.43-3.67,2.43A76.28,76.28,0,0,1,361.22,495.38Z",
    style: {
      fill: "url(#ce6a97ef-ba8e-46a7-b60c-1e663a977bf4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.57,428.07s3.93-2.57,6.64-2.3,5,1.18,5.55,0,2.3-1.73,3.79-1.67,2.17.87,4.47,0a2.93,2.93,0,0,1-2-1.56c-.95-1.49-1.49-3.66-3.79-3.66a3.21,3.21,0,0,1-3-2.11s-3.59,4.06-5.1,5.66S346.57,428.07,346.57,428.07Z",
    style: {
      fill: "url(#9eb49f1a-2019-47c9-9156-7ff239c1b409)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.05,570.21s3.72-.61,7-1.53a2.69,2.69,0,0,1,2.36.42c.43.34.66.74.05,1.11-1.35.82-3.4.28-4.54.82s-1.37,2.64-4.91,2.64-4.43-.07-6.19.54a12.31,12.31,0,0,1-4.75.11S361,570.58,363.05,570.21Z",
    style: {
      fill: "url(#34e5f752-766b-44ef-999a-e682dd6ebfc5)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M389,401.48S368.91,515.64,253.3,522.82",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 6,
      stroke: "url(#38edea67-d63f-4e12-9d11-eb2fe98c6f53)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.77,370s-5,113.83-94.42,149.9c-108.54,43.79-230.43-37.3-230.43-37.3",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 6,
      stroke: "url(#d7df31fb-3557-4902-84b8-35cc3c51647d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.22,324.67s28.61,24.93,62.48,13.59,55-57.25,57.57-84.55",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 6,
      stroke: "url(#855fece1-fad3-4037-ab91-7c93acc3c7ea)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.31,163c-47.13,119.46-172.55,72.8-172.55,72.8l-38.6-14.56",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 6,
      stroke: "url(#8b6ca878-7adc-466a-8741-bde500a7009e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.23,260.66s17.19,72,86.27,75.43,116.21-57.15,120.68-107.94,4.06-95.48,4.06-95.48",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 6,
      stroke: "url(#9a06ae5e-f249-454d-bfaf-00cc8a77a4a3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.54,160.46c-1.9-7,1.09-12.54,0-20.59-2.18-16.05-37-12.32-50.56-23.24-23.16-18.69-70.87-12.8-75.76.9a13.58,13.58,0,0,0-14-5.73c-.28.06-32.65,14.54-32.65,14.54a25.29,25.29,0,0,0-17.62,18.15l-2,7.85L674.79,150a14.65,14.65,0,0,0-12.12-1.06,51.56,51.56,0,0,1-8.92,2.23l-3.27.53c-6.31,1-10.77,6.27-11.61,12.6-.78,5.88-7.62,14.13-14.63,17a35.23,35.23,0,0,0-14.15,9.9c-8.36-2.53-19.36-1-29.59,9.09-5.39,5.3-15.68,8.3-21.39,6.68-6.15-1.75-12.72.26-16.18,5.64l-1.79,2.78a51.58,51.58,0,0,1-5.59,7.3,14.65,14.65,0,0,0-3.85,11.54l.56,5.28a27.3,27.3,0,0,0-11.63.41,93.37,93.37,0,0,1-12.25,2.26l-4.48.54c-8.66,1.05-15.51,6.26-16,12.64,0,0,0,.11,0,.27a14.63,14.63,0,0,0-4.09-1.1,51.55,51.55,0,0,1-9-1.91l-3.17-1c-6.12-1.84-12.43.9-16,6.23-3.28,4.94-13.05,9.35-20.6,8.82-27-1.89-36.48,21.06-30.07,31.35.17.27.35.54.53.8l-.4-.12c-6.22-2-13.19-3.48-16.11-1.45-1.8,1.25-2.75,4.82-3.22,8.79a30.21,30.21,0,0,1-15.52,22.77l-11.42,6.29c-21.14,11.65-24.74,41-6.51,56.82,6.44,5.59,15,9.69,26.24,10.47,42.45,3,50.8,28.13,58.39,30.44s14.52-6.7,20.59-4.8,14,12.36,24.33,12.44,21.72-15.18,15.76-22.45l26.22-15.14,5.78,3.34a14.65,14.65,0,0,0,12.11,1.16,51.57,51.57,0,0,1,8.94-2.15l3.27-.51a13.7,13.7,0,0,0,11.71-12.5c0-.11-.72-5.24-1.63-11.57a13.58,13.58,0,0,0,14,5.84c.28-.06,32.77-14.26,32.77-14.26a25.29,25.29,0,0,0,17.77-18l2-7.83,4.14,2.39a14.65,14.65,0,0,0,12.11,1.16,51.57,51.57,0,0,1,8.94-2.15l3.27-.51c6.32-1,10.82-6.18,11.71-12.5.83-5.87,7.74-14.06,14.78-16.84a35.23,35.23,0,0,0,14.24-9.78c8.34,2.6,19.35,1.13,29.66-8.84,5.43-5.26,15.75-8.17,21.44-6.5,6.13,1.8,12.73-.15,16.23-5.5l1.81-2.77a51.58,51.58,0,0,1,5.65-7.25,14.65,14.65,0,0,0,3.94-11.5l-.52-5.28a27.3,27.3,0,0,0,11.63-.31A93.37,93.37,0,0,1,802,258l4.49-.51c8.67-1,15.56-6.13,16.08-12.5,0-.1,16.66-4.56,15.51-10.37,0,0,21.94-11.38,27.45-15.43.33-.24,4.9-2.65,10.08-15.62a48.13,48.13,0,0,0,2.71-8.75C883.73,167.23,873.44,167.5,871.54,160.46Z",
    style: {
      fill: "url(#a89c03ea-4b58-48e1-bf03-cc13c3bf3682)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M446.31,311.87c7.39-2.44,4.23-3.61,15.56-4.24s24,4.09,29,5.71,8.59-1.83,19.76-1,19-2.64,22.14-2.64c4.93,0,11.26,4,15.39,5.74,3.11,1.29,8.76-1.05,11,1.45,1.25,1.38,3.81,2.91,9.09,3.52,10.56,1.23,15-1.93,22.35-.7s31.92,4.7,28.37,9.83c-10.7,15.46,10.68-.61,11.68,16.87L629,352.76s-1.95-.8-3.44-6.63-3-5.42-6.57-6-4.67,4.6-6.84-3.39,1.66-7.86-1.95-8.67-2.66-1.73-8.21-2.54-3.3,2.27-9.57.24-10.34-4.6-14.67-1.35-5.15,3.25-8,1.49.95-2.17-4.33-2.71-6.37.54-9.48-.68-3.25-2.17-7.31-4.6-13.27-.54-23.57-2.44-8.13-.27-15.3.14-12.73,6.91-19.1,3.25-4.47-5.82-12.05-6.23-8,.54-13.68-.68-16.12,1.63-16.12,1.63Z",
    style: {
      fill: "url(#06158f64-4c2b-4048-ba8c-e0a5c55a4d44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.86,308.15s7-10,7.08-12.85-3.28-12.48-1.32-18.49-2.09-10.08-2-12.39c.05-2,10.14-10.63,6.09-14.19a79.64,79.64,0,0,0-7.38-4.2,48,48,0,0,1-11.31-6.9,20.52,20.52,0,0,0-5.18-3c-5-2-14.5-6.66-14.31-12.26.05-1.53-1.5-13.68,4.73-19.5.87-.81-2.17-6.81-1.22-6.64,10.16,1.9,1.61,15.24,1.61,15.24s-5.43,8.73,0,11.44,5.63,8,10.58,10,10.7-.69,14.15,4.88,12.53,3,10.23,8.8c-.66,1.65,7.84,2.5,3.24,7s-9.63,8.33-5.34,11.58,9.35,5.31,6.09,7-6.43,2.17-7.52,7.58,3.25,5.52,2.71,12-2.29,16-2.29,16a14,14,0,0,1-3.73,0l-5.55,3.09Z",
    style: {
      fill: "url(#7eb4d5bf-5f69-4f86-b118-5ea4c09e1e55)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.27,239.46s24.41-4.77,25.75-1.7,1.73,9.17,13.72,9.17,12.6-2.15,18.39-1.69c4.15.33,13.43,0,17.92.39a5.69,5.69,0,0,1,4.43,2.79L619,261.91s2.36,6,0,10.72c0,0,4.68-6.82,3.19-9.39s-2.84-3.93-4.06-6.09-1.63-2.57-3-7.86S612,243.06,609,243.2s-10.43,1.35-12.87.27-3.93-2.17-10-2-6.37,3.12-9.62,3.52-7.86-1.49-9.48-2-4.33-.95-4.88-2.3-1.08-6.37-3.39-7-7.31-.81-8.94.14-3,3.12-5.69,2.44-1.2-1.49-5.68-1.63-6.22.81-6.22.81Z",
    style: {
      fill: "url(#16b62e6b-7bef-4951-a433-0bc80b581041)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.87,177c5.15,3,9.48,2.92,12.46,3.09s4.33,1,5.69,3.14,7.44,6,12,6,7.25,1.35,7.79,3.52-.27,6,1.08,8.13,4.88,0,4.88,0-2.86,0-3.4-2.2a33.91,33.91,0,0,1-.41-6.91c0-.81,1-3.35-3-5s-5.6-1-9.4-.71-5-1.46-6.28-3.89,2.49-1.54-1.85-4-6.57-3-9.24-2.17-4.3.46-6.2.46A19.77,19.77,0,0,0,721.87,177Z",
    style: {
      fill: "url(#ea463362-6315-4f0b-8b22-fcd35f2b4b7d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.08,234.67s2.44-.81,4.74-8.4,1.32-12,3.71-13.34,3.88-2.1,4.29-6.57.68-4.46,0-6.56.81-1.84,3.12-5.09,2.84-3,2.84-5,1.76,2.71,0,5.55-2.17.68-2.71,4.74-.68,4.47-.54,5.28a5.83,5.83,0,0,1-1.22,3.12,8.32,8.32,0,0,0-1.08,4.54c.14,1.82-1.66.06-3.4,2.64s-2.15,3.79-2.15,5.55a39.39,39.39,0,0,0,.14,4.06c.14,1.63-.6.54-1.45,3.25a24.45,24.45,0,0,1-2.26,5l-4,2.41Z",
    style: {
      fill: "url(#5e4d8a4d-91d6-414d-a182-3b60a202ffcd)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.32,217.6c2.38-8.4,5.63-10,6.72-13.54s2.71-3.8,1.08-6.37-6,.68-1.9-4.74,7.72-1.68,9.14-12.9,4.27-8.5,0-15-3.45-13.81-10.5-15.44S828,148.8,821,148s-12.85-3.25-13.18-6,8.71.14-1-5.55-6.8-8.4-20.48-8.19A74.6,74.6,0,0,1,769,126.59s10-1.35,13.81-1.35a50,50,0,0,1,10.56,1.08c4.33.81,7.31-1.08,8.4,1.9s4.6,4.88,8.94,6.23,4.6,4.06,3.52,5.69-5.15,2.44-1.9,3.79a23.66,23.66,0,0,0,8.64,1.9c2.2,0,3-1.35,4.64.27s4.06,1.63,6.5,3,5.83,1.35,5.62,5.15.38,4.88,2.25,6.23a9.48,9.48,0,0,1,4.35,7.31c.23,3.79.5,8.61-1.67,12.3s-6,9.92-4.6,11.54-3.52,2.44-3.52,3.52a29.26,29.26,0,0,0,1.08,5.15c.54,2.17-2.17,1.08-3.25,6S824.32,217.6,824.32,217.6Z",
    style: {
      fill: "url(#be55035d-f33a-4916-b5f9-303719efc641)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.83,354.12s1,6.7,5.89,7.31,4.51,2.65,6.11,3.36-.75,1.48,4.08,1.91,4.41,2,8.65,3.31,8,2,9.77,3.16,7,5.58,7.38,5.88-.25-1.66-2.58-4.3-1.19-2.71-3.62-4.33-3-1.73-4.88-1.52-3.35,0-4.16-1,.71-1.63-1.93-1.63-1.93.77-4.27-.63S389.44,363.3,388,363s-1.42.71-2.64-.2-1.12-2.23-2.64-2.84a18.93,18.93,0,0,0-4.16-1.52C377.15,358.22,373.45,357.17,371.83,354.12Z",
    style: {
      fill: "url(#c2c99808-cdd3-419e-bb97-4e46c835e35f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.61,298.81s.82,1.27,7.05,2.76,6.23,1.08,10.84,1.35,4.74,1.63,7,2.71a15.65,15.65,0,0,0,6.77,1.22c2,0-5.82-2.63-6.77-4s-.14-2.61-4.6-3.16-3.66.14-6.91-.27-1.61.68-5.21-1.49-3.33-2.71-5-2.3a28.68,28.68,0,0,1-4.74.46Z",
    style: {
      fill: "url(#22218155-b59b-4ffc-9112-25ee55d2725a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.09,191.16s5.59,2.27,8.91,1.86,5.76-2.14,6.27,0-.61,2.69,1.83,2.19a13.66,13.66,0,0,1,4.67-.41c1.52.1,1.63,1.73,4.27,0s.61-1.78-1.52-1.45-3.86.48-4.88,0,1.32-.08-1.93-1.29-2.83-.67-5.23-.94-6.66-.07-7.67-.88a6.65,6.65,0,0,0-3.07-.93Z",
    style: {
      fill: "url(#ae6183a1-afd2-4967-8e26-22201f83dd57)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M468.65,399.36s3.88-8.9,5.37-12.73c2-5.24,7.58-.93,9.48-2.71s5.69-4.88,8.67-4.88,7.15,4.06,8.18,1.9c0,0-1.41,4.84-4.12,3.66s-2-3.27-4.64-3.2-3.51,3.87-5.11,5.1-3.77.4-7.58,1.63S476,398.14,468.65,399.36Z",
    style: {
      fill: "url(#da352464-0b08-468b-ae62-8d8dc2de83eb)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M449.22,646.45A26.31,26.31,0,0,1,466.93,630c9.17-2.44,7.18-.2,13.4-2.79s19.89-10.08,27.92-8.06,13.31,9.81,18.34,14,7.81,6.67,11.41,4.9c18.69-9.23,39.95,19.94,37.3,28.67-2.35,7.73-1.34,11.54,3.68,13.94s14.92-1.41,18,11.13.9,27.71,11,29.16,25.14,15.32,25.28,21.6-2.3,10.63-1.74,21.05c.63,11.69-19.36,26.1-42.8,25.84-42.06-.46-66.34-5.81-71.51-11.83s-2.78-10.28-11.06-10.53-21,2.32-31.27-5.74c-5.42-4.25-10-25.85-11.29-36.21s5.59-14.24-.25-17.83c-4.66-2.87-16-7.58-16.17-18.38S446.67,653.32,449.22,646.45Z",
    style: {
      fill: "url(#2e1dc1ee-7b4c-4a02-a714-5bc41feabdcd)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.68,710.21a27.14,27.14,0,0,0,1.73-11.4c-.47-6.23-3.2-7,.06-11.91a57.66,57.66,0,0,0,5.16-8.67c1.63-3.25,1.35-6,1.9-9.21s.32-4.88,5.31-7,2,6.23,10.4-3.79,5.69-10,8.4-11.92-5.42-4.06-7,0,1.63,3.52-3.79,7-4.88,3.52-6.77,4.06-4.88-1.63-6.77,2.71-1.35,6.77-3.79,8.4-5.24,8.4-4.79,10.84.8,6,0,7.59-2.48,1.08-1.94,4.6-1.7,15-1.7,15Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#4dc256a3-9952-448a-9ac7-4b6581fe7bb0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579,680.6a48.86,48.86,0,0,0-11.53,0c-4.88.81-7.11,3.66-7.31,4.27s-11.45,5.49-14.66,6.3-7.57,0-8.85,3-5.75,9.83-8.39,9.89-1.63-2.38,0-3.8,1.83-1.63,3.45-4.47,1.91-6.7,6.44-7.52,6.77-.41,8.39-3.25,7.11-6.91,10.56-6.91,5.35-.61,6.43,0,3.11.47,5.55-.27,5-4.8,5-4.8S575.25,680,579,680.6Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#aae4e39d-e885-45f2-880d-2b65f5c3b46f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.28,767.61s-3-1.35-.95-6.77,2.57-5.55,2.57-8.4-2.44-1.63,0-4.74,1.49-3.79,4.47-4.33,3.79.68,3.25,1.08-2.71,1.35-2.84,3.52a17,17,0,0,0,.14,4.74c.27,1.22-2.58,3.39-2.71,3.66s-2.43,1.22-1.89,3.25,3,6,3,6.5-2.33,4.23-2.33,4.23S511.32,767.8,510.28,767.61Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#726bd4ac-4e51-4f68-9884-1446985ee0c6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.38,722.37c-6.09-.27-10.56,0-11.78,1.76s-3.12,3.93-4.41,4.47-1.69-1.9-4,1.08-3.25,7.31-3.79,9.75-4.88,5.82-6,6.5-1.35,3.25-1.35,4.06.41-.14,2.44-1.35,3.25-2,5.55-2.3,3.39,1.49,3.39-3.12-1.76-5.28.68-6.36.95-3,4.47-3.52,2.84.41,5-3.12,2.84-4.47,2.84-4.47-1.63-.81,3-.41S589.38,722.37,589.38,722.37Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#afa62112-4ab1-446c-b0ca-7e19a44cef1f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484,698.94c4.6,5.42,4.2,5.55,3.39,8.4s-1.35,4.33-.81,5.69-.85.41-.63,4.47.83,4.74,1.95,7.18,0,1.22.85-1.63,1.22-.81,1.35-3.93-.54-3.25-.54-5.42-.14-1.22,1.76-4.6,4.33-4.88,1.35-8.4-1.08-4.47-4.6-4.2S484,698.94,484,698.94Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#b87bda48-e2e7-49cb-8685-d115afec8197)"
    }
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(Svg404Hero);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dist/static/media/404-hero.23916a6ffbb8698cb338facf3febe4a9.svg";